<template>
    <div>
        <yetkidialog ref="yetkidialog"></yetkidialog>
        <onaydialog ref="onaydialog"></onaydialog>
        <onaydialogchk ref="onaydialogchk"></onaydialogchk>
        <paxdriveeditdialog ref="paxdriveeditdialog"></paxdriveeditdialog>
        <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
        <tahsilatdialog ref="tahsilatdialog" v-model="kalemData"></tahsilatdialog>
        <kisiadresara v-model="adresDialogData"></kisiadresara>
        <hatadialog ref="hatadialog"></hatadialog>
        <profildialog ref="profildialog"></profildialog>
        <musteripersoneldialog ref="musteripersoneldialog"></musteripersoneldialog>
       
        <snackbarcomp v-bind:mesaj="text1" ref="showMessage" v-model="snackbar"></snackbarcomp>
    
        <v-card color="grey lighten-5">
            <v-layout row wrap>
                <v-flex xs12 sm12>
                    <v-toolbar size="120px" dark color="info">
                        <v-toolbar-title> {{sayfabaslik}}</v-toolbar-title>
                        <v-spacer></v-spacer>
    
    
                        <v-menu offset-y>
                            <v-btn slot="activator" dark icon>
                                <v-icon>more_vert</v-icon>
                            </v-btn>
                            <v-list>
    
                                <v-tooltip bottom>
                                    <v-list-tile v-if="guncellebuton" slot="activator" @click="pnrIptalDialog()">
                                        <v-list-tile-title>Takip No İptal</v-list-tile-title>
                                    </v-list-tile>
                                    <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Delete">Takip No İptal</span>
                                </v-tooltip>
    
    
                                <a target="_self" v-bind:href="'#/faturalar/faturalistesi'">
                                    <v-list-tile>
                                        <v-list-tile-title>{{ $t('Leave') }}</v-list-tile-title>
                                    </v-list-tile>
                                </a>
                            </v-list>
                        </v-menu>
    
                    </v-toolbar>
                </v-flex>
    
                <v-layout row wrap>
    
                    <v-flex sm12 md12>
                        <v-card>
                            <v-list two-line>
                                <v-layout row wrap>
    
                                    <v-flex xs12 sm3 md3>
                                        <v-layout align-center justify-start row fill-height>
                                            <v-card flat="">
                                                <v-list-tile>
                                                    <v-list-tile-content>
                                                        <v-layout row align-start wrap justify-start>
                                                            <v-flex xs12 sm12 md12>
                                                                <div class="font-weight-bold grey--text subheading ">
                                                                    <v-chip small color="orange darken-4" text-color="white"> {{ $t('No') }} :
                                                                        {{kalemData.Rez.takipNo}}</v-chip>
                                                                </div>
                                                            </v-flex>
                                                            <v-flex xs12 sm12 md12>
                                                                <div class="font-weight-   grey--text body-1 ">
                                                                   
                                                                    <!-- {{kalemData.Rez.cariKod.kod}} -->
                                                                    <!-- -{{kalemData.Rez.cariKod.isim}} -->
                                                                </div>
                                                                <div class="font-weight- grey--text body-1 ">
                                                                </div>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-list-tile-content>
                                                </v-list-tile>
                                            </v-card>
                                        </v-layout>
                                    </v-flex>
    
                                    <v-flex sm12 md1 sm1>
                                        <v-card flat="">
                                            <v-list-tile>
    
                                            </v-list-tile>
                                        </v-card>
                                    </v-flex>
    
                                    <v-flex xs12 sm6 md6>
                                        <v-layout align-center justify-start row fill-height>
                                            <v-card flat="">
                                                <v-list-tile>
                                                    <v-list-tile-content>
                                                        <v-layout row align-start wrap justify-start>
    
                                                            <v-flex xs12 sm12 md12>
                                                                <div class="font-weight subheading ">
                                                                    <v-icon hide-details color="red">
                                                                        check_box
                                                                    </v-icon>
                                                                     {{ $t('Invoice-not-Approved') }} 
                                                                </div>
                                                            </v-flex>
    
                                                            <v-flex xs12 sm12 md12>
                                                                <div v-if="item.FatTip==2" v-for="item in kalemData.Rez.FaturaBilgileri" :key="item.id" class="font-weight- grey--text subheading ">
                                                                    <span v-if="item.FatTip==2"> {{ $t('Sales-Invoice-No') }} :
                                                                    </span>
                                                                    {{item.FatNo}}
                                                                    <v-menu hide-details bottom left offset-y>
                                                                        <v-btn icon flat slot="activator">
                                                                            <v-icon>keyboard_arrow_down</v-icon>
                                                                        </v-btn>
                                                                        <v-list>
                                                                            <v-list-tile v-for="item in kalemData.Rez.FaturaBilgileri" :key="item.id">
                                                                                <v-list-tile-title>
                                                                                    {{item.FatTipStr}}:{{ item.FatNo }}
                                                                                </v-list-tile-title>
                                                                            </v-list-tile>
                                                                        </v-list>
                                                                    </v-menu>
                                                                </div>
                                                            </v-flex>
    
                                                        </v-layout>
                                                    </v-list-tile-content>
                                                </v-list-tile>
                                            </v-card>
                                        </v-layout>
                                    </v-flex>
    
                                    <v-flex xs12 sm2 md2>
                                        <v-layout justify-center="" align-center="" fill-height="">
                                            <v-layout justify-center="" column="" fill-height="">
                                                <v-flex xs12 sm12 md12>
                                                    <v-layout justify-center="">
                                                        <v-card flat="" class="white--text">
                                                            <v-card-actions class="pa-3">
                                                                <v-layout row wrap justify-center="">
                                                                    <v-flex xs12 sm12 md12>
                                                                        <v-layout justify-center="">
                                                                            <span class="headline red--text font-weight-">
                                                                                {{kalemData.Rez.toplamTL.netSatis | moneyformat}}
                                                                                ₺
                                                                            </span>
                                                                        </v-layout>
                                                                    </v-flex>
                                                                    <v-flex xs12 sm12 md12>
                                                                        <v-divider></v-divider>
                                                                    </v-flex>
                                                                    <v-flex pt-1 xs12 sm12 md12>
                                                                        <v-layout align-start fill-height justify-center="">
    
                                                                            <!-- <v-icon @click="tutarAyarla()"  color="green">exposure</v-icon> &nbsp; -->
    
                                                                            <span class="subheading grey--text ">
                                                                                {{$t('totalamount')}}
                                                                            </span>
    
                                                                        </v-layout>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-spacer></v-spacer>
                                                            </v-card-actions>
                                                        </v-card>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                        </v-layout>
                                    </v-flex>
    
                                </v-layout>
                            </v-list>
                        </v-card>
                    </v-flex>
    
                    <v-flex xs12 sm12 md12>
                        <v-flex xs12 sm12 md12>
                            <v-card flat class="white--text">
                                <v-card flat="">
                                    <v-card-actions>
                                        <v-layout row wrap>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm12 md12>
                                                    <v-stepper complete v-model="steppervmodel">
                                                        <v-stepper-header>
                                                            <v-stepper-step :complete="steppervmodel > 1" :step="step.onKayit">
                                                                 {{ $t('Pre-Registry-Details') }} 
                                                            </v-stepper-step>
    
                                                            <v-divider></v-divider>
                                                            <v-stepper-step :complete="steppervmodel > 2" :step="step.kisiBilgileri">
                                                                {{ $t('Personal-Information') }}
                                                            </v-stepper-step>
    
                                                            <v-divider></v-divider>
                                                            <v-stepper-step :complete="steppervmodel > 3" :step="step.rezKalemleri">
                                                                {{$t('Booking-Items')}}
                                                            </v-stepper-step>
    
                                                            <v-divider></v-divider>
                                                            <v-stepper-step :complete="steppervmodel > 4" :step="step.tahsilat">{{$t('Collection')}}
                                                            </v-stepper-step>
    
                                                            <v-divider></v-divider>
                                                            <v-stepper-step :step=step.dokumanlar>
                                                                {{ $t('Documents') }}
                                                            </v-stepper-step>
    
                                                        </v-stepper-header>
    
                                                        <v-stepper-items>
    
                                                            <v-stepper-content :step="step.onKayit">
                                                                <v-form ref="formOnKayit" v-model="valid" lazy-validation>
                                                                    <v-card flat color="grey lighten-5">
    
                                                                        <v-layout row="" wrap="">
                                                                            <v-flex pb-1 pt-1 xs12 sm6 md6>
                                                                                <v-layout row="" wrap="">
                                                                                    <v-flex xs12 sm12 md12>
                                                                                        <!-- <caricomp v-bind:autofocuss="true" :Coper="true" :v-bind:statecariyedek="statecari" @sendCurrentInfo="getCurrentInfo($event)" v-bind:zorunlumu="true" v-model="kalemData.Rez.cariKod.kod">
                                                                                        </caricomp> -->
                                                                                    </v-flex>
    
                                                                                    <v-flex xs12 sm12 md12>
                                                                                        <!-- <v-autocomplete
                             label="Acente :"
                             v-model="kalemData.Rez.acente"
                             
                              :items="this.saticiItems"
                              item-text="isim"
       item-value="isim"
       :disabled="this.disabledValue"
       return-object
    ></v-autocomplete> -->
                                                                                    <genelarama apiname="SaticiAra" :tip="4"
                                                                                    label="Acente"
                                                                                    v-model="kalemData.Rez.acente"></genelarama>
                                                                                    </v-flex>
    
                                                                                    <v-flex xs12 sm12 md12>
                                                                                        <v-text-field hide-details :label="$t('Person-Offering-Booking')" v-model="kalemData.Rez.rezVeren">
                                                                                        </v-text-field>
                                                                                    </v-flex>
                                                                                    <v-flex xs12 sm12 md12>
                                                                                        <genelarama apiname="MasrafMerkeziAra" :label="$t('Expense-Center-v2')" v-model="kalemData.Rez.masrafMerkezi">
                                                                                        </genelarama>
                                                                                    </v-flex>
                                                                                    <v-flex xs12 sm12 md12>
                                                                                    <referansmerkezicomp
                                                                                        v-model="kalemData.Rez.referansKod"
                                                                                        :etiket="$t('Reference-Centre')"
                                                                                        :coper="true"
                                                                                    >
                                                                                    </referansmerkezicomp>
                                                                                    </v-flex>
                                                                                    <v-flex xs12 sm12 md12>
                                                                                        <anatip v-model="kalemData.Rez.anaTip">
                                                                                        </anatip>
                                                                                    </v-flex>
                                                                                    <v-flex xs12 sm12 md12>
                                                                                        <tarihcomp :etiket="$t('Registration-Date')" v-bind:detaygizle="true" v-bind:defaultvalue="'yes'" v-bind:value="kalemData.Rez.kayitTarihi" v-model="kalemData.Rez.kayitTarihi">
                                                                                        </tarihcomp>
                                                                                    </v-flex>
                                                                                </v-layout>
                                                                            </v-flex>
    
                                                                            <v-flex xs12 sm6 md6>
    
                                                                                <v-layout row="" wrap="">
                                                                                    <v-flex xs12 sm12 md12>
                                                                                        <v-text-field hide-details :label="$t('Country_label')" v-model="kalemData.Rez.ulke">
                                                                                        </v-text-field>
                                                                                    </v-flex>
    
                                                                                    <v-flex xs12 sm12 md12>
                                                                                        <v-text-field hide-details :label="$t('Counter-Booking-Code')" v-model="kalemData.Rez.karsiRezKod">
                                                                                        </v-text-field>
                                                                                    </v-flex>
    
                                                                                    <v-flex xs12 sm12 md12>
                                                                                        <v-text-field hide-details :label="$t('Tour-Code')" v-model="kalemData.Rez.turKod">
                                                                                        </v-text-field>
                                                                                    </v-flex>
    
                                                                                    <v-flex xs12 sm12 md12>
                                                                                        <geneltipara tip="AcenteDepartman" v-model="kalemData.Rez.acenteDepartman">
                                                                                        </geneltipara>
                                                                                    </v-flex>
    
                                                                                    <v-flex xs12 sm12 md12>
                                                                                        <v-text-field hide-details :label="$t('Department-ServiceNo')" v-model="kalemData.Rez.hizmetNo">
                                                                                        </v-text-field>
                                                                                    </v-flex>
                                                                                    <v-flex xs12 sm12 md12>
                                                                                        <v-checkbox hide-details :label="$t('Optional-Client')" v-model="kalemData.Rez.opsiyonluMusteri">
                                                                                        </v-checkbox>
    
                                                                                    </v-flex>
                                                                                    <v-flex v-if="kalemData.Rez.opsiyonluMusteri" xs12 sm6 md6>
                                                                                        <tarihcomp :etiket="$t('Option-Date')" v-bind:detaygizle="true" v-bind:defaultvalue="'no'" v-bind:value="kalemData.Rez.opsiyonTarihi" v-model="kalemData.Rez.opsiyonTarihi">
                                                                                        </tarihcomp>
                                                                                    </v-flex>
    
                                                                                    <v-flex v-if="kalemData.Rez.opsiyonluMusteri" xs12 sm6 md6>
                                                                                        <v-menu ref="menuacilis" v-model="menuopsiyonsaat" :close-on-content-click="false" :nudge-right="40" :return-value.sync="kalemData.Rez.opsiyonSaati" transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                                                                                            <template v-slot:activator="{ on }">
                                                                                                <v-text-field hide-details v-model="kalemData.Rez.opsiyonSaati" :label="$t('Option-Time')" append-icon="access_time" v-on="on">
                                                                                                </v-text-field>
                                                                                            </template>
                                                                                            <v-time-picker v-if="menuopsiyonsaat" format="24hr" v-model="kalemData.Rez.opsiyonSaati" full-width @click:minute="$refs.menuacilis.save(kalemData.Rez.opsiyonSaati)">
                                                                                            </v-time-picker>
                                                                                        </v-menu>
    
                                                                                    </v-flex>
    
                                                                                    <v-flex xs12 sm12 md12>
                                                                                    <v-text-field label="Notlar" rows="2" v-model="kalemData.Rez.notlar" textarea></v-text-field>
                                                                                    </v-flex>
                                                                                    <v-flex xs12 sm12 md12>
                                                                                        <v-select :items="coperStatusItems" hide-details v-model="kalemData.Rez.Status" item-text="text" item-value="value" label="Statu">
                                                                                                            </v-select>
                                                                                    
                                                                                    </v-flex>
                                                                                </v-layout>
                                                                            </v-flex>
    
                                                                        </v-layout>
                                                                        <!--</v-container>-->
    
                                                                    </v-card>
                                                                </v-form>
                                                                <v-layout pt-2 justify-end row wrap>
    
                                                                    <v-tooltip bottom>
                                                                        <v-btn :disabled="!sayfayetki.Screen" outline flat color="primary" slot="activator" @click.native="SonrakiSayfa(step.onKayit)">
                                                                            <span class="hidden-sm-and-down">
                                                                                {{ $t('NEXT') }}
                                                                            </span>
                                                                            <v-icon small>navigate_next</v-icon>
                                                                        </v-btn>
                                                                        <span v-if="!sayfayetki.Screen">{{ $t('Limited-Authorization') }}</span>
                                                                        <span v-if="sayfayetki.Screen">{{ $t('NEXT') }}</span>
                                                                    </v-tooltip>
    
                                                                </v-layout>
    
                                                            </v-stepper-content>
    
                                                            <!--2 Kişi Bilgileri ****************************************************************************************-->
                                                            <v-stepper-content :step="step.kisiBilgileri">
                                                                <v-card flat color="grey lighten-5" class="mb-5">
    
                                                                    <v-layout v-if="steppervmodel==2" row="" wrap="">
    
                                                                        <v-flex pa-1 xs6 sm6 md6>
                                                                            <v-form ref="formkisiEkle" v-model="validkisiekle" lazy-validation>
    
                                                                                <v-flex pb-1 pt-1 xs12 sm12 md12>
                                                                                    <v-layout row="" wrap="">
    
                                                                                        <v-flex xs12 pa-2 sm12 md12>
    
                                                                                            <v-layout row wrap>
    
                                                                                                <v-flex xs11 sm11 md11>
                                                                                                    <v-icon medium="" color="red">
                                                                                                        person</v-icon>
                                                                                                    &nbsp;
                                                                                                    <span class=" font-weight-regular grey--text title">
                                                                                                        {{ $t('Personal-Information') }}
                                                                                                    </span>
                                                                                                    <v-divider>
                                                                                                    </v-divider>
                                                                                                </v-flex>
    
                                                                                                <v-flex xs1 sm1 md1>
                                                                                                    <v-layout justify-end>
                                                                                                        <v-btn @click="kisiAra()" icon color="red">
                                                                                                            <v-icon small color="white">
                                                                                                                search
                                                                                                            </v-icon>
                                                                                                        </v-btn>
                                                                                                    </v-layout>
                                                                                                </v-flex>
    
                                                                                            </v-layout>
    
                                                                                        </v-flex>
    
                                                                                        <v-flex pb-1 pt-1 xs6 sm6 md6>
                                                                                            <v-layout row="" wrap="">
    
                                                                                                <!-- <v-flex xs12 sm12 md12>
                                                    <pnraracomp hide-details v-model="Rez.pNR_No" v-on:kodonchange="pnrchange">
                                                    </pnraracomp>
                                                  </v-flex> -->
                                                                                                <v-flex xs12 sm12 md12>
                                                                                                    <kisitip :autofocuss="true" :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="Adres.kisiTip">
                                                                                                    </kisitip>
                                                                                                </v-flex>
                                                                                                <!-- <v-flex xs12 sm12 md12>
                                                    <v-text-field hide-details label="Yaş" v-model="Adres.yas">
                                                    </v-text-field>
                                                  </v-flex> -->
                                                                                                <v-flex xs12 sm12 md12>
                                                                                                    <v-text-field mask="###########" @change="tckisiGetir()" hide-details :label="$t('Identitynumber_label')" v-model="Adres.tcKimlikNo">
                                                                                                    </v-text-field>
                                                                                                </v-flex>
                                                                                                <!-- <v-flex xs12 sm12 md12>
                                                    <v-text-field hide-details :label="$t('Member-No')" v-model="Adres.uyeNo">
                                                    </v-text-field>
                                                  </v-flex> -->
    
                                                                                                <v-flex xs12 sm12 md6>
                                                                                                    <v-text-field hide-details :rules="passwordRules" :label="$t('Name_label') + '(max 50)'" v-model="Adres.firstName">
                                                                                                    </v-text-field>
                                                                                                </v-flex>
    
                                                                                                <v-flex xs12 sm12 md6>
                                                                                                    <v-text-field hide-details :label="$t('Surname_label') + '(max 50)'" v-model="Adres.lastName">
                                                                                                    </v-text-field>
                                                                                                </v-flex>
    
                                                                                                <v-flex v-if="false" xs12 sm12 md6>
                                                                                                    <v-text-field hide-details :label="$t('Name_Surname_label') +  '(max 50)'" v-model="Adres.adSoyad">
                                                                                                    </v-text-field>
                                                                                                </v-flex>
    
                                                                                                <v-flex xs12 sm12 md12>
    
                                                                                                    <v-textarea hide-details :label="$t('Address_label')" v-model="Adres.adres">
                                                                                                    </v-textarea>
                                                                                                </v-flex>
                                                                                            </v-layout>
                                                                                        </v-flex>
    
                                                                                        <v-flex pb-1 pt-1 xs6 sm6 md6>
                                                                                            <v-layout row="" wrap="">
    
                                                                                                <v-flex pb-1 pt-1 xs12 sm12 md12>
                                                                                                    <v-layout row="" wrap="">
                                                                                                        <v-flex xs12 sm12 md12>
                                                                                                            <tarihcomp :etiket="$t('Date-of-Birth')" v-bind:detaygizle="true" v-bind:defaultvalue="'yes'" v-bind:value="Adres.dogumTarihi" v-model="Adres.dogumTarihi">
                                                                                                            </tarihcomp>
    
                                                                                                        </v-flex>
                                                                                                        <v-flex xs12 sm12 md12>
                                                                                                            <v-select :items="cinsiyetitems" hide-details v-model="Adres.cinsiyet" item-text="text" item-value="value" :label="$t('Sex')">
                                                                                                            </v-select>
    
                                                                                                        </v-flex>
                                                                                                        <v-flex xs12 sm12 md12>
                                                                                                            <v-text-field hide-details :label="$t('Telephone')" v-model="Adres.telefon1">
                                                                                                            </v-text-field>
                                                                                                        </v-flex>
                                                                                                        <v-flex xs12 sm12 md12>
                                                                                                            <v-text-field hide-details :label="$t('Mobilphonenumber_label')" v-model="Adres.gsm">
                                                                                                            </v-text-field>
                                                                                                        </v-flex>
                                                                                                        <v-flex xs12 sm12 md12>
                                                                                                            <v-text-field hide-details :label="$t('Email_label')" v-model="Adres.eMail">
                                                                                                            </v-text-field>
                                                                                                        </v-flex>
                                                                                                        <v-flex xs12 sm12 md12>
                                                                                                            <v-layout pt-2 justify-end row wrap>
                                                                                                                <!-- <v-btn flat color="primary" @click.native="YeniPNR()">Yeni Kayıt</v-btn> -->
                                                                                                                <v-btn flat color="primary" @click.native="KisiEkle()">
                                                                                                                {{$t('Add-to-Persons')}}
                                                                                                                </v-btn>
    
                                                                                                            </v-layout>
                                                                                                        </v-flex>
                                                                                                    </v-layout>
                                                                                                </v-flex>
                                                                                            </v-layout>
                                                                                        </v-flex>
    
                                                                                    </v-layout>
                                                                                </v-flex>
                                                                            </v-form>
    
                                                                        </v-flex>
    
                                                                        <v-flex xs12 pa-1 sm12 md6>
                                                                            <v-card color="grey lighten-5" flat>
                                                                                <v-layout row wrap>
                                                                                    <v-flex xs12 pa-2 sm12 md12>
                                                                                        <v-icon medium="" color="grey">
                                                                                            view_headline</v-icon>
                                                                                        &nbsp;
                                                                                        <span class=" font-weight-regular grey--text title">
                                                                                            {{$t('Persons-Added-to-Booking')}}
                                                                                        </span>
                                                                                        <v-divider></v-divider>
                                                                                    </v-flex>
    
                                                                                    <v-flex xs12 sm12 md12>
                                                                                        <v-layout row wrap>
    
                                                                                            <v-flex v-if="kalemData.Rez.adresler.length==0" pa-2 xs12 sm12 md12>
                                                                                                <v-card flat="">
                                                                                                    <v-layout row wrap>
                                                                                                        <v-flex xs12 sm12 md12>
                                                                                                            <v-card-actions>
                                                                                                                <v-layout row wrap>
                                                                                                                    <v-flex xs12 sm12 md12>
                                                                                                                        <v-layout align-center="" justify-start="" fill-height="">
                                                                                                                            <v-icon color="red">
                                                                                                                                person
                                                                                                                            </v-icon>
                                                                                                                            &nbsp;
                                                                                                                            <span class="body-2 black--text font-weight-regular">
                                                                                                                                {{ $t('You-have-not-yet-added-person') }}
                                                                                                                            </span>
                                                                                                                        </v-layout>
                                                                                                                    </v-flex>
                                                                                                                </v-layout>
                                                                                                            </v-card-actions>
    
                                                                                                        </v-flex>
                                                                                                    </v-layout>
    
                                                                                                </v-card>
                                                                                            </v-flex>
    
                                                                                            <v-flex pa-2 v-for="item in kalemData.Rez.adresler" v-bind:key="item.id" xs12 sm12 md12>
                                                                                                <v-card flat="">
                                                                                                    <v-layout row wrap>
                                                                                                        <v-flex xs12 sm12 md12>
                                                                                                            <v-card-actions>
                                                                                                                <v-layout row wrap>
                                                                                                                    <v-flex xs6 sm4 md4>
                                                                                                                        <v-layout align-center="" justify-start="" fill-height="">
                                                                                                                            <v-icon color="red">
                                                                                                                                person
                                                                                                                            </v-icon>
                                                                                                                            &nbsp;
                                                                                                                            <span class="body-2 black--text font-weight-regular">
                                                                                                                                {{KisiTipToStr(item.kisiTip)}}
                                                                                                                            </span>
                                                                                                                        </v-layout>
                                                                                                                    </v-flex>
    
                                                                                                                    <v-flex xs6 sm2 md4>
                                                                                                                        <v-layout align-center="" justify-start="" fill-height="">
                                                                                                                            <span class="body-2 black--text font-weight-regular">
                                                                                                                                {{item.adSoyad}}
                                                                                                                            </span>
                                                                                                                        </v-layout>
                                                                                                                    </v-flex>
    
                                                                                                                    <v-flex xs12 sm2 md2>
                                                                                                                        <v-layout align-start="" justify-start fill-height>
                                                                                                                            <v-card flat="">
                                                                                                                                <v-list-tile>
                                                                                                                                    <v-list-tile-content>
                                                                                                                                        <v-list-tile-sub-title>
                                                                                                                                            <div class="font-weight grey--text caption ">
                                                                                                                                                <v-icon small color="grey">
                                                                                                                                                    fingerprint
                                                                                                                                                </v-icon>
                                                                                                                                                &nbsp; {{ $t('Identitynumber_label') }}
                                                                                                                                            </div>
                                                                                                                                        </v-list-tile-sub-title>
                                                                                                                                        <v-list-tile-sub-title>
                                                                                                                                            <div class="font-weight green--text body-2 ">
                                                                                                                                                {{item.tcKimlikNo}}
                                                                                                                                            </div>
                                                                                                                                        </v-list-tile-sub-title>
                                                                                                                                    </v-list-tile-content>
                                                                                                                                </v-list-tile>
                                                                                                                            </v-card>
                                                                                                                        </v-layout>
    
                                                                                                                    </v-flex>
    
                                                                                                                    <v-flex sm2 md2 xs2>
                                                                                                                        <v-layout justify-end align-center>
    
                                                                                                                            <v-menu color="info" offset-y>
                                                                                                                                <v-btn slot="activator" dark icon>
                                                                                                                                    <v-icon color="grey">
                                                                                                                                        more_vert
                                                                                                                                    </v-icon>
                                                                                                                                </v-btn>
                                                                                                                                <v-list>
    
                                                                                                                                    <v-list-tile @click="kisiSil(item)">
                                                                                                                                        <v-list-tile-title>
                                                                                                                                            {{ $t('Delete') }} 
                                                                                                                                        </v-list-tile-title>
                                                                                                                                    </v-list-tile>
    
                                                                                                                                    <v-list-tile @click="profil(item)">
                                                                                                                                        <v-list-tile-title>
                                                                                                                                            {{ $t('Profile') }}
                                                                                                                                        </v-list-tile-title>
                                                                                                                                    </v-list-tile>
                                                                                                                                    
                                                                                                                                    <v-list-tile @click="musteripersonel(item)">
                                                                                                                                        <v-list-tile-title>
                                                                                                                                            Sicil Bilgisi
                                                                                                                                        </v-list-tile-title>
                                                                                                                                    </v-list-tile>
                                                                                               
    
                                                                                                                                </v-list>
                                                                                                                            </v-menu>
                                                                                                                        </v-layout>
                                                                                                                    </v-flex>
    
                                                                                                                </v-layout>
                                                                                                            </v-card-actions>
    
                                                                                                        </v-flex>
                                                                                                    </v-layout>
    
                                                                                                </v-card>
                                                                                            </v-flex>
                                                                                        </v-layout>
    
                                                                                    </v-flex>
    
                                                                                </v-layout>
                                                                            </v-card>
                                                                        </v-flex>
    
                                                                        <!-- End Data Table *************************************************************************************** -->
    
                                                                    </v-layout>
    
                                                                </v-card>
                                                                <v-layout row wrap>
                                                                    <v-flex sm6 md6 xs6>
                                                                        <v-layout pt-2 justify-start row wrap>
    
                                                                            <v-tooltip bottom>
                                                                                <v-btn :disabled="!sayfayetki.Screen" outline flat color="primary" slot="activator" @click.native="OncekiSayfa(step.kisiBilgileri)">
                                                                                    <span class="hidden-sm-and-down">
                                                                                    </span>
                                                                                    <v-icon small>keyboard_arrow_left
                                                                                    </v-icon> {{ $t('BACK') }}
                                                                                </v-btn>
                                                                                <span v-if="!sayfayetki.Screen"> {{ $t('Limited-Authorization') }} </span>
                                                                                <span v-if="sayfayetki.Screen">{{ $t('BACK') }}</span>
                                                                            </v-tooltip>
    
                                                                        </v-layout>
                                                                    </v-flex>
                                                                    <v-flex sm6 md6 xs6>
                                                                        <v-layout pt-2 justify-end row wrap>
    
                                                                            <v-tooltip bottom>
                                                                                <v-btn :disabled="!sayfayetki.Screen" outline flat color="primary" slot="activator" @click.native="SonrakiSayfa(step.kisiBilgileri)">
                                                                                    <span class="hidden-sm-and-down">
                                                                                        {{ $t('NEXT') }}
                                                                                    </span>
                                                                                    <v-icon small>navigate_next</v-icon>
                                                                                </v-btn>
                                                                                <span v-if="!sayfayetki.Screen"> {{ $t('Limited-Authorization') }} </span>
                                                                                <span v-if="sayfayetki.Screen">{{ $t('NEXT') }}</span>
                                                                            </v-tooltip>
    
                                                                        </v-layout>
                                                                    </v-flex>
    
                                                                </v-layout>
    
                                                            </v-stepper-content>
    
                                                            <!--3 Rez Kalemleri ****************************************************************************************-->
                                                            <v-stepper-content height="100%" :step="step.rezKalemleri">
                                                                <v-card min-height="500" height="100%" flat color="grey lighten-4">
    
                                                                    <v-layout v-if="steppervmodel==3">
    
                                                                        <v-layout pa-2 v-if="minrezlist" row wrap>
    
                                                                            <v-flex xs9 pa-2 sm9 md9>
                                                                                <v-card flat>
                                                                                    <v-layout row wrap>
                                                                                        <v-flex xs12 pl-1 sm12 md12>
                                                                                            <v-icon color="grey">
                                                                                                {{rezicon}}</v-icon>
                                                                                            &nbsp;
                                                                                            <span class=" font-weight-regular grey--text subheading">{{rezbaslik}}</span>
                                                                                            <v-divider></v-divider>
                                                                                        </v-flex>
    
                                                                                        <v-flex pa-2 xs12 sm12 md12>
    
                                                                                            <v-card flat="">
                                                                                                <v-layout row wrap>
                                                                                                    <v-flex v-if="iconrezervasyon=='tab-1'" xs12 sm12 md12>
                                                                                                        <v-card-actions>
                                                                                                            <v-layout row wrap>
                                                                                                                <kalemotel v-model="kalemData">
                                                                                                                </kalemotel>
                                                                                                            </v-layout>
                                                                                                        </v-card-actions>
                                                                                                    </v-flex>
    
                                                                                                    <v-flex v-if="iconrezervasyon=='tab-2'" xs12 sm12 md12>
                                                                                                        <v-card-actions>
                                                                                                            <v-layout row wrap>
                                                                                                                <kalemarac v-model="kalemData">
                                                                                                                </kalemarac>
                                                                                                            </v-layout>
                                                                                                        </v-card-actions>
                                                                                                    </v-flex>
    
                                                                                                    <v-flex v-if="iconrezervasyon=='tab-3'" xs12 sm12 md12>
                                                                                                        <v-card-actions>
                                                                                                        <v-layout row wrap>
                                                                                                            <kalemrestaurant v-model="kalemData"></kalemrestaurant>
                                                                                                        </v-layout>
                                                                                                        </v-card-actions>
                                                                                                    </v-flex> 
    
                                                                                                    <v-flex v-if="iconrezervasyon=='tab-4'" xs12 sm12 md12>
                                                                                                        <v-card-actions>
                                                                                                            <v-layout row wrap>
                                                                                                                <kalemgunluktur v-model="kalemData">
                                                                                                                </kalemgunluktur>
                                                                                                            </v-layout>
                                                                                                        </v-card-actions>
                                                                                                    </v-flex>
                                                                                                    <v-flex v-if="iconrezervasyon=='tab-6'" xs12 sm12 md12>
                                                                                                        <v-card-actions>
                                                                                                            <v-layout row wrap>
                                                                                                                <kalemrehber v-model="kalemData">
                                                                                                                </kalemrehber>
                                                                                                            </v-layout>
                                                                                                        </v-card-actions>
                                                                                                    </v-flex>
    
                                                                                                    <v-flex v-if="iconrezervasyon=='tab-8'" xs12 sm12 md12>
                                                                                                        <v-card-actions>
                                                                                                            <v-layout row wrap>
                                                                                                                <kalemcharter v-model="kalemData">
                                                                                                                </kalemcharter>
                                                                                                            </v-layout>
                                                                                                        </v-card-actions>
                                                                                                    </v-flex>
    
                                                                                                    <v-flex v-if="iconrezervasyon=='tab-9'" xs12 sm12 md12>
                                                                                                        <v-card-actions>
                                                                                                            <v-layout row wrap>
                                                                                                                <kalemgemi v-model="kalemData">
                                                                                                                </kalemgemi>
                                                                                                            </v-layout>
                                                                                                        </v-card-actions>
                                                                                                    </v-flex>
    
                                                                                                    <v-flex v-if="iconrezervasyon=='tab-10'" xs12 sm12 md12>
                                                                                                        <v-card-actions>
                                                                                                            <v-layout row wrap>
                                                                                                                <kalemdiger v-model="kalemData">
                                                                                                                </kalemdiger>
                                                                                                            </v-layout>
                                                                                                        </v-card-actions>
                                                                                                    </v-flex>
    
                                                                                                    <v-flex v-if="iconrezervasyon=='tab-14'" xs12 sm12 md12>
                                                                                                        <v-card-actions>
                                                                                                            <v-layout row wrap>
                                                                                                                <kalemsigorta v-model="kalemData">
                                                                                                                </kalemsigorta>
                                                                                                            </v-layout>
                                                                                                        </v-card-actions>
                                                                                                    </v-flex>
    
                                                                                                    <v-flex v-if="iconrezervasyon=='tab-5'" xs12 sm12 md12>
                                                                                                        <v-card-actions>
                                                                                                            <v-layout row wrap>
                                                                                                                <kalemrentacar v-model="kalemData">
                                                                                                                </kalemrentacar>
                                                                                                            </v-layout>
                                                                                                        </v-card-actions>
                                                                                                    </v-flex>
    
                                                                                                    <v-flex v-if="iconrezervasyon=='tab-12'" xs12 sm12 md12>
                                                                                                        <v-card-actions>
                                                                                                            <v-layout row wrap>
                                                                                                                <kalemvize v-model="kalemData">
                                                                                                                </kalemvize>
                                                                                                            </v-layout>
                                                                                                        </v-card-actions>
                                                                                                    </v-flex>
    
                                                                                                </v-layout>
    
                                                                                            </v-card>
                                                                                        </v-flex>
                                                                                    </v-layout>
                                                                                </v-card>
                                                                            </v-flex>
    
                                                                            <v-flex xs4 pa-2 sm4 md3>
                                                                                <v-card flat>
                                                                                    <v-layout row wrap>
                                                                                        <v-flex pl-1 xs12 sm12 md12>
    
                                                                                            <span class=" font-weight-regular info--text subheading">
                                                                                            {{$t('Booking-Items')}}
                                                                                            </span>
                                                                                            <v-divider></v-divider>
                                                                                        </v-flex>
                                                                                        <v-flex pa-2 v-if="kalemData.Rez.kalemler.length==0" xs12 sm12 md12>
                                                                                            <div class="font-weight grey--text body-1 ">
                                                                                                {{ $t('You-have-not-yet-added-an-item') }}
                                                                                            </div>
                                                                                        </v-flex>
    
                                                                                        <v-flex pa-2 v-for="item in kalemData.Rez.kalemler" v-bind:key="item.id" xs12 sm12 md12>
                                                                                            <v-card flat="">
                                                                                                <v-layout row wrap>
                                                                                                    <v-flex xs12 sm12 md12>
                                                                                                        <v-card-actions>
                                                                                                            <v-layout row wrap>
    
                                                                                                                <v-flex xs1 v-if="item.saticiTip=='1'|| item.satici.saticiTip=='01'" sm1 md1>
                                                                                                                    <v-layout align-center="" justify-start="" fill-height="">
                                                                                                                        <v-icon color="red">
                                                                                                                            hotel
                                                                                                                        </v-icon>
                                                                                                                        &nbsp;
    
                                                                                                                    </v-layout>
                                                                                                                </v-flex>
    
                                                                                                                <v-flex xs1 sm1 v-if="item.saticiTip=='2'" md1>
                                                                                                                    <v-layout align-center="" justify-start="" fill-height="">
                                                                                                                        <v-icon color="orange">
                                                                                                                            rv_hookup
                                                                                                                        </v-icon>
                                                                                                                        &nbsp;
                                                                                                                    </v-layout>
                                                                                                                </v-flex>
    
                                                                                                                <v-flex xs1 sm1 v-if="item.saticiTip=='6'" md1>
                                                                                                                    <v-layout align-center="" justify-start="" fill-height="">
                                                                                                                        <v-icon color="teal accent-4">
                                                                                                                            emoji_people
                                                                                                                        </v-icon>
                                                                                                                        &nbsp;
                                                                                                                    </v-layout>
                                                                                                                </v-flex>
    
                                                                                                                <v-flex xs1 sm1 v-if="item.saticiTip=='8'" md1>
                                                                                                                    <v-layout align-center="" justify-start="" fill-height="">
                                                                                                                        <v-icon color="blue darken-4">
                                                                                                                            flight_takeoff
                                                                                                                        </v-icon>
                                                                                                                        &nbsp;
                                                                                                                    </v-layout>
                                                                                                                </v-flex>
    
                                                                                                                <v-flex xs1 sm1 v-if="item.saticiTip=='4'" md1>
                                                                                                                    <v-layout align-center="" justify-start="" fill-height="">
                                                                                                                        <v-icon color="yellow accent-4">
                                                                                                                            local_see
                                                                                                                        </v-icon>
                                                                                                                        &nbsp;
                                                                                                                    </v-layout>
                                                                                                                </v-flex>
    
                                                                                                                <v-flex xs1 sm1 v-if="item.saticiTip=='3'" md1>
                                                                                                                <v-layout align-center="" justify-start="" fill-height="">
                                                                                                                    <v-icon color="deep-purple lighten-4">restaurant</v-icon>
                                                                                                                    &nbsp;
                                                                                                                </v-layout>
                                                                                                                </v-flex> 
    
                                                                                                                <v-flex xs1 sm1 v-if="item.saticiTip=='14'" md1>
                                                                                                                    <v-layout align-center="" justify-start="" fill-height="">
                                                                                                                        <v-icon color="lime">
                                                                                                                            verified_user
                                                                                                                        </v-icon>
                                                                                                                        &nbsp;
                                                                                                                    </v-layout>
                                                                                                                </v-flex>
    
                                                                                                                <v-flex xs1 sm1 v-if="item.saticiTip=='5'" md1>
                                                                                                                    <v-layout align-center="" justify-start="" fill-height="">
                                                                                                                        <v-icon color="green">
                                                                                                                            departure_board
                                                                                                                        </v-icon>
    
                                                                                                                    </v-layout>
                                                                                                                </v-flex>
    
                                                                                                                <v-flex xs1 sm1 v-if="item.saticiTip=='9'" md1>
                                                                                                                    <v-layout align-center="" justify-start="" fill-height="">
                                                                                                                        <v-icon color="light-blue lighten-3">
                                                                                                                            directions_boat
                                                                                                                        </v-icon>
                                                                                                                    </v-layout>
                                                                                                                </v-flex>
    
                                                                                                                <v-flex xs1 sm1 v-if="item.saticiTip=='11'" md1>
                                                                                                                    <v-layout align-center="" justify-start="" fill-height="">
                                                                                                                        <v-icon color="brown">
                                                                                                                            style
                                                                                                                        </v-icon>
    
                                                                                                                    </v-layout>
                                                                                                                </v-flex>
    
                                                                                                                <v-flex xs1 sm1 v-if="item.saticiTip=='10'" md1>
                                                                                                                    <v-layout align-center="" justify-start="" fill-height="">
                                                                                                                        <v-icon color="pink">
                                                                                                                            category
                                                                                                                        </v-icon>
    
                                                                                                                    </v-layout>
                                                                                                                </v-flex>
                                                                                                              
    
                                                                                                                <v-flex xs12 sm2 md5>
                                                                                                                    <v-layout align-start="" justify-start fill-height>
                                                                                                                        <v-card flat="">
                                                                                                                            <v-list-tile>
                                                                                                                                <v-list-tile-content>
                                                                                                                                    <v-list-tile-title>
                                                                                                                                        <span class="font-weight grey--text caption ">
                                                                                                                                            <v-icon small color="grey">
                                                                                                                                                fingerprint
                                                                                                                                            </v-icon>
                                                                                                                                           
                                                                                                                                            &nbsp;
                                                                                                                                            {{item.satici.kod}}
                                                                                                                                            -
                                                                                                                                            {{item.satici.id}}
                                                                                                                                        </span>
                                                                                                                                    </v-list-tile-title>
                                                                                                                                    <v-list-tile-sub-title>
                                                                                                                                        <div class="font-weight green--text caption ">
                                                                                                                                            {{ item.satici.isim}}
                                                                                                                                        </div>
                                                                                                                                    </v-list-tile-sub-title>
                                                                                                                                </v-list-tile-content>
                                                                                                                            </v-list-tile>
                                                                                                                        </v-card>
                                                                                                                    </v-layout>
                                                                                                                </v-flex>
    
                                                                                                                <v-flex xs12 v-if="item.saticiTip!='5' && item.saticiTip!='11'" sm2 md5>
                                                                                                                    <v-layout align-start="" justify-start fill-height>
                                                                                                                        <v-card flat="">
                                                                                                                            <v-list-tile>
                                                                                                                                <v-list-tile-content>
                                                                                                                                    <v-list-tile-sub-title>
                                                                                                                                        <div class="font-weight grey--text caption ">
                                                                                                                                            <v-icon small color="grey">
                                                                                                                                                calendar_today
                                                                                                                                            </v-icon>
                                                                                                                                            &nbsp; {{ $t('Period-Interval') }} 
                                                                                                                                        </div>
                                                                                                                                    </v-list-tile-sub-title>
                                                                                                                                    <v-list-tile-sub-title>
                                                                                                                                        <div class="font-weight green--text caption ">
                                                                                                                                            {{item.donem1 | dateformat}}
                                                                                                                                            -
                                                                                                                                            {{item.donem2 | dateformat}}
                                                                                                                                        </div>
                                                                                                                                    </v-list-tile-sub-title>
                                                                                                                                </v-list-tile-content>
                                                                                                                            </v-list-tile>
                                                                                                                        </v-card>
                                                                                                                    </v-layout>
                                                                                                                </v-flex>
    
                                                                                                                <v-flex xs12 v-if="item.saticiTip=='5'" sm2 md5>
                                                                                                                    <v-layout align-start="" justify-start fill-height>
                                                                                                                        <v-card flat="">
                                                                                                                            <v-list-tile>
                                                                                                                                <v-list-tile-content>
                                                                                                                                    <v-list-tile-sub-title>
                                                                                                                                        <div class="font-weight grey--text caption ">
                                                                                                                                            <v-icon small color="grey">
                                                                                                                                                calendar_today
                                                                                                                                            </v-icon>
                                                                                                                                            &nbsp; {{ $t('Period-Interval') }}
                                                                                                                                        </div>
                                                                                                                                    </v-list-tile-sub-title>
                                                                                                                                    <v-list-tile-sub-title>
                                                                                                                                        <div class="font-weight green--text caption ">
                                                                                                                                            {{item.kalemRentACar.alisTarih | dateformat}}
                                                                                                                                            -
                                                                                                                                            {{item.donem2 | dateformat}}
                                                                                                                                        </div>
                                                                                                                                    </v-list-tile-sub-title>
                                                                                                                                </v-list-tile-content>
                                                                                                                            </v-list-tile>
                                                                                                                        </v-card>
                                                                                                                    </v-layout>
                                                                                                                </v-flex>
    
                                                                                                                <v-flex xs12 v-if="item.saticiTip=='11'" sm2 md5>
                                                                                                                    <v-layout align-start="" justify-start fill-height>
                                                                                                                        <v-card flat="">
                                                                                                                            <v-list-tile>
                                                                                                                                <v-list-tile-content>
                                                                                                                                    <v-list-tile-sub-title>
                                                                                                                                        <div class="font-weight grey--text caption ">
                                                                                                                                            <v-icon small color="grey">
                                                                                                                                                calendar_today
                                                                                                                                            </v-icon>
                                                                                                                                            &nbsp;  {{ $t('Period-Interval') }}
                                                                                                                                        </div>
                                                                                                                                    </v-list-tile-sub-title>
                                                                                                                                    <v-list-tile-sub-title>
                                                                                                                                        <div class="font-weight green--text caption ">
    
                                                                                                                                            {{item.Donem1| dateformat}}
                                                                                                                                            -
                                                                                                                                            {{item.Donem2 | dateformat}}
                                                                                                                                        </div>
                                                                                                                                    </v-list-tile-sub-title>
                                                                                                                                </v-list-tile-content>
                                                                                                                            </v-list-tile>
                                                                                                                        </v-card>
                                                                                                                    </v-layout>
                                                                                                                </v-flex>
    
                                                                                                                <v-flex sm2 md2 xs2>
                                                                                                                    <v-layout justify-end align-center>
    
                                                                                                                    </v-layout>
                                                                                                                </v-flex>
    
                                                                                                            </v-layout>
                                                                                                        </v-card-actions>
    
                                                                                                    </v-flex>
                                                                                                </v-layout>
    
                                                                                            </v-card>
                                                                                        </v-flex>
                                                                                    </v-layout>
                                                                                </v-card>
                                                                            </v-flex>
    
                                                                        </v-layout>
                                                                        <!-- butonlar -->
    
                                                                        <v-layout pa-2 row v-if="allrezlist" wrap>
    
                                                                            <v-flex xs12 pl-2 pb-4 sm12 md12>
                                                                                <span class=" font-weight-regular info--text title">
                                                                                    {{$t('Booking-Items')}}
                                                                                </span>
                                                                                <v-divider color="white"></v-divider>
                                                                                <v-card flat id="create">
                                                                                    <v-speed-dial v-model="fab" :absolute="true" :top="false" :bottom="true" :right="true" :left="false" fixed :direction="'left'" :transition="'scala-transition'">
                                                                                        <template v-slot:activator>
                                                                                            <v-btn v-model="fab" color="blue darken-2" dark fab>
                                                                                                <v-icon>add</v-icon>
                                                                                                <v-icon>close</v-icon>
                                                                                            </v-btn>
                                                                                        </template>
    
                                                                                        <v-btn class="caption" @click.native="iconrezervasyon='tab-1'" fab dark color="red">
                                                                                            <v-icon style="padding-bottom:15px;" small>hotel</v-icon>
                                                                                            <br /> {{ $t('Hotel') }}
                                                                                        </v-btn>
    
                                                                                        <v-btn fab class="caption" @click.native="iconrezervasyon='tab-2'" dark color="orange">
                                                                                            <v-icon style="padding-bottom:15px;" small>rv_hookup</v-icon>
                                                                                            <br />Transfer
                                                                                        </v-btn>
    
                                                                                         <v-btn @click.native="iconrezervasyon='tab-3'" fab dark
                                                                                                color="deep-purple lighten-4">
                                                                                                <v-icon small>restaurant</v-icon>
                                                                                                <br />Restaurant
                                                                                        </v-btn> 
    
                                                                                        <v-btn class="caption" @click.native="iconrezervasyon='tab-4'" fab dark color="yellow accent-4">
                                                                                            <v-icon style="padding-bottom:15px;" small>local_see</v-icon>
                                                                                            <br /> {{ $t('Tour') }}
                                                                                        </v-btn>
    
                                                                                        <v-btn class="caption" @click.native="iconrezervasyon='tab-5'" fab dark color="green">
                                                                                            <v-icon style="padding-bottom:15px;" small>departure_board
                                                                                            </v-icon>
                                                                                            <br /> {{ $t('Rent-A-Car') }}
                                                                                        </v-btn>
    
                                                                                        <v-btn class="caption" @click.native="iconrezervasyon='tab-6'" fab dark color="teal accent-4">
                                                                                            <v-icon style="padding-bottom:15px;" small>emoji_people
                                                                                            </v-icon>
                                                                                            <br /> {{$t('Guide')}}
                                                                                        </v-btn>
    
                                                                                        <v-btn class="caption" @click.native="iconrezervasyon='tab-8'" fab dark color="blue darken-4">
                                                                                            <v-icon style="padding-bottom:15px;" small>flight_takeoff
                                                                                            </v-icon>
                                                                                            <br />{{$t('Airline')}}
                                                                                        </v-btn>
    
                                                                                        <v-btn class="caption" @click.native="iconrezervasyon='tab-9'" fab dark color="cyan darken-2">
                                                                                            <v-icon style="padding-bottom:15px;" small>directions_boat
                                                                                            </v-icon>
                                                                                            <br />{{$t('Cruise')}}
                                                                                        </v-btn>
    
                                                                                        <v-btn class="caption" @click.native="iconrezervasyon='tab-12'" fab dark color="brown">
                                                                                            <v-icon style="padding-bottom:15px;" small>style</v-icon>
                                                                                            <br /> {{$t('Visa')}}
                                                                                        </v-btn>
    
                                                                                        <v-btn class="caption" @click.native="iconrezervasyon='tab-14'" fab dark color="lime">
                                                                                            <v-icon style="padding-bottom:15px;" small>verified_user
                                                                                            </v-icon>
                                                                                            <br /> {{$t('Insurance')}}
    
                                                                                        </v-btn>
                                                                                        <v-btn class="caption" fab @click.native="iconrezervasyon='tab-10'" dark color="pink">
    
                                                                                            <v-icon style="padding-bottom:15px;" small>category</v-icon>
                                                                                            <br /> {{$t('Other')}}
                                                                                        </v-btn>
    
                                                                                    </v-speed-dial>
                                                                                </v-card>
    
                                                                            </v-flex>
                                                                            
                                                                            <v-flex pa-2  xs12 sm12 md12>
                                                                                <div v-if="kalemData.Rez.kalemler.length==0" class="font-weight grey--text body-1 ">
                                                                                    {{ $t('You-have-not-yet-added-an-item') }}
                                                                                </div>
                                                                                <div class="text-align-left">
                                                                                    <v-menu
                                                                                        v-model="pnrMenu"
                                                                                        :close-on-content-click="false"
                                                                                        :nudge-width="200"
                                                                                        offset-x
                                                                                    >
                                                                                        <template v-slot:activator="{ on }">
                                                                                        <v-btn
                                                                                        outline
                                                                                            color="indigo"
                                                                                            dark
                                                                                            v-on="on"
                                                                                        >
                                                                                             {{ $t('Copy-PNR') }}
                                                                                        </v-btn>
                                                                                        </template>
                                                                                        <v-card>
                                                                                            <v-card-text>
                                                                                                <v-form ref="formPNR" lazy-validation>
                                                                                                    <pnrbul
                                                                                                    v-model="searchPnrNo"
                                                                                                    :rules="[(v) => !!v || 'Lütfen PNR seçiniz']"
                                                                                                    hide-details
                                                                                                    >
                                                                                                    </pnrbul>
                                                                                                </v-form>
                                                                                            </v-card-text>
                                                                                        <v-card-actions>
                                                                                            <v-spacer></v-spacer>
                                                                                            <v-btn flat @click="pnrMenu = false">{{$t('Cancel')}}</v-btn>
                                                                                            <v-btn color="primary" flat @click="pnrKopyala()">{{ $t('Apply') }}</v-btn>
                                                                                        </v-card-actions>
                                                                                        </v-card>
                                                                                    </v-menu>
                                                                                </div>
                                                                            </v-flex>
    
                                                                            <v-flex pa-2 v-for="(item,index) in kalemData.Rez.kalemler" v-bind:key="item.id" xs12 sm12 md12>
    
                                                                                <v-card flat="">
                                                                                    <v-layout row wrap>
                                                                                        <v-flex xs12 sm12 md12>
                                                                                            <v-card-actions>
                                                                                                <v-layout row wrap>
    
                                                                                                    <v-flex xs1 sm1 v-if="item.saticiTip=='1'|| item.satici.saticiTip=='01'" md1>
                                                                                                        <v-layout align-center="" justify-start="" fill-height="">
                                                                                                            <v-icon color="red">
                                                                                                                hotel
                                                                                                            </v-icon>
                                                                                                            &nbsp;
                                                                                                            <span class="body-2 black--text font-weight-regular">
                                                                                                                {{ $t('Hotel') }}
                                                                                                            </span>
                                                                                                        </v-layout>
                                                                                                    </v-flex>
    
                                                                                                    <v-flex xs1 sm1 v-if="item.saticiTip=='2'" md1>
                                                                                                        <v-layout align-center="" justify-start="" fill-height="">
                                                                                                            <v-icon color="orange">
                                                                                                                rv_hookup
                                                                                                            </v-icon>
                                                                                                            &nbsp;
                                                                                                            <span class="body-2 black--text font-weight-regular">
                                                                                                                Transfer
                                                                                                            </span>
                                                                                                        </v-layout>
                                                                                                    </v-flex>
    
                                                                                                    <v-flex xs1 sm1 v-if="item.saticiTip=='3'" md1>
                                                                                                        <v-layout align-center="" justify-start="" fill-height="">
                                                                                                        <v-icon color="deep-purple lighten-4">restaurant</v-icon> &nbsp;
                                                                                                        <span class="body-2 black--text font-weight-regular">
                                                                                                            Restaurant
                                                                                                        </span>
                                                                                                        </v-layout>
                                                                                                    </v-flex> 
    
                                                                                                    <v-flex xs1 sm1 v-if="item.saticiTip=='4'" md1>
                                                                                                        <v-layout align-center="" justify-start="" fill-height="">
                                                                                                            <v-icon color="yellow accent-4">
                                                                                                                local_see
                                                                                                            </v-icon>
                                                                                                            &nbsp;
                                                                                                            <span class="body-2 black--text font-weight-regular">
                                                                                                                {{ $t('Daily-Tour') }}
                                                                                                            </span>
                                                                                                        </v-layout>
                                                                                                    </v-flex>
    
                                                                                                    <v-flex xs1 sm1 v-if="item.saticiTip=='8'" md1>
                                                                                                        <v-layout align-center="" justify-start="" fill-height="">
                                                                                                            <v-icon color="blue darken-4">
                                                                                                                flight_takeoff
                                                                                                            </v-icon>
                                                                                                            &nbsp;
                                                                                                            <span class="body-2 black--text font-weight-regular">
                                                                                                                {{$t('Airline')}}
                                                                                                            </span>
                                                                                                        </v-layout>
                                                                                                    </v-flex>
    
                                                                                                    <v-flex xs1 sm1 v-if="item.saticiTip=='10'" md1>
                                                                                                        <v-layout align-center="" justify-start="" fill-height="">
                                                                                                            <v-icon color="pink">
                                                                                                                category
                                                                                                            </v-icon>
                                                                                                            &nbsp;
                                                                                                            <span class="body-2 black--text font-weight-regular">
                                                                                                                {{$t('Other')}}
                                                                                                            </span>
                                                                                                        </v-layout>
                                                                                                    </v-flex>
    
                                                                                                    <v-flex xs1 sm1 v-if="item.saticiTip=='5'" md1>
                                                                                                        <v-layout align-center="" justify-start="" fill-height="">
                                                                                                            <v-icon color="green">
                                                                                                                departure_board
                                                                                                            </v-icon>
                                                                                                            &nbsp;
                                                                                                            <span class="body-2 black--text font-weight-regular">
                                                                                                                {{ $t('Rent-A-Car') }}
                                                                                                            </span>
                                                                                                        </v-layout>
                                                                                                    </v-flex>
    
                                                                                                    <v-flex xs1 sm1 v-if="item.saticiTip=='6'" md1>
                                                                                                        <v-layout align-center="" justify-start="" fill-height="">
                                                                                                            <v-icon color="teal accent-4">
                                                                                                                emoji_people
                                                                                                            </v-icon>
                                                                                                            &nbsp;
                                                                                                            <span class="body-2 black--text font-weight-regular">
                                                                                                                {{$t('Guide')}}
                                                                                                            </span>
                                                                                                        </v-layout>
                                                                                                    </v-flex>
    
                                                                                                    <v-flex xs1 sm1 v-if="item.saticiTip=='9'" md1>
                                                                                                        <v-layout align-center="" justify-start="" fill-height="">
                                                                                                            <v-icon color="cyan lighten-4">
                                                                                                                directions_boat
                                                                                                            </v-icon>
                                                                                                            &nbsp;
                                                                                                            <span class="body-2 black--text font-weight-regular">
                                                                                                                {{ $t('Cruise') }}
                                                                                                            </span>
                                                                                                        </v-layout>
                                                                                                    </v-flex>
    
                                                                                                    <v-flex xs1 sm1 v-if="item.saticiTip=='14'" md1>
                                                                                                        <v-layout align-center="" justify-start="" fill-height="">
                                                                                                            <v-icon color="lime">
                                                                                                                verified_user
                                                                                                            </v-icon>
                                                                                                            &nbsp;
                                                                                                            <span class="body-2 black--text font-weight-regular">
                                                                                                                {{ $t('Insurance') }}
                                                                                                            </span>
                                                                                                        </v-layout>
                                                                                                    </v-flex>
                                                                                                    <v-flex xs1 sm1 v-if="item.saticiTip=='11'" md1>
                                                                                                        <v-layout align-center="" justify-start="" fill-height="">
                                                                                                            <v-icon color="brown">
                                                                                                                style
                                                                                                            </v-icon>
                                                                                                            &nbsp;
                                                                                                            <span class="body-2 black--text font-weight-regular">
                                                                                                                {{$t('Visa')}}
                                                                                                            </span>
                                                                                                        </v-layout>
                                                                                                    </v-flex>
                                                                                                    <v-flex xs12 sm3 md1>
                                                                                                        <v-layout align-start="" justify-start fill-height>
                                                                                                            <v-card flat="">
                                                                                                                <v-list-tile>
                                                                                                                    <v-list-tile-content>
                                                                                                                        <div class="font-weight grey--text caption ">
                                                                                                                           
                                                                                                                            {{$t('PNR')}}
                                                                                                                        </div>
                                                                                                                        <v-list-tile-sub-title>
                                                                                                                            <div class="font-weight green--text caption ">
                                                                                                                                
                                                                                                                                {{ item.PNR_No}}
                                                                                                                            </div>
                                                                                                                        </v-list-tile-sub-title>
                                                                                                                    </v-list-tile-content>
                                                                                                                </v-list-tile>
                                                                                                            </v-card>
                                                                                                        </v-layout>
                                                                                                    </v-flex>
                                                                                                    <v-flex xs12 sm3 md2>
                                                                                                        <v-layout align-start="" justify-start fill-height>
                                                                                                            <v-card flat="">
                                                                                                                <v-list-tile>
                                                                                                                    <v-list-tile-content>
                                                                                                                        <div class="font-weight grey--text caption ">
                                                                                                                          
                                                                                                                            &nbsp;
                                                                                                                            {{$t('Current')}}
                                                                                                                        </div>
                                                                                                                        <v-list-tile-sub-title>
                                                                                                                            <div class="font-weight green--text caption ">
                                                                                                                              
                                                                                                                                &nbsp;
                                                                                                                                {{item.cariKod.kod}}  - {{ item.cariKod.isim}}
                                                                                                                               
                                                                                                                            </div>
                                                                                                                        </v-list-tile-sub-title>
                                                                                                                    </v-list-tile-content>
                                                                                                                </v-list-tile>
                                                                                                            </v-card>
                                                                                                        </v-layout>
                                                                                                    </v-flex>
                                                                                                    <v-flex xs12 sm3 md2>
                                                                                                        <v-layout align-start="" justify-start fill-height>
                                                                                                            <v-card flat="">
                                                                                                                <v-list-tile>
                                                                                                                    <v-list-tile-content>
                                                                                                                        <div class="font-weight grey--text caption ">
                                                                                                                            <v-icon small color="grey">
                                                                                                                                fingerprint
                                                                                                                            </v-icon>
                                                                                                                            &nbsp;
                                                                                                                            {{$t('Seller')}}
                                                                                                                        </div>
                                                                                                                        <v-list-tile-sub-title>
                                                                                                                            <div class="font-weight green--text caption ">
                                                                                                                                &nbsp;
                                                                                                                               
                                                                                                                                {{item.satici.kod}}
                                                                                                                                - {{ item.satici.isim}}
                                                                                                                            </div>
                                                                                                                        </v-list-tile-sub-title>
                                                                                                                    </v-list-tile-content>
                                                                                                                </v-list-tile>
                                                                                                            </v-card>
                                                                                                        </v-layout>
                                                                                                    </v-flex>
                                                                                                    <v-flex v-if="item.saticiTip=='5'" xs12 sm2 md2>
                                                                                                        <v-layout align-start="" justify-start fill-height>
                                                                                                            <v-card flat="">
                                                                                                                <v-list-tile>
                                                                                                                    <v-list-tile-content>
                                                                                                                        <v-list-tile-sub-title>
                                                                                                                            <div class="font-weight grey--text caption ">
                                                                                                                                <v-icon small color="grey">
                                                                                                                                    calendar_today
                                                                                                                                </v-icon>
                                                                                                                                &nbsp; {{ $t('Purchase-Date') }}
                                                                                                                            </div>
                                                                                                                        </v-list-tile-sub-title>
                                                                                                                        <v-list-tile-sub-title>
                                                                                                                            <div class="font-weight red--text body-2 ">
                                                                                                                                &nbsp;
                                                                                                                                &nbsp;
                                                                                                                                &nbsp;{{item.kalemRentACar.alisTarih | dateformat}}
                                                                                                                            </div>
                                                                                                                        </v-list-tile-sub-title>
                                                                                                                    </v-list-tile-content>
                                                                                                                </v-list-tile>
                                                                                                            </v-card>
                                                                                                        </v-layout>
    
                                                                                                    </v-flex>
    
                                                                                                    <v-flex xs12 v-if="item.saticiTip!='5' && item.saticiTip!='11'" sm2 md2>
                                                                                                        <v-layout align-start="" justify-start fill-height>
                                                                                                            <v-card flat="">
                                                                                                                <v-list-tile>
                                                                                                                    <v-list-tile-content>
                                                                                                                        <v-list-tile-sub-title>
                                                                                                                            <div class="font-weight grey--text caption ">
                                                                                                                                <v-icon small color="grey">
                                                                                                                                    calendar_today
                                                                                                                                </v-icon>
                                                                                                                                &nbsp; {{ $t('Term-Start') }}
                                                                                                                            </div>
                                                                                                                        </v-list-tile-sub-title>
                                                                                                                        <v-list-tile-sub-title>
                                                                                                                            <div class="font-weight red--text body-2 ">
                                                                                                                                &nbsp;
                                                                                                                                &nbsp;
                                                                                                                                &nbsp;
                                                                                                                                {{item.donem1 | dateformat}}
                                                                                                                            </div>
                                                                                                                        </v-list-tile-sub-title>
                                                                                                                    </v-list-tile-content>
                                                                                                                </v-list-tile>
                                                                                                            </v-card>
                                                                                                        </v-layout>
                                                                                                    </v-flex>
    
                                                                                                    <v-flex v-if="item.saticiTip!='5' && item.saticiTip!='11' " xs12 sm2 md2>
                                                                                                        <v-layout align-start="" justify-start fill-height>
                                                                                                            <v-card flat="">
                                                                                                                <v-list-tile>
                                                                                                                    <v-list-tile-content>
                                                                                                                        <v-list-tile-sub-title>
                                                                                                                            <div class="font-weight grey--text caption ">
                                                                                                                                <v-icon small color="grey">
                                                                                                                                    calendar_today
                                                                                                                                </v-icon>
                                                                                                                                &nbsp; {{ $t('Term-End') }}
                                                                                                                            </div>
                                                                                                                        </v-list-tile-sub-title>
                                                                                                                        <v-list-tile-sub-title>
                                                                                                                            <div class="font-weight red--text body-2 ">
                                                                                                                                &nbsp;
                                                                                                                                &nbsp;
                                                                                                                                &nbsp;{{item.donem2 | dateformat}}
                                                                                                                            </div>
                                                                                                                        </v-list-tile-sub-title>
                                                                                                                    </v-list-tile-content>
                                                                                                                </v-list-tile>
                                                                                                            </v-card>
                                                                                                        </v-layout>
                                                                                                    </v-flex>
    
                                                                                                    <v-flex v-if="item.saticiTip=='5'" xs12 sm2 md2>
                                                                                                        <v-layout align-start="" justify-start fill-height>
                                                                                                            <v-card flat="">
                                                                                                                <v-list-tile>
                                                                                                                    <v-list-tile-content>
                                                                                                                        <v-list-tile-sub-title>
                                                                                                                            <div class="font-weight grey--text caption ">
                                                                                                                                <v-icon small color="grey">
                                                                                                                                    calendar_today
                                                                                                                                </v-icon>
                                                                                                                                &nbsp; {{ $t('Delivery-Date') }} 
                                                                                                                            </div>
                                                                                                                        </v-list-tile-sub-title>
                                                                                                                        <v-list-tile-sub-title>
                                                                                                                            <div class="font-weight red--text body-2 ">
                                                                                                                                &nbsp;
                                                                                                                                &nbsp;
                                                                                                                                &nbsp;{{item.donem2 | dateformat}}
                                                                                                                            </div>
                                                                                                                        </v-list-tile-sub-title>
                                                                                                                    </v-list-tile-content>
                                                                                                                </v-list-tile>
                                                                                                            </v-card>
                                                                                                        </v-layout>
                                                                                                    </v-flex>
    
                                                                                                    <v-flex v-if="item.saticiTip=='11'" xs12 sm2 md2>
                                                                                                        <v-layout align-start="" justify-start fill-height>
                                                                                                            <v-card flat="">
                                                                                                                <v-list-tile>
                                                                                                                    <v-list-tile-content>
                                                                                                                        <v-list-tile-sub-title>
                                                                                                                            <div class="font-weight grey--text caption ">
                                                                                                                                <v-icon small color="grey">
                                                                                                                                    calendar_today
                                                                                                                                </v-icon>
                                                                                                                                &nbsp; {{ $t('Starting-Date') }}
                                                                                                                            </div>
                                                                                                                        </v-list-tile-sub-title>
                                                                                                                        <v-list-tile-sub-title>
                                                                                                                            <div class="font-weight red--text body-2 ">
                                                                                                                                &nbsp;
                                                                                                                                &nbsp;
                                                                                                                                &nbsp;{{item.donem1 | dateformat}}
                                                                                                                            </div>
                                                                                                                        </v-list-tile-sub-title>
                                                                                                                    </v-list-tile-content>
                                                                                                                </v-list-tile>
                                                                                                            </v-card>
                                                                                                        </v-layout>
                                                                                                    </v-flex>
    
                                                                                                    <v-flex v-if="item.saticiTip=='11'" xs12 sm2 md2>
                                                                                                        <v-layout align-start="" justify-start fill-height>
                                                                                                            <v-card flat="">
                                                                                                                <v-list-tile>
                                                                                                                    <v-list-tile-content>
                                                                                                                        <v-list-tile-sub-title>
                                                                                                                            <div class="font-weight grey--text caption ">
                                                                                                                                <v-icon small color="grey">
                                                                                                                                    calendar_today
                                                                                                                                </v-icon>
                                                                                                                                &nbsp; {{ $t('Finishing-Date') }}
                                                                                                                            </div>
                                                                                                                        </v-list-tile-sub-title>
                                                                                                                        <v-list-tile-sub-title>
                                                                                                                            <div class="font-weight red--text body-2 ">
                                                                                                                                &nbsp;
                                                                                                                                &nbsp;
                                                                                                                                &nbsp;{{item.donem2 | dateformat}}
    
                                                                                                                            </div>
                                                                                                                        </v-list-tile-sub-title>
                                                                                                                    </v-list-tile-content>
                                                                                                                </v-list-tile>
                                                                                                            </v-card>
                                                                                                        </v-layout>
                                                                                                    </v-flex>
    
                                                                                                    <v-flex sm2 md1 xs2>
                                                                                                        <v-layout justify-end align-center>
    
                                                                                                            <v-menu color="info" offset-y>
                                                                                                                <v-btn slot="activator" dark icon>
                                                                                                                    <v-icon color="grey">
                                                                                                                        more_vert
                                                                                                                    </v-icon>
                                                                                                                </v-btn>
                                                                                                                <v-list>
                                                                                                                   
                                                                                                                    <v-list-tile v-if="item.entegrasyonKodu==null && item.entTip!=2" @click="rezkayitsil(item)">
                                                                                                                        <v-list-tile-title>
                                                                                                                           
                                                                                                                            {{  $t('Delete') }} 
                                                                                                                        </v-list-tile-title>
                                                                                                                    </v-list-tile>
                                                                                                                    <v-list-tile v-if="item.entTip!=2" @click="rezkayitgetir(item,index)">
                                                                                                                        <v-list-tile-title>
                                                                                                                            {{ $t('Edit') }}
                                                                                                                        </v-list-tile-title>
                                                                                                                    </v-list-tile>
                                                                                                                    <!-- <v-list-tile @click="kalemKopyala(item)">
                                                                                                                        <v-list-tile-title>
                                                                                                                            Kopyala
                                                                                                                        </v-list-tile-title>
                                                                                                                    </v-list-tile> -->
    
                                                                                                                    <v-list-tile v-if="item.entId!=null && item.entId!=0" @click="hotelRunnerRezDegistir(item)">
                                                                                                                        <v-list-tile-title>
                                                                                                                            {{ $t('Change-Reservation') }}
                                                                                                                        </v-list-tile-title>
                                                                                                                    </v-list-tile>
    
                                                                                                                    <v-list-tile v-if="item.entId!=null && item.entId!=0" @click="hotelRunnerRezIptal(item)">
                                                                                                                        <v-list-tile-title>
                                                                                                                            {{ $t('Cancel-Reservation') }}
                                                                                                                        </v-list-tile-title>
                                                                                                                    </v-list-tile>
    
                                                                                                                    <v-list-tile v-if="item.saticiTip==2 && item.entTip==2" @click="paxdriveRezDegistir(item)">
                                                                                                                        <v-list-tile-title>
                                                                                                                            PaxDrive
                                                                                                                            {{ $t('Change-Reservation') }}
                                                                                                                        </v-list-tile-title>
                                                                                                                    </v-list-tile>
    
                                                                                                                    <v-list-tile v-if="item.saticiTip==2 && item.entTip==2" @click="paxdriveRezervasyonIptal(item)">
                                                                                                                        <v-list-tile-title>
                                                                                                                            PaxDrive
                                                                                                                            {{ $t('Cancel-Reservation') }}
                                                                                                                        </v-list-tile-title>
                                                                                                                    </v-list-tile>
    
                                                                                                                </v-list>
                                                                                                            </v-menu>
                                                                                                        </v-layout>
                                                                                                    </v-flex>
    
                                                                                                </v-layout>
                                                                                            </v-card-actions>
    
                                                                                        </v-flex>
                                                                                    </v-layout>
    
                                                                                </v-card>
                                                                            </v-flex>
                                                                        </v-layout>
    
                                                                    </v-layout>
    
                                                                </v-card>
    
                                                                <v-layout row wrap>
    
                                                                    <v-flex sm6 md6 xs6>
                                                                        <v-layout pt-2 justify-start row wrap>
                                                                            <v-tooltip bottom>
                                                                                <v-btn :disabled="!sayfayetki.Screen" outline flat color="primary" slot="activator" @click.native="OncekiSayfa(step.rezKalemleri)">
                                                                                    <span class="hidden-sm-and-down">
                                                                                    </span>
                                                                                    <v-icon small>keyboard_arrow_left
                                                                                    </v-icon> {{ $t('BACK') }}
                                                                                </v-btn>
                                                                                
                                                                                <span v-if="sayfayetki.Screen">{{ $t('BACK') }}</span>
                                                                            </v-tooltip>
    
                                                                        </v-layout>
                                                                    </v-flex>
                                                                    <v-flex v-if="this.$route.query.islem != 'get'" sm6 md6 xs6>
                                                                        <v-layout pt-2 justify-end row wrap>
    
                                                                            <v-tooltip bottom>
                                                                                <v-btn :disabled="!sayfayetki.Save" outline flat color="primary" slot="activator" @click.native="SonrakiSayfa(step.rezKalemleri)">
                                                                                    <span class="hidden-sm-and-down">
                                                                                    </span>
                                                                                    <v-icon small>save</v-icon> KAYDET İLERİ
                                                                                </v-btn>
                                                                               
                                                                                <span v-if="sayfayetki.Save"> {{ $t('Save-and-Continue') }} </span>
                                                                            </v-tooltip>
    
                                                                        </v-layout>
    
                                                                    </v-flex>
                                                                    <v-flex v-if="this.$route.query.islem == 'get'" sm6 md6 xs6>
                                                                        <v-layout pt-2 justify-end row wrap>
    
                                                                            <v-tooltip bottom>
                                                                                <v-btn :disabled="!sayfayetki.Update || minrezlist" outline flat color="primary" slot="activator" @click.native="SonrakiSayfa(step.rezKalemleri)">
                                                                                    <span class="hidden-sm-and-down">
                                                                                    </span>
                                                                                    <v-icon small>save</v-icon> GÜNCELLE İLERİ
                                                                                </v-btn>
                                                                               
                                                                                <span v-if="sayfayetki.Update"> {{ $t('Update-and-Continue') }} </span>
                                                                            </v-tooltip>
    
                                                                        </v-layout>
                                                                    </v-flex>
    
                                                                </v-layout>
    
                                                            </v-stepper-content>
    
                                                            <!--4 Tahsilat -->
                                                            <v-stepper-content :step=step.tahsilat>
    
                                                                <v-card class="mb-5">
                                                                    <!-- <odeme v-model="Rez"> </odeme> -->
    
                                                                    <v-flex xs12 sm12 md12>
    
                                                                        <v-flex xs12 sm12 md12>
                                                                            <span class=" font-weight-regular grey--text title">
                                                                               {{$t('Collections-Made')}} 
                                                                            </span>
                                                                            <v-divider></v-divider>
                                                                        </v-flex>
                                                                        <v-card flat>
                                                                            <v-card flat>
                                                                                <v-flex xs12 pt-4 sm12 md12>
                                                                                    <v-btn fab small color="info" bottom right absolute @click="OdemeEkle()">
                                                                                        <v-icon>add</v-icon>
                                                                                    </v-btn>
                                                                                </v-flex>
                                                                            </v-card>
                                                                            <v-data-table :headers="headerstahsilat" :rows-per-page-items=[10,20,50,100] :items="kalemData.Rez.odemeler">
                                                                                <v-progress-linear slot="progress" indeterminate></v-progress-linear>
    
                                                                                <template slot="items" slot-scope="props">
                                                                                    <td class="text-xs-left">
                                                                                        {{ props.item.evrakNo }}</td>
                                                                                    <td class="text-xs-left">
                                                                                        {{ props.item.evrakTipi }}</td>
                                                                                    <td class="text-xs-center">
                                                                                        {{ props.item.tarih | dateformat }}
                                                                                    </td>
                                                                                    <td class="text-xs-center">
                                                                                        {{ props.item.para.paraBirimi}}
                                                                                    </td>
                                                                                    <td class="text-xs-right">
                                                                                        {{ props.item.dovizTutar | moneyformat}}
                                                                                    </td>
                                                                                    <td class="text-xs-right">
                                                                                        {{ props.item.para.kur | currencyformat  }}
                                                                                    </td>
                                                                                    <td class="text-xs-right">
    
                                                                                        <v-btn icon class="mx-0" @click="OdemeSil(props.item)">
                                                                                            <v-icon color="pink">delete
                                                                                            </v-icon>
                                                                                        </v-btn>
                                                                                        <!-- <v-btn icon class="mx-0" @click="OdemeDuzenle(props.item)">
                                                  <v-icon color="teal">edit</v-icon>
                                                </v-btn> -->
                                                                                    </td>
    
                                                                                </template>
                                                                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                                                                {{ $t('No-records-searched-for', { value: search3}) }} 
    
                                                                                </v-alert>
                                                                            </v-data-table>
                                                                        </v-card>
    
                                                                    
                                                                    </v-flex>
    
                                                                </v-card>
    
                                                                <v-layout row wrap>
                                                                    <v-flex sm6 md6 xs6>
                                                                        <v-layout pt-2 justify-start row wrap>
    
                                                                            <v-tooltip bottom>
                                                                                <v-btn :disabled="!sayfayetki.Screen" outline flat color="primary" slot="activator" @click.native="OncekiSayfa(step.tahsilat)">
                                                                                    <span class="hidden-sm-and-down">
                                                                                    </span>
                                                                                    <v-icon small>keyboard_arrow_left
                                                                                    </v-icon> {{ $t('BACK') }}
                                                                                </v-btn>
                                                                               
                                                                                <span v-if="sayfayetki.Screen">{{ $t('BACK') }}</span>
                                                                            </v-tooltip>
                                                                            
                                                                        </v-layout>
                                                                    </v-flex>
                                                                    <v-flex sm6 md6 xs6>
                                                                        <v-layout pt-2 justify-end row wrap>
    
                                                                            <v-tooltip bottom>
                                                                                <v-btn :disabled="!sayfayetki.Screen" outline flat color="primary" slot="activator" @click.native="SonrakiSayfa(step.tahsilat)">
                                                                                    <span class="hidden-sm-and-down">
                                                                                        {{ $t('NEXT') }}
                                                                                    </span>
                                                                                    <v-icon small>navigate_next</v-icon>
                                                                                </v-btn>
                                                                              
                                                                                <span v-if="sayfayetki.Screen">{{ $t('NEXT') }}</span>
                                                                            </v-tooltip>
    
                                                                        </v-layout>
                                                                    </v-flex>
    
                                                                </v-layout>
    
                                                            </v-stepper-content>
    
                                                            <!--5 Dökümanlar ****************************************************************************************-->
                                                            <v-stepper-content :step=step.dokumanlar>
                                                                <v-card flat color="grey lighten-1" class="mb-5">
                                                                    <kalemdokumanlar v-model="kalemData">
                                                                    </kalemdokumanlar>
                                                                </v-card>
    
                                                                <v-layout row wrap>
                                                                    <v-flex sm6 md6 xs6>
                                                                        <v-layout pt-2 justify-start row wrap>
    
                                                                            <v-tooltip bottom>
                                                                                <v-btn :disabled="!sayfayetki.Screen" outline flat color="primary" slot="activator" @click.native="OncekiSayfa(step.dokumanlar)">
                                                                                    <span class="hidden-sm-and-down">
                                                                                    </span>
                                                                                    <v-icon small>keyboard_arrow_left
                                                                                    </v-icon> {{ $t('BACK') }}
                                                                                </v-btn>
                                                                              
                                                                                <span v-if="sayfayetki.Screen">{{ $t('BACK') }}</span>
                                                                            </v-tooltip>
    
                                                                        </v-layout>
                                                                    </v-flex>
                                                                    <v-flex sm6 md6 xs6>
                                                                        <v-layout pt-2 justify-end row wrap>
    
                                                                            <!-- <v-btn flat color="primary" @click.native="SonrakiSayfa(step.dokumanlar)">İLERİ
                                            <v-icon small>navigate_next</v-icon>
                                          </v-btn> -->
                                                                        </v-layout>
                                                                    </v-flex>
    
                                                                </v-layout>
    
                                                            </v-stepper-content>
    
                                                        </v-stepper-items>
                                                    </v-stepper>
    
                                                </v-flex>
    
                                            </v-layout>
                                        </v-layout>
                                    </v-card-actions>
                                </v-card>
                            </v-card>
                        </v-flex>
    
                    </v-flex>
    
                </v-layout>
    
            </v-layout>
        </v-card>
    
        <v-dialog v-if="iptalDialog" persistent v-model="iptalDialog" max-width="450px">
            <v-card>
                <v-card-text>
                    <v-container>
    
                        <v-form ref="formiptal" v-model="validiptal" lazy-validation>
                            <v-layout class="  project overdue" row wrap>
                                <v-flex xs12 pb-2 sm12 md12>
                                    <v-layout row wrap>
    
                                        <v-toolbar flat="" size="120px" dark color="white">
                                            <v-toolbar-title> <span class="subheading black--text">
                                                    {{ $t('Details-of-PNR-Cancelled') }}
                                                </span> </v-toolbar-title>
                                            <v-spacer></v-spacer>
                                        </v-toolbar>
                                    </v-layout>
                                </v-flex>
    
                                <v-flex pl-4 xs3 md3 sm3>
                                    <span>  {{ $t('No') }} </span>
                                </v-flex>
                                <v-flex xs9 md9 sm9>
                                    <span>:{{kalemData.Rez.takipNo}} </span>
                                </v-flex>
                                <v-flex xs3 pl-4 md3 sm3>
                                    <!-- <span> {{ $t('Current') }} </span> -->
                                </v-flex>
                                <v-flex xs9 md9 sm9>
    
                                    <!-- <span>:{{kalemData.Rez.cariKod.kod}}-{{kalemData.Rez.cariKod.isim}} </span> -->
                                </v-flex>
    
                            </v-layout>
                            <v-flex pl-4 pt-2 xs12 md12 sm12>
                                <v-text-field hide-details :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="IptalNedeni" :label="$t('Reason-of-Cancellation')"></v-text-field>
                            </v-flex>
                        </v-form>
    
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="info" v-if="iptalTuru!='hrIptal' && iptalTuru!='pdIptal' " flat="flat" @click.native="iptalDialog = false">
                        {{$t("cancel_button")}}</v-btn>
                    <v-btn color="info" flat @click.native="pnrIptal()">{{ $t('OK') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    
        <v-dialog v-model="loadingdialog" hide-overlay persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    {{ $t('Your-invoice-information-being-prepared') }} , {{ $t('Please-Wait') }} ...
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    
        <v-dialog v-model="dialogsor" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">{{ $t('Warning') }} !</v-card-title>
                <v-card-text>Bu kayıtı silmek istediğinize emin misiniz?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="info" flat @click.native="dialogsor=false">{{$t("cancel_button")}}</v-btn>
                    <v-btn v-if="faturasilbtn" color="info" flat @click="faturasil()">{{ $t('OK') }}</v-btn>
    
                    <v-btn v-if="satirsilbtn" color="info" flat @click="satirsil()">{{ $t('OK') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    
      
    </div>
    </template>
    
    <script>
    //importlar
    import auth from '../../../../api/auth'
    import parainput from "../../customcomp/parainput" 
    import dovizinput from '../../customcomp/dovizinput'
    import yuzdeinput from '../../customcomp/yuzdeinput'
    import tarihcomp from '../../customcomp/tarihim'
    import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
    import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"
    import reportbrosablon from "@/components/app/coper/comp/reportbrosablon.vue";
    import geneltiplist from "@/components/app/customcomp/geneltiplist.vue"
    import helpers from "@/components/app/customcomp/helpers.js"
    import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
    

    import tool from "../tools";
    import rez from "@/components/app/coper/mice.js";
    import kisitip from "@/components/app/coper/comp/kisitip.vue";
    import anatip from "@/components/app/coper/comp/anatip.vue";
    import geneltipara from "@/components/app/coper/comp/geneltipara.vue";
    import pnraracomp from "@/components/app/coper/component/pnraracomp.vue";
    import cariara from "@/components/app/coper/comp/cariara.vue";
    import genelarama from "@/components/app/coper/comp/genelarama.vue";
    import odeme from "@/components/app/coper/comp/odeme.vue";
    import pnrara from "@/components/app/coper/comp/pnrara.vue";
    import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
    
    import caricomp from '@/components/app/customcomp/caricomp.vue'

    import kalemotel from "@/components/app/coper/mice/comp/kalemotel.vue";
    import kalemdiger from "@/components/app/coper/mice/comp/kalemdiger.vue";
    import kalemrentacar from "@/components/app/coper/mice/comp/kalemrentacar.vue";
    import kalemsigorta from "@/components/app/coper/mice/comp/kalemsigorta.vue";
    import kalemrestaurant from "@/components/app/coper/mice/comp/kalemrestaurant.vue";
    import kalemgemi from "@/components/app/coper/mice/comp/kalemgemi.vue";
    import kalemrehber from "@/components/app/coper/mice/comp/kalemrehber.vue";
    import kalemvize from "@/components/app/coper/mice/comp/kalemvize.vue";
    import kalemgunluktur from "@/components/app/coper/mice/comp/kalemgunluktur.vue";
    import kalemdokumanlar from "@/components/app/coper/mice/comp/kalemdokumanlar.vue";
    import kalemarac from "@/components/app/coper/mice/comp/kalemarac.vue";
    import kalemcharter from "@/components/app/coper/mice/comp/kalemcharter.vue";

    import loadingcomp from "@/components/app/customcomp/loadingcomp"
    import tahsilatdialog from "@/components/app/coper/component/tahsilatdialog"
    import onaydialog from "@/components/app/customcomp/onaydialog.vue";
    import onaydialogchk from "@/components/app/customcomp/onaydialogchkbox.vue";
    import kisiadresara from "@/components/app/coper/component/kisiadresara.vue";
    import paxdriveeditdialog from "@/components/app/coper/component/paxdriveeditdialog.vue";
    import pnrbul from "@/components/app/coper/component/pnrbul.vue";
    
    import profildialog from "@/components/app/coper/comp/profildialog.vue";
    import musteripersoneldialog from "@/components/app/coper/comp/musteripersoneldialog.vue";
    
    import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
    
    
    export default {
        props: {
            operation: ''
        },
    
        data() {
            return {
               
                saticiItems:[],
                rezControl:0,
                searchPnrNo:null,
                pnrMenu:false,
                validiptal: true,
                IptalNedeni: null,
                iptalDialog: false,
                iptalTuru: null,
                passwordRules: [
                    v => !!v || 'Password is required',
                    v => (v && v.length < 51) || this.$t('Must-be-characters-maximum')
                ],
                //değişkenler
                fab: false,
                sayfayetki: {
                    Screen: false,
                    Update: false,
                    Save: false,
                    Delete: false,
                    Status: false,
                    Message: null,
                    islem: 0,
                },
    
                adresDialogData: {
                    dialogShow: false,
                    adres: rez.Adres()
                },
    
                kalemData: {
                    kalem: rez.Kalem(),
                    Kalemler: [],
                    Rez: rez.Rezervasyon(),
                    Kisiler: [],
                    islem: 'new',
                    aktif: false,
                    recordno: null,
                },
    
                headerstahsilat: [{
    
                        text: this.$t('Document-No'),
                        value: "evrakNo",
                        sortable: false
                    },
                    {
                        text: this.$t('Document-Type'),
                        value: "evrakTipi",
                        sortable: false
                    },
                    {
                        text: this.$t('Date'),
                        value: "tarih",
                        sortable: false,
                        align: 'center',
                    },
                    {
                        text: this.$t('Currency-Unit'),
                        value: "para.ParaBirimi",
                        sortable: false,
                        align: 'center',
                    },
                    {
                        text: this.$t('Amount'),
                        value: "dovizTutar",
                        sortable: false,
                        align: 'right'
                    },
                    {
                        text: this.$t('Exchange-Rate-v2'),
                        value: "para.kur",
                        sortable: false,
                        align: 'right'
                    },
                    {
                        text: "",
                        value: "",
                        sortable: false
                    }
    
                ],
                itemstahsilat: [],
                menuopsiyonsaat: false,
                loadingvmodel: false,
                rezbaslik: 'Otel Bilgileri',
                rezicon: 'edit',
                steppervmodel: 0,
                validkisiekle: true,
                step: {
                    onKayit: 1,
                    kisiBilgileri: 2,
                    rezKalemleri: 3,
                    tahsilat: 4,
                    dokumanlar: 5
                },
                caricompitems: null,
                Referans: [],
                kisileritems: [],
                minrezlist: false,
                allrezlist: true,
                iconrezervasyon: null,
                
                coperStatusItems:[
                    {
                        text:'Açık',
                        value:0
                    },
                    {
                        text:'Kapalı',
                        value:1
                    }
                ],
                cinsiyetitems: rez.Cinsiyet(),
                Rez: rez.Rezervasyon(),
                Adres: rez.Adres(),
                yolcutableheaders: [{
                        text: this.$t('Person-Type'),
                        value: "kisiTip",
                        sortable: false
                    },
                    {
                        text: this.$t('Name_Surname_label'),
                        value: "adSoyad",
                        sortable: false
                    },
                    {
                        text: this.$t('Identitynumber_label'),
                        value: "tcKimlikNo",
                        sortable: false
                    },
                    {
                        text: "",
                        value: "",
                        sortable: false
                    }
                ],
                kalemtableheaders: [{
                        text: "Satici Tipi",
                        value: "saticiTip"
                    },
                    {
                        text: this.$t('Seller-Code'),
                        value: "saticiKod"
                    },
                    {
                        text: this.$t('Period-v2') + " 1",
                        value: "denem1"
                    },
                    {
                        text: this.$t('Period-v2') +  "2",
                        value: "donem2"
                    },
                    {
                        text: this.$t('Process'),
                        value: "name",
                        sortable: false
                    }
                ],
                status: tool.NewSatatus(),
    
                dizayngoster: true,
                yazdirbtngoster: false,
                efaturatipi: [{
                        text: this.$t('Commercial'),
                        value: '0'
                    },
                    {
                        text: this.$t('Basic'),
                        value: '1'
                    },
                    {
                        text: this.$t('Export'),
                        value: '2'
                    }
                ],
                silinecekkayit: null,
                dialogsor: false,
                efaturatipigecici: 0,
                webadresilabel: null,
                odemeseklilabel: null,
                odemesekliaciklamalabel: null,
                odemearacilabel: null,
                odemetarihilabel: null,
                internetsatislabel: null,
                gonderimlabel: null,
                valid: true,
                Current: {
                    CompanyCode: '',
                    Code: null,
                    Title: null,
                    Phone1: '',
                    CreditLimit1: 0,
                    AccountingCode: null,
                    Phone2: '',
                    Mobile: '',
                    Web: '',
                    Email: '',
                    AccountGroup: '',
                    Type: '',
                    CMCode: '',
                    Reserved1: '',
                    Reserved2: '',
                    Authorized: '',
                    WarningNote: '',
                    InfoNote: '',
                    CustomerType: '',
                    TicketBill: '',
                    EInvoiceType: '',
                    PostCodeLabel: '',
                    EInvoiceCustomer: '',
                    MultiPostUse: false,
                    EArchiveSendType: false,
                    EArchiveSendPaper: false,
                    CreditLimit: 0,
                    CreditLimitCurrencyAmount: 0,
                    CreditLimitCurrency: '',
                    WebPassword: '',
                    PinCode: '',
                    MileCode: '',
                    ExpiryDayDomestic: '',
                    ExpiryTypeDomestic: '',
                    ExpiryDayInt: '',
                    ExpiryTypeInt: '',
                    ExpiryDayGeneral: '',
                    ExpiryTypeGeneral: '',
                    DiscountGeneral: '',
                    DiscountDom: '',
                    DiscountInt: '',
                    DiscountDomService: '',
                    DiscountIntService: '',
                    TaxFree: '',
                    ExternalCurrentCode: '',
                    ExternalAccountingCode: '',
                    StreamCurrentCode: '',
                    ArkmanStreamCode: '',
                    ExpenseCenter: null,
                    TemplateID: '',
                    ProfileForced: '',
                    EventIDForced: '',
                    MainAccount: '',
                    Invoice: {
                        Address: '',
                        PostCode: '',
                        Province: '',
                        Country: '',
                        TaxNumber: '',
                        TaxOffice: '',
                        IdentityNumber: '',
                        PerFirstName: '',
                        PerFamilyName: '',
                        PerTitle: '',
                        PerMiddleName: '',
                        PerNameSuffix: '',
                        NoPrint: '',
                        CustomerPersonelNoInvoice: '',
                        DeliveryAddress: '',
                        DeliveryName: ''
                    },
                    Contract: {
                        ContractNumber: '',
                        ContractDate: '',
                        PaymentType: '',
                        BankAccountNumber: '',
                        BankBranchOffice: '',
                        InvoiceRowNumber: '',
                        InvoicePassengerName: '',
                        InvoiceFlightNumber: ''
                    }
                },
    
                musteritipi: [{
                        text: this.$t('Individual'),
                        value: 'B'
                    },
                    {
                        text: this.$t('Corporate'),
                        value: 'K'
                    }
                ],
                dialogyenicari: false,
                reportbroview: false,
                headers: [{
                        text: this.$t('Accounting-Code'),
                        value: 'MuhasebeKodu'
                    },
                    {
                        text: this.$t('Description'),
                        value: 'Aciklama',
    
                    },
                    {
                        text: this.$t('Reference'),
                        value: 'Referans.Kod'
                    },
                    {
                        text: this.$t('Amount'),
                        value: 'Tutar',
                    },
                    {
                        text: this.$t('Currency-Amount'),
                        value: 'DovizTutar',
                    },
                    {
                        text: this.$t('VAT-Percentage-v2'),
                        value: 'KdvYuzde',
                    },
                    {
                        text: this.$t('VAT-Amount'),
                        value: 'KdvTutar',
                    },
                    {
                        text: this.$t('Type'),
                        value: 'Tip',
                    },
                    {
                        text: this.$t('Discount-Percentage'),
                        value: 'IskontoYuzde',
                    },
                    {
                        text: this.$t('Process'),
                        value: '',
                    }
                ],
                gibserigoster: true,
                autocomplete: 'autocomplete',
                drawer: null,
                baslik: '',
                e1: 0,
                Code: '',
                e2: true,
                yok: false,
                statesecili: [{
                    Kod: 'Kod',
                    Unvan: 'Unvan',
                    newProp: 'Kod' + ' - ' + 'Unvan'
                }],
                statecari: [],
                secilensatirno: -1,
                search3: '',
                search1: '',
                loading: false,
                caritext: '',
                cariid: '',
                aktifdate: false,
                nefaturasi: 'serbest',
    
                SerbestFatura: {
                    SirketKodu: '',
                    SerbestFaturaDetay: [],
                    Serbest: true,
                    AlisSatis: false,
                    FaturaSeri: '',
                    FaturaNo: '',
                    Update: false,
                    FaturaTip: 0, // 0 : Satış faturası , 1 : Iade Faturası
                    Evrak: {
                        Evrakkod: ''
                    },
                    Cari: {
                        Kod: ''
                    },
                    EFaturaBilgi: {
                        Unvani: '',
                        Unvani2: '',
                        Adres1: '',
                        Adres2: '',
                        IlceSehir: '',
                        Email: '',
                        VergiDairesi: '',
                        VergiNo: '',
                        TcKimlikNo: '',
                        Adi: '',
                        Soyadi: '',
                        TUnvani: '',
                        DigerAdi: '',
                        OnAdiEki: '',
                    },
                    Tarih: null,
                    GibSeri: '',
                    Vade: null,
                    Referans: {
                        Kod: ''
                    },
                    Masraf: {
                        Code: ''
                    },
                    Aciklama: '',
                    Doviz: {
                        DovizKod: ''
                    },
                    Kur: 0,
                    TevkivatKdv: 0,
                    FaturaID: 0,
                    CariAktarma: false,
                    Tutarlar: {
                        ToplamTutar: 0,
                        Iskonto: 0,
                        FaturaToplam: 0,
                        Kdv: 0,
                        TevkifatKdv: 0
                    },
                    Efaturakayit: false,
                    Earchiveakayit: false,
                    Kagitfatura: false,
                    EarsivBilgi: {
                        GonderimSekli: '',
                        InternetSatis: '',
                        pWebAdresi: '',
                        OdemeSekli: '',
                        OdemeSekliAciklama: '',
                        OdemeAraci: '',
                        OdemeTarihi: ''
                    },
                    EFaturaShowID: {
                        EFaturaID: null,
                        EFaturaGuid: null,
                        FaturaStatus: null,
                        PdfID: null,
                        DizaynID: null,
                        XsltID: null
    
                    }
                },
    
                SerbestFaturaDetayList: [],
    
                SerbestFaturaDetay: {
                    MuhasebeKodu: '',
                    Aciklama: '',
                    LineNote: '',
                    Referans: {
                        Kod: ''
                    },
                    Masraf: {
                        Code: ''
                    },
                    Miktar: 0,
                    Birim: '',
                    BirimFiyat: 0,
                    Tutar: 0,
                    DovizTutar: 0,
                    IskontoYuzde: 0,
                    IskontoTutar: 0,
                    KdvTip: 'D',
                    KdvYuzde: 0,
                    KdvTutar: 0,
                    KdvMuhKodu: '',
                    IskMuhKodu: '',
                    KdvKodu: '',
                    IstisnaKodu: '',
                    TevkifatKodu: '',
                    Tip: '',
                    TevkifatDetayTutar: 0,
                    TevkifatDetayOran: 0,
    
                    TeslimBilgileri: {
                        SokakAdi: '',
                        BinaAdi: '',
                        BinaNo: '',
                        TeslimSehir: '',
                        TeslimPostaKodu: '',
                        TeslimUlke: '',
                        TeslimSarti: '',
                        GTIPNo: '',
                        TransferKodu: '',
                        KabinNo: '',
                        KabinAdedi: '',
                        KabinCinsi: '',
                        TeslimOdeme: ''
                    }
    
                },
    
                SerbestFaturaToplamTutarBilgileri: {
                    ToplamTutar: 0,
                    Iskonto: 0,
                    FaturaToplam: 0,
                    Kdv: 0,
                    TevkifatKdv: 0
                },
    
                birim: [{
                        text: 'adet',
                        value: 'adet'
                    },
                    {
                        text: 'kilo',
                        value: 'kilo'
                    }, {
                        text: this.$t('gram'),
                        value: 'gram'
                    }, {
                        text: this.$t('meter'),
                        value: 'metre'
                    },
                    {
                        text: 'litre',
                        value: 'litre'
                    },
                    {
                        text: 'm2',
                        value: 'm2'
                    },
                    {
                        text: 'dm2',
                        value: 'dm2'
                    },
                    {
                        text: 'm3',
                        value: 'm3'
                    },
                ],
                faturatipi: [{
                        text: this.$t('Sales-Invoice'),
                        value: 0
                    },
                    {
                        text: this.$t('Return-Invoice'),
                        value: 1
                    }
                ],
                gonderimsekli: [{
                        text: this.$t('Paper'),
                        value: 0
                    },
                    {
                        text: this.$t('Electronic'),
                        value: 1
                    }
                ],
    
                odemesekli: [{
                        text: this.$t('Normal-Sales'),
                        value: 0
                    },
                    {
                        text: this.$t('Internet-Sales'),
                        value: 1
                    }
                ],
                seridisable: false,
                faturagosterbtn: false,
                date: null,
                menu: false,
                modal: false,
                dateFormatted: '',
    
                datearsiv: null,
                menuarsiv: false,
                modalarsiv: false,
                dateFormattedarsiv: '',
                yedeksatirkayit: {
                    Tutar: 0,
                    Kdv: 0,
                    Tevkifat: 0,
                    iskonto: 0
                },
                date2: null,
                menu2: false,
                dateFormatted2: '',
                modal2: false,
                ihracat: false,
                progress: false,
                satirdialog: false,
    
                gibseri: [],
                satiritems: [],
                referaslist: [],
                EvrakTipi1: [],
                kdvtipi: [{
                        text: 'D',
                        value: 'D'
                    },
                    {
                        text: 'H',
                        value: 'H'
                    }
                ],
                Tevkifat: [{
                        text: '0/10',
                        value: '0'
                    },
                    {
                        text: '1/10',
                        value: '0.1'
                    },
                    {
                        text: '2/10',
                        value: '0.2'
                    },
                    {
                        text: '3/10',
                        value: '0.3'
                    },
                    {
                        text: '4/10',
                        value: '0.4'
                    },
                    {
                        text: '5/10',
                        value: '0.5'
                    },
                    {
                        text: '6/10',
                        value: '0.6'
                    },
                    {
                        text: '7/10',
                        value: '0.7'
                    },
                    {
                        text: '8/10',
                        value: '0.8'
                    },
                    {
                        text: '9/10',
                        value: '0.9'
                    },
                    {
                        text: '10/10',
                        value: '1'
                    }
                ],
    
                odemesekli1: [{
                        text: this.$t('Credit-Debit-Card'),
                        value: '0'
                    },
                    {
                        text: 'EFT-' + this.$t('Transfer-v3'),
                        value: '1'
                    },
                    {
                        text: this.$t('Cash-on-delivery'),
                        value: '2'
                    },
                    {
                        text: this.$t('Payment-Intermediary'),
                        value: '3'
                    },
                    {
                        text: this.$t('Other'),
                        value: '4'
                    }
                ],
    
                transferkodu: [{
                        text: this.$t('Seaways'),
                        value: '1'
                    },
                    {
                        text: this.$t('Railway'),
                        value: '2'
                    },
                    {
                        text: this.$t('Highway'),
                        value: '3'
                    },
                    {
                        text: this.$t('Airline'),
                        value: '4'
                    },
                    {
                        text: this.$t('Post'),
                        value: '5'
                    },
                    {
                        text: this.$t('Multiple-Vehicles'),
                        value: '6'
                    },
                    {
                        text: this.$t('Fixed-Transportation-Complexes'),
                        value: '7'
                    },
                    {
                        text: this.$t('Territorial-Water-Transportation'),
                        value: '8'
                    }
                ],
    
                teslimodeme: [{
                        text: 'Instrument not defined',
                        value: 1
                    },
                    {
                        text: 'Automated clearing house credit',
                        value: 2
                    },
                    {
                        text: 'Automated clearing house debit',
                        value: 3
                    },
                    {
                        text: 'ACH demand debit reversal',
                        value: 4
                    },
                    {
                        text: 'ACH demand credit reversal',
                        value: 5
                    },
                    {
                        text: 'ACH demand credit',
                        value: 6
                    },
                    {
                        text: 'ACH demand debit',
                        value: 7
                    },
                    {
                        text: 'Hold',
                        value: 8
                    },
                    {
                        text: 'National or regional clearing',
                        value: 9
                    },
                    {
                        text: 'In cash',
                        value: 10
                    },
                    {
                        text: 'ACH savings credit reversal',
                        value: 11
                    },
                    {
                        text: 'ACH savings debit reversal',
                        value: 12
                    },
                    {
                        text: 'ACH savings credit',
                        value: 13
                    },
                    {
                        text: 'ACH savings debit',
                        value: 14
                    },
                    {
                        text: 'Bookentry credit',
                        value: 15
                    },
                    {
                        text: 'Bookentry debit',
                        value: 16
                    },
                    {
                        text: 'ACH demand cash concentration/disbursement (CCD) credit',
                        value: 17
                    },
                    {
                        text: 'ACH demand cash concentration/disbursement (CCD) debit',
                        value: 18
                    },
                    {
                        text: 'ACH demand corporate trade payment (CTP) credit',
                        value: 19
                    },
                    {
                        text: 'Cheque',
                        value: 20
                    },
                    {
                        text: 'Bankers draft',
                        value: 21
                    },
                    {
                        text: 'Certified bankers draft',
                        value: 22
                    },
                    {
                        text: 'Bank cheque (issued by a banking or similar establishment)',
                        value: 23
                    },
                    {
                        text: 'Certified cheque',
                        value: 25
                    },
                    {
                        text: 'Local cheque',
                        value: 26
                    },
                    {
                        text: 'ACH demand corporate trade payment (CTP) debit',
                        value: 27
                    },
                    {
                        text: 'ACH demand corporate trade exchange (CTX) credit',
                        value: 28
                    },
                    {
                        text: 'ACH demand corporate trade exchange (CTX) debit',
                        value: 29
                    },
                    {
                        text: 'Credit transfer',
                        value: 30
                    },
                    {
                        text: 'Debit transfer',
                        value: 31
                    },
                    {
                        text: 'ACH demand cash concentration/disbursement plus (CCD+)',
                        value: 32
                    },
                    {
                        text: 'ACH demand cash concentration/disbursement plus (CCD+)',
                        value: 33
                    },
                    {
                        text: 'ACH prearranged payment and deposit (PPD)',
                        value: 34
                    },
                    {
                        text: ' ACH savings cash concentration/disbursement (CCD) credit',
                        value: 35
                    },
                    {
                        text: 'ACH savings cash concentration/disbursement (CCD) debit',
                        value: 36
                    },
                    {
                        text: 'ACH savings corporate trade payment (CTP) credit',
                        value: 37
                    },
                    {
                        text: 'ACH savings corporate trade payment (CTP) debit',
                        value: 38
                    },
                    {
                        text: 'ACH savings corporate trade exchange (CTX) credit',
                        value: 39
                    },
                    {
                        text: 'ACH savings corporate trade exchange (CTX) debit',
                        value: 40
                    },
                    {
                        text: 'ACH savings cash concentration/disbursement plus (CCD+)',
                        value: 41
                    },
                    {
                        text: 'Payment to bank account',
                        value: 42
                    },
                    {
                        text: 'ACH savings cash concentration/disbursement plus (CCD+)',
                        value: 43
                    },
                    {
                        text: 'Accepted bill of exchange',
                        value: 44
                    },
                    {
                        text: 'Referenced home-banking credit transfer',
                        value: 45
                    },
                    {
                        text: 'Interbank debit transfer',
                        value: 46
                    },
                    {
                        text: 'Home-banking debit transfer',
                        value: 47
                    },
                    {
                        text: 'Bank card',
                        value: 48
                    },
                    {
                        text: 'Direct debit',
                        value: 49
                    },
                    {
                        text: 'Payment by postgiro',
                        value: 50
                    },
                    {
                        text: 'Promissory note',
                        value: 60
                    },
                    {
                        text: '61    Promissory note signed by the debtor',
                        value: 61
                    },
                    {
                        text: 'Promissory note signed by the debtor and endorsed by a bank',
                        value: 62
                    },
                    {
                        text: 'Promissory note signed by the debtor and endorsed by a',
                        value: 63
                    },
                    {
                        text: ' Promissory note signed by a bank',
                        value: 64
                    },
                    {
                        text: 'Promissory note signed by a bank and endorsed by another',
                        value: 65
                    },
                    {
                        text: 'Promissory note signed by a third party',
                        value: 66
                    },
                    {
                        text: 'Promissory note signed by a third party and endorsed by a',
                        value: 67
                    },
                    {
                        text: 'Bill drawn by the creditor on the debtor',
                        value: 70
                    },
                    {
                        text: 'Bill drawn by the creditor on a bank',
                        value: 74
                    },
                    {
                        text: 'Bill drawn by the creditor, endorsed by another bank',
                        value: 75
                    },
                    {
                        text: 'Bill drawn by the creditor on a bank and endorsed by a',
                        value: 76
                    },
                    {
                        text: 'Bill drawn by the creditor on a third party',
                        value: 77
                    },
                    {
                        text: 'Bill drawn by creditor on third party, accepted and',
                        value: 78
                    },
                    {
                        text: 'Not transferable banker s draft',
                        value: 91
                    },
                    {
                        text: 'Not transferable local cheque',
                        value: 92
                    },
                    {
                        text: 'Reference giro',
                        value: 93
                    },
                    {
                        text: 'Urgent giro',
                        value: 94
                    },
                    {
                        text: 'Free format giro',
                        value: 95
                    },
                    {
                        text: 'Requested method for payment was not used',
                        value: 96
                    },
                    {
                        text: 'Clearing between partners',
                        value: 97
                    }
    
                ],
    
    
                islembilgileri: [{
                        text: this.$t('Hard-Copy-Invoice'),
                        value: 'false'
                    },
                    {
                        text: this.$t('Electronic-Invoice'),
                        value: 'true'
                    }
                ],
    
                doviztipi: [],
                webadresleri: [],
                odemesekilleri: [],
                odemearaci: [],
                dizayn: null,
    
                ichattipi: [
                    'D', 'D-', 'D+', 'K', 'K-', 'K+', 'U', 'U-', 'U+', 'L', 'L-', 'L+'
                ],
    
                evethayir: [{
                        text: 'Evet',
                        value: 'E'
                    },
                    {
                        text: 'Hayır',
                        value: 'H'
                    },
                ],
    
                cmkodu: [
                    'C', 'M'
                ],
                dizaynsec: [],
                xsltitems: [],
                masrafmerkezi: [],
                dictionary: {
                    custom: {
                        carikod: {
                            required: () => this.$t('This-space-cannot-left-blank'),
                        },
                        unvan: {
                            required: () => this.$t('This-space-cannot-left-blank'),
                        },
                        faturaseri: {
                            required: () => this.$t('This-space-cannot-left-blank'),
                        },
                        faturano: {
                            required: () => this.$t('This-space-cannot-left-blank'),
                        },
    
                        dizayn: {
                            required: () => this.$t('This-space-cannot-left-blank'),
                        },
                        xslt: {
                            required: () => this.$t('This-space-cannot-left-blank'),
                        },
                        gtip: {
                            min: () => this.$t('Must-least-4-digits'),
                        }
    
                    }
                },
                sayfabaslik: 'Rezervasyon',
                satirguncellebuton: false,
                satirkaydetbuton: true,
                StartDate: null,
                EndDate: null,
                NumberOfPolicies: '',
                PolicySum: '',
                TotalDebt: '',
                TotalFlatDebt: '',
                kaydetbuton: true,
                guncellebuton: false,
                silbuton: false,
                detaytevkifat: true,
                text1: '',
                denemevalue: 0,
    
                biletlerfaturalanmasin: null,
                efaturamukellefi: null,
                loadingdialog: false,
                Kdvmuaf: null,
                ciktiistemiyor: null,
                musteribilgitipi: null,
                profilzorunlu: null,
                eventidzorunlu: null,
                snackbar: false,
                y: 'top',
                x: 'right',
                mode: '',
                timeout: 6000,
                carikod: '',
                unvan: '',
                active: '',
                ex11: 'false',
                dialogearsiv: false,
                earsivdurum: false,
                guidim: null,
                idim: null,
                faturadialog: false,
                kredilimiti: 0,
                dizaynIdget: null,
                xsltIdget: null,
                faturasilbtn: false,
                satirsilbtn: false,
                islemturu: null,
                dialogdegistir: false,
                ChangeTarih: null,
                ChangeFaturaNo: null,
    
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.prevRoute = from.path
            })
        },
        getSaticilar()
        {
          var prm = {
            id: "",
            kod: "",
            aciklama: "",
            tip: 4,
            YurtIcDis:2,
          };
          tool.http_post(this, 'SaticiAra', prm).then(
            response => {
              this.saticiItems = [];
              for (var i = 0; i < response.body.length; i++) {
                this.saticiItems.push({
                  id: response.body[i].id,
                  isim: response.body[i].isim,
                  KDV:response.body[i].KDV,
                  kod: response.body[i].kod,
                  CariKod:response.body[i].CariKod,
                  YurtIci_YurtDisi:response.body[i].YurtIci_YurtDisi,
                 
                });
              }
    
              
            },
            response => {
              // this.status = tool.responseToStatus(response);
            }
          );
        },
        mounted() {
    
            this.$validator.localize('en', this.dictionary)
    
            this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
            this.sayfayetki.Status=true;
            this.sayfayetki.Screen=true;
            this.sayfayetki.Save=true;
            this.sayfayetki.Update=true;
            if (this.sayfayetki.Status == true) {
    
                this.guncellebuton = false
    
                this.mountedShortcut();
   
            } else {
    
                this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {
    
                    if (sonuc == true) {
    
                        if (this.prevRoute != null) {
                            let url = '#' + this.prevRoute
                            window.open(url, '_self')
                        } else {
                            let url = '#/'
                            window.open(url, '_self')
                        }
                    } 
    
                });
    
            }
    
        },
        filters: {
            dateformat: function (t) {
                return helpers.dateformat(t);
            },
            moneyformat: function (m) {
                return helpers.moneyformat(m);
            },
    
            bakiyekontrol: function (m) {
                return helpers.bakiyekontrol(m);
            },
            currencyformat: function (t) {
                return helpers.currencyformat(t);
            },
        },
        created() {
            if (this.$route.query.islem == "hrget") {
                this.steppervmodel = this.step.rezKalemleri
            }
        },
        methods: {
            getSaticilar()
        {
          var prm = {
            id: "",
            kod: "",
            aciklama: "",
            tip: 4,
            YurtIcDis:0,
          };
          tool.http_post(this, 'SaticiAra', prm).then(
            response => {
              this.saticiItems = [];
              for (var i = 0; i < response.body.length; i++) {
                this.saticiItems.push({
                  id: response.body[i].id,
                  isim: response.body[i].isim,
                  KDV:response.body[i].KDV,
                  kod: response.body[i].kod,
                  CariKod:response.body[i].CariKod,
                  YurtIci_YurtDisi:response.body[i].YurtIci_YurtDisi,
                 
                });
              }
    
              
            },
            response => {
              // this.status = tool.responseToStatus(response);
            }
          );
        },
          mountedShortcut(){
            if (this.$route.query.islem == "yeni") {
                    this.sayfabaslik = 'Rezervasyon Ekle'
    
                } else if (this.$route.query.islem == "get") {
    
                    this.sayfabaslik = 'Rezervasyon Güncelle'
                    let params = {
                        TakipNo: this.$route.query.TakipNo
                    }
                    this.loadingvmodel = true
                    tool.http_post(this, "MiceLoad", params).then(
                        response => {
                            
                            if (response.body.Status == true) {
                                this.guncellebuton = true
                                this.loadingvmodel = false
                                this.kalemData.Rez = response.body.data
                                this.kalemData.Rez.opsiyonSaati = helpers.getTime(response.body.data.opsiyonSaati)
                                
                                var statecariyeni = [{
                                    unvan1:'',// response.body.data.cariKod.isim,
                                    id: 0//response.body.data.cariKod.kod
                                }]
                                this.statecari = statecariyeni
    
                            } else {
                                this.loadingvmodel = false
                                this.text1 = response.body.ErrorList[0]
                                this.snackbar = true
                            }
                        },
                        response => {
                            this.HataYonetimi(response, params, 'Rezervasyon Getirilemedi');
                        }
                    );
                } else if (this.$route.query.islem == "hrget" || this.$route.query.islem == "hryeni") {
    
                    this.sayfabaslik = 'Rezervasyon Ekle'
    
                    var hrrez = JSON.parse(window.localStorage.getItem('hrrezervasyon'));
    
                    //kişileri ekleyelim
                    if (hrrez != null) {
    
                        if (this.$route.query.islem == "hrget") {
    
                            this.kalemData.Rez = hrrez.Rezervasyon
    
                            var kisisira = []
    
                            hrrez.AdresBilgileri.forEach(element => {
    
                                var yas = 0
    
                                if (element.BirthDate != null) {
                                    var dogumyili = new Date(element.BirthDate)
                                    yas = helpers.getYear() - dogumyili.getFullYear()
                                } else {
                                    yas = 0
                                }
    
                                var yenikayit = {
                                    id: null,
                                    kisiTip: element.tip,
                                    kisiSira: this.kalemData.Rez.adresler.length - 1,
                                    yas: yas,
                                    profilId: null,
                                    sicilId: null,
                                    
                                    tcKimlikNo: element.TcKimlikNo,
                                    uyeNo: null,
                                    adSoyad: element.Ad + ' ' + element.Soyad,
                                    adres: hrrez.HotelRuner.Address,
                                    dogumTarihi: element.dogumTarihi,
                                    cinsiyet: null,
                                    telefon1: hrrez.HotelRuner.Phone,
                                    gsm: hrrez.HotelRuner.Phone,
                                    eMail: hrrez.HotelRuner.Mail,
                                    kisiTableRef: null,
                                    kod: null
                                }
    
                                this.kalemData.Rez.adresler.push(yenikayit)
    
                                kisisira.push(this.kalemData.Rez.adresler.length - 1)
    
                            });
    
                            var yenikalem = {
                                saticiEntegrasyon: {
                                    SaticiTipi: 1,
                                    Kod: hrrez.SaticiBilgileri.Kod,
                                    Isim: hrrez.SaticiBilgileri.Isim,
                                    Adres: hrrez.SaticiBilgileri.Adres,
                                    PK: hrrez.SaticiBilgileri.PK,
                                    Ulke: hrrez.SaticiBilgileri.Ulke,
                                    Sehir: hrrez.SaticiBilgileri.Sehir,
                                    Yer: hrrez.SaticiBilgileri.Yer,
                                    SaticiKonumu: hrrez.SaticiBilgileri.SaticiKonumu,
                                    Yetkili: hrrez.SaticiBilgileri.Yetkili,
                                    Web: hrrez.SaticiBilgileri.Web,
                                    HavaAlani: hrrez.SaticiBilgileri.HavaAlani,
                                    VDaire: hrrez.SaticiBilgileri.VDaire,
                                    VNo: hrrez.SaticiBilgileri.VNo,
                                    Tel1: hrrez.SaticiBilgileri.Tel1,
                                    Tel2: hrrez.SaticiBilgileri.Tel2,
                                    Fax: hrrez.SaticiBilgileri.Fax,
                                    Teleks: hrrez.SaticiBilgileri.Teleks,
                                    Email: hrrez.SaticiBilgileri.Email,
                                    GSM: hrrez.SaticiBilgileri.GSM,
                                    Ic_Dis: hrrez.SaticiBilgileri.Ic_Dis,
                                    Aciklamalar: hrrez.SaticiBilgileri.Aciklamalar,
                                },
                                entTip: 1,
                                entId: hrrez.RezervasyonID,
                                islemRef: 0,
                                donem1: hrrez.HotelRuner.StartDate,
                                donem2: hrrez.HotelRuner.EndDate,
                                satis: {
                                    KDVOran: 0
                                },
                                alis: {
                                    KDVOran: 0
                                },
                                komisyon: {
                                    KDVOran: 0,
                                    tutar: 0
                                },
                                acenteKomisyon: {
                                    paraBirimi: null,
                                    kur: 0,
                                    tutar: 0,
                                    KDVOran: 0
                                },
                                iskonto: {
                                    oran: 0,
                                    tutar: 0,
                                    iskontoSebebi: null,
                                },
                                odeyenTaraf: 1,
                                aciklama: hrrez.HotelRuner.Message,
                                tedarikciAciklama: 'Hotel Runner Otel Satışı',
                                turOperatoru: {
                                    id: null,
                                    kod: null,
                                    isim: null,
                                    isimAra: null,
                                },
                                departman: {
                                    id: null,
                                    kod: null,
                                    isim: null,
                                    isimAra: null,
                                },
                                kdvID: {
                                    id: null,
                                    kod: null,
                                    isim: null,
                                    isimAra: null
                                },
                                kdvMuafiyetID: {
                                    id: null,
                                    kod: null,
                                    isim: null,
                                    isimAra: null
                                },
                                entegrasyonKodu: null,
                                maliyetCariKod: {
                                    id: null,
                                    kod: null,
                                    isim: null,
                                    tip: null
                                },
                                saticiTip: 1,
                                kisiSira: kisisira,
    
                                yet_Satis: parseFloat(hrrez.HotelRuner.RoomDetail.ArkmanPrice),
                                co1_Satis: 0,
                                co2_Satis: 0,
                                co3_Satis: 0,
                                co4_Satis: 0,
                                ekY_Satis: 0,
    
                                yet_Alis: parseFloat(hrrez.OtelInfo.ServicePrice),
                                co1_Alis: 0,
                                co2_Alis: 0,
                                co3_Alis: 0,
                                co4_Alis: 0,
                                ekY_Alis: 0,
    
                                yet_KisiSayisi: kisisira.length,
                                co1_KisiSayisi: 0,
                                co2_KisiSayisi: 0,
                                co3_KisiSayisi: 0,
                                co4_KisiSayisi: 0,
                                ekY_KisiSayisi: 0,
    
                                satici: {
                                    id: -1,
                                    kod: hrrez.SaticiBilgileri.Kod,
                                    isim: hrrez.SaticiBilgileri.Isim,
                                    tip: 1,
                                    YurtIci_YurtDisi: hrrez.SaticiBilgileri.IcDis,
                                },
                                alisPara: {
                                    paraBirimi: this.hrgetkur(hrrez.HotelRuner.CurrencyType),
                                    kur: hrrez.OtelBilgi.CurrencyValue,
                                    kurTarihi: null,
                                },
                                satisPara: {
                                    paraBirimi: this.hrgetkur(hrrez.HotelRuner.CurrencyType),
                                    kur: hrrez.OtelBilgi.CurrencyValue,
                                    kurTarihi: null,
                                },
                                komisyonPara: {
                                    paraBirimi: this.hrgetkur(hrrez.HotelRuner.CurrencyType),
                                    kur: hrrez.OtelBilgi.CurrencyValue,
                                    kurTarihi: null,
                                },
                                komisyonYuzdeTip: 0,
                                komisyonYuzde: 0,
                                komisyonTutar: 0,
                                P_RP: 'R',
                                masrafMerkezi: {
                                    id: null,
                                    kod: null,
                                    isim: null,
                                    tip: null
                                },
                                kalemOtel: {
                                    odaTipi: {
                                        id: null,
                                        kod: null,
                                        isim: null,
                                        tip: null
                                    },
                                    pansiyon: 0,
                                    girisSaati: hrrez.OtelBilgi.CheckInTime,
                                    konum: null,
                                    RP: 'T',
                                    odaSayi: 1,
                                    kontenjan: false,
                                    freeKisi: 0,
                                    fiyatKodu: {
                                        id: null,
                                        kod: null,
                                        isim: null,
                                        tip: null
                                    }
                                },
                                kalemArac: null,
                                kalemDiger: null,
                                kalemRentACar: null,
                                kalemVize: null,
                                kalemSigorta: null,
                                kalemGemi: null,
                                kalemRehber: null,
                                kalemAcente: null,
                                kalemCharter: null
                            }
                        } else {
    
                            var kisisira = []
                            hrrez.AdresBilgileri.forEach(element => {
    
                                var yas = 0
    
                                if (element.dogumTarihi != null) {
                                    var dogumyili = new Date(element.dogumTarihi)
                                    yas = helpers.getYear() - dogumyili.getFullYear()
                                } else {
                                    yas = 0
                                }
    
                                var yenikayit = {
                                    id: null,
                                    kisiTip: element.tip,
                                    kisiSira: this.kalemData.Rez.adresler.length - 1,
                                    yas: yas,
                                    profilId: null,
                                    sicilId: null,
                                    
                                    tcKimlikNo: element.TcKimlikNo,
                                    uyeNo: null,
                                    adSoyad: element.Ad + ' ' + element.Soyad,
                                    adres: hrrez.HotelRuner.Address,
                                    dogumTarihi: element.dogumTarihi,
                                    cinsiyet: null,
                                    telefon1: hrrez.HotelRuner.Phone,
                                    gsm: hrrez.HotelRuner.Phone,
                                    eMail: hrrez.HotelRuner.Mail,
                                    kisiTableRef: null,
                                    kod: null
                                }
    
                                this.kalemData.Rez.adresler.push(yenikayit)
    
                                kisisira.push(this.kalemData.Rez.adresler.length - 1)
    
                            });
    
                            this.kalemData.Rez.cariKod.kod = hrrez.CariKodu
                          
                            var runnerOtel = {
                                saticiEntegrasyon: {
                                    SaticiTipi: 1,
                                    Kod: hrrez.SaticiBilgileri.Kod,
                                    Isim: hrrez.SaticiBilgileri.Isim,
                                    Adres: hrrez.SaticiBilgileri.Adres,
                                    PK: hrrez.SaticiBilgileri.PK,
                                    Ulke: hrrez.SaticiBilgileri.Ulke,
                                    Sehir: hrrez.SaticiBilgileri.Sehir,
                                    Yer: hrrez.SaticiBilgileri.Yer,
                                    SaticiKonumu: hrrez.SaticiBilgileri.SaticiKonumu,
                                    Yetkili: hrrez.SaticiBilgileri.Yetkili,
                                    Web: hrrez.SaticiBilgileri.Web,
                                    HavaAlani: hrrez.SaticiBilgileri.HavaAlani,
                                    VDaire: hrrez.SaticiBilgileri.VDaire,
                                    VNo: hrrez.SaticiBilgileri.VNo,
                                    Tel1: hrrez.SaticiBilgileri.Tel1,
                                    Tel2: hrrez.SaticiBilgileri.Tel2,
                                    Fax: hrrez.SaticiBilgileri.Fax,
                                    Teleks: hrrez.SaticiBilgileri.Teleks,
                                    Email: hrrez.SaticiBilgileri.Email,
                                    GSM: hrrez.SaticiBilgileri.GSM,
                                    Ic_Dis: hrrez.SaticiBilgileri.Ic_Dis,
                                    Aciklamalar: hrrez.SaticiBilgileri.Aciklamalar,
                                },
                                entTip: 1,
                                entId: hrrez.RezervasyonID,
                                islemRef: 0,
                                donem1: hrrez.HotelRuner.StartDate,
                                donem2: hrrez.HotelRuner.EndDate,
                                satis: {
                                    KDVOran: 0
                                },
                                alis: {
                                    KDVOran: 0
                                },
                                komisyon: {
                                    KDVOran: 0,
                                    tutar: 0
                                },
                                acenteKomisyon: {
                                    paraBirimi: null,
                                    kur: 0,
                                    tutar: 0,
                                    KDVOran: 0
                                },
                                iskonto: {
                                    oran: 0,
                                    tutar: 0,
                                    iskontoSebebi: null,
                                },
                                odeyenTaraf: 1,
                                aciklama: hrrez.HotelRuner.Message,
                                tedarikciAciklama: 'Hotel Runner Otel Satışı',
                                turOperatoru: {
                                    id: null,
                                    kod: null,
                                    isim: null,
                                    isimAra: null,
                                },
                                departman: {
                                    id: null,
                                    kod: null,
                                    isim: null,
                                    isimAra: null,
                                },
                                kdvID: {
                                    id: null,
                                    kod: null,
                                    isim: null,
                                    isimAra: null
                                },
                                kdvMuafiyetID: {
                                    id: null,
                                    kod: null,
                                    isim: null,
                                    isimAra: null
                                },
                                entegrasyonKodu: null,
                                maliyetCariKod: {
                                    id: null,
                                    kod: null,
                                    isim: null,
                                    tip: null
                                },
                                saticiTip: 1,
                                kisiSira: kisisira,
                                yet_Satis: parseFloat(hrrez.OtelBilgi.ArkmanPrice) + parseFloat(hrrez.OtelBilgi.MarkupPrice),
                                co1_Satis: 0,
                                co2_Satis: 0,
                                co3_Satis: 0,
                                co4_Satis: 0,
                                ekY_Satis: 0,
    
                                yet_Alis: parseFloat(hrrez.OtelBilgi.ArkmanPrice),
                                co1_Alis: 0,
                                co2_Alis: 0,
                                co3_Alis: 0,
                                co4_Alis: 0,
                                ekY_Alis: 0,
    
                                yet_KisiSayisi: kisisira.length,
                                co1_KisiSayisi: 0,
                                co2_KisiSayisi: 0,
                                co3_KisiSayisi: 0,
                                co4_KisiSayisi: 0,
                                ekY_KisiSayisi: 0,
    
                                satici: {
                                    id: -1,
                                    kod: hrrez.SaticiBilgileri.Kod,
                                    isim: hrrez.SaticiBilgileri.Isim,
                                    tip: 1,
                                    YurtIci_YurtDisi: hrrez.SaticiBilgileri.IcDis,
                                },
                                alisPara: {
                                    paraBirimi: this.hrgetkur(hrrez.HotelRuner.CurrencyType),
                                    kur: hrrez.OtelBilgi.CurrencyValue,
                                    kurTarihi: null,
                                },
                                satisPara: {
                                    paraBirimi: this.hrgetkur(hrrez.HotelRuner.CurrencyType),
                                    kur: hrrez.OtelBilgi.CurrencyValue,
                                    kurTarihi: null,
                                },
                                komisyonPara: {
                                    paraBirimi: this.hrgetkur(hrrez.HotelRuner.CurrencyType),
                                    kur: hrrez.OtelBilgi.CurrencyValue,
                                    kurTarihi: null,
                                },
                                komisyonYuzdeTip: 0,
                                komisyonYuzde: 0,
                                komisyonTutar: 0,
                                P_RP: 'R',
                                masrafMerkezi: {
                                    id: null,
                                    kod: null,
                                    isim: null,
                                    tip: null
                                },
                                kalemOtel: {
                                    odaTipi: {
                                        id: null,
                                        kod: null,
                                        isim: null,
                                        tip: null
                                    },
                                    pansiyon: 0,
                                    girisSaati: hrrez.OtelBilgi.CheckInTime,
                                    konum: null,
                                    RP: 'T',
                                    odaSayi: 1,
                                    kontenjan: false,
                                    freeKisi: 0,
                                    fiyatKodu: {
                                        id: null,
                                        kod: null,
                                        isim: null,
                                        tip: null
                                    }
                                },
                                kalemArac: null,
                                kalemDiger:null,
                                kalemRentACar: null,
                                kalemVize: null,
                                kalemSigorta: null,
                                kalemGemi: null,
                                kalemRehber: null,
                                kalemAcente: null,
                                kalemCharter: null
                            }
    
    
                             if(hrrez.SaticiBilgileri.Ic_Dis == 2){
                                var runnerDiger = {
                                saticiEntegrasyon: {
                                    SaticiTipi: 10,
                                    Kod: "RUNNERYURTDISI",
                                    Isim: "RUNNER YURT DISI",
                                    Adres: "",
                                    PK: "",
                                    Ulke: "",
                                    Sehir: "",
                                    Yer: "",
                                    SaticiKonumu: "",
                                    Yetkili: "",
                                    Web: "",
                                    HavaAlani: "",
                                    VDaire: "",
                                    VNo: "",
                                    Tel1: "",
                                    Tel2: "",
                                    Fax: "",
                                    Teleks: "",
                                    Email: "",
                                    GSM: "",
                                    Ic_Dis: hrrez.SaticiBilgileri.Ic_Dis,
                                    Aciklamalar: "Hotel Runner Yurt Dışı Otel Satışı",
                                },
                                entTip: 1,
                                entId: hrrez.RezervasyonID,
                                islemRef: 0,
                                donem1: hrrez.HotelRuner.StartDate,
                                donem2: hrrez.HotelRuner.EndDate,
                                satis: {
                                    KDVOran: 18
                                },
                                alis: {
                                    KDVOran: 0
                                },
                                komisyon: {
                                    KDVOran: 0,
                                    tutar: 0
                                },
                                acenteKomisyon: {
                                    paraBirimi: null,
                                    kur: 0,
                                    tutar: 0,
                                    KDVOran: 0
                                },
                                iskonto: {
                                    oran: 0,
                                    tutar: 0,
                                    iskontoSebebi: null,
                                },
                                odeyenTaraf: 1,
                                aciklama: hrrez.HotelRuner.Message,
                                tedarikciAciklama: 'Hotel Runner Yurtdışı Otel Satışı',
                                turOperatoru: {
                                    id: null,
                                    kod: null,
                                    isim: null,
                                    isimAra: null,
                                },
                                departman: {
                                    id: null,
                                    kod: null,
                                    isim: null,
                                    isimAra: null,
                                },
                                kdvID: {
                                    id: null,
                                    kod: null,
                                    isim: null,
                                    isimAra: null
                                },
                                kdvMuafiyetID: {
                                    id: null,
                                    kod: null,
                                    isim: null,
                                    isimAra: null
                                },
                                entegrasyonKodu: null,
                                maliyetCariKod: {
                                    id: null,
                                    kod: null,
                                    isim: null,
                                    tip: null
                                },
                                saticiTip: 10,
                                kisiSira: kisisira,
                                yet_Satis: parseFloat(hrrez.OtelBilgi.MarkupPrice),
                                co1_Satis: 0,
                                co2_Satis: 0,
                                co3_Satis: 0,
                                co4_Satis: 0,
                                ekY_Satis: 0,
    
                                yet_Alis: 0,
                                co1_Alis: 0,
                                co2_Alis: 0,
                                co3_Alis: 0,
                                co4_Alis: 0,
                                ekY_Alis: 0,
    
                                yet_KisiSayisi: kisisira.length,
                                co1_KisiSayisi: 0,
                                co2_KisiSayisi: 0,
                                co3_KisiSayisi: 0,
                                co4_KisiSayisi: 0,
                                ekY_KisiSayisi: 0,
                                satici: {
                                    id: -1,
                                    kod: "RUNNERYURTDISI",
                                    isim: "RUNNER YURT DISI",
                                    tip: 10,
                                    YurtIci_YurtDisi: 2,
                                },
                                alisPara: {
                                    paraBirimi: this.hrgetkur(hrrez.HotelRuner.CurrencyType),
                                    kur: hrrez.OtelBilgi.CurrencyValue,
                                    kurTarihi: null,
                                },
                                satisPara: {
                                    paraBirimi: this.hrgetkur(hrrez.HotelRuner.CurrencyType),
                                    kur: hrrez.OtelBilgi.CurrencyValue,
                                    kurTarihi: null,
                                },
                                komisyonPara: {
                                    paraBirimi: this.hrgetkur(hrrez.HotelRuner.CurrencyType),
                                    kur: hrrez.OtelBilgi.CurrencyValue,
                                    kurTarihi: null,
                                },
                                komisyonYuzdeTip: 0,
                                komisyonYuzde: 0,
                                komisyonTutar: 0,
                                P_RP: 'R',
                                masrafMerkezi: {
                                    id: null,
                                    kod: null,
                                    isim: null,
                                    tip: null
                                },
                                kalemOtel: null,
                                kalemArac: null,
                                kalemDiger: {
                                    isAciklama: "YURT DIŞI OTEL HİZMET BEDELİ",
                                    Satici: "", 
                                    IsKodu: null,
                                    Bolge: null,
                                    Saat: null,
                                    DeadLine: null,
                                    PaketDisi: null
                                },
                                kalemRentACar: null,
                                kalemVize: null,
                                kalemSigorta: null,
                                kalemGemi: null,
                                kalemRehber: null,
                                kalemAcente: null,
                                kalemCharter: null
                            }
    
                            this.kalemData.Rez.kalemler.push(runnerDiger);
    
                             }
    
                        }
    
                        this.kalemData.Rez.kalemler.push(runnerOtel)
                        this.rezervasyonKaydet(this.step.rezKalemleri, this.kalemData.Rez);
    
                    } else {
                        this.text1 = this.$t('You-being-redirected-reservation-page-wrong-process')
                        this.snackbar = true
    
                        setTimeout(function () {
    
                                var link = '#/coper/rezervasyon/rezervasyonlistesi'
                                window.open(link, '_self');
                            }
    
                            .bind(this), 5000)
                    }
    
                } else if (this.$route.query.islem == "hredit") {
    
                    this.sayfabaslik = 'Rezervasyon Düzenle'
    
                    var hrrez = JSON.parse(window.localStorage.getItem('hrrezervasyon'));
    
                    if (hrrez != null) {
    
                        this.kalemData.Rez = hrrez.Rezervasyon
    
                        var kisisira = []
    
                        hrrez.AdresBilgileri.forEach(element => {
    
                            var indexx = this.kalemData.Rez.adresler.map(function (e) {
                                return e.id;
                            }).indexOf(element.CoperKisiID);
    
                            if (indexx != -1) {
                                //düzenlenen kayıt bizim listede var ise
    
                                var yas = 0
    
                                if (element.dogumTarihi != null) {
                                    var dogumyili = new Date(element.dogumTarihi)
                                    yas = helpers.getYear() - dogumyili.getFullYear()
                                } else {
                                    yas = 0
                                }
    
                                var yenikayit = {
                                    id: element.CoperKisiID,
                                    kisiTip: element.tip,
                                    kisiSira: this.kalemData.Rez.adresler[indexx].kisiSira,
                                    yas: yas,
                                    profilId: this.kalemData.Rez.adresler[indexx].profilId,
                                    sicilId: this.kalemData.Rez.adresler[indexx].sicilId,
                                    
                                    tcKimlikNo: element.TcKimlikNo,
                                    uyeNo: this.kalemData.Rez.adresler[indexx].uyeNo,
                                    adSoyad: element.Ad + ' ' + element.Soyad,
                                    adres: hrrez.HotelRuner.Adres,
                                    dogumTarihi: element.dogumTarihi,
                                    cinsiyet: null,
                                    telefon1: hrrez.HotelRuner.Telefon,
                                    gsm: hrrez.HotelRuner.Telefon,
                                    eMail: hrrez.HotelRuner.Mail,
                                    kisiTableRef: this.kalemData.Rez.adresler[indexx].kisiTableRef,
                                    kod: this.kalemData.Rez.adresler[indexx].kod
                                }
    
                                this.kalemData.Rez.adresler.splice(indexx, 1, yenikayit)
    
                                kisisira.push(indexx)
    
                            } else {
    
                                var yas = 0
    
                                if (element.dogumTarihi != null) {
                                    var dogumyili = new Date(element.dogumTarihi)
                                    yas = helpers.getYear() - dogumyili.getFullYear()
                                } else {
                                    yas = 0
                                }
    
                                var yenikayit = {
                                    id: null,
                                    kisiTip: element.tip,
                                    kisiSira: this.kalemData.Rez.adresler.length - 1,
                                    yas: yas,
                                    profilId: null,
                                    sicilId: null,
                                    
                                    tcKimlikNo: element.TcKimlikNo,
                                    uyeNo: null,
                                    adSoyad: element.Ad + ' ' + element.Soyad,
                                    adres: hrrez.HotelRuner.Adres,
                                    dogumTarihi: element.dogumTarihi,
                                    cinsiyet: null,
                                    telefon1: hrrez.HotelRuner.Telefon,
                                    gsm: hrrez.HotelRuner.Telefon,
                                    eMail: hrrez.HotelRuner.Mail,
                                    kisiTableRef: null,
                                    kod: null
                                }
    
                                this.kalemData.Rez.adresler.push(yenikayit)
    
                                kisisira.push(this.kalemData.Rez.adresler.length - 1)
    
                            }
    
                        });
    
                        var hrkalemindex = hrrez.Rezervasyon.kalemler.map(function (e) {
                            return e.entId;
                        }).indexOf(hrrez.kalemIndex);
    
                        var yenikalem = {
                            saticiEntegrasyon: null,
                            entTip: 1,
                            entId: hrrez.RezervasyonID,
                            islemRef: hrrez.Rezervasyon.kalemler[hrkalemindex].islemRef,
                            donem1: hrrez.HotelRuner.StartDate,
                            donem2: hrrez.HotelRuner.EndDate,
                            satis: {
                                KDVOran: 0
                            },
                            alis: {
                                KDVOran: 0
                            },
                            komisyon: {
                                KDVOran: 0,
                                tutar: 0
                            },
                            acenteKomisyon: {
                                paraBirimi: null,
                                kur: 0,
                                tutar: 0,
                                KDVOran: 0
                            },
                            iskonto: {
                                oran: 0,
                                tutar: 0,
                                iskontoSebebi: null,
                            },
                            odeyenTaraf: 1,
                            aciklama: hrrez.HotelRuner.Message,
                            tedarikciAciklama: 'Hotel Runner Otel Satışı',
                            turOperatoru: {
                                id: null,
                                kod: null,
                                isim: null,
                                isimAra: null,
                            },
                            departman: {
                                id: null,
                                kod: null,
                                isim: null,
                                isimAra: null,
                            },
                            kdvID: {
                                id: null,
                                kod: null,
                                isim: null,
                                isimAra: null
                            },
                            kdvMuafiyetID: {
                                id: null,
                                kod: null,
                                isim: null,
                                isimAra: null
                            },
                            entegrasyonKodu: null,
                            maliyetCariKod: {
                                id: null,
                                kod: null,
                                isim: null,
                                tip: null
                            },
                            saticiTip: 1,
                            kisiSira: kisisira,
    
                            yet_Satis: parseFloat(hrrez.HotelRuner.ArkmanPrice),
                            co1_Satis: 0,
                            co2_Satis: 0,
                            co3_Satis: 0,
                            co4_Satis: 0,
                            ekY_Satis: 0,
    
                            yet_Alis: parseFloat(hrrez.HotelRuner.ServicePrice),
                            co1_Alis: 0,
                            co2_Alis: 0,
                            co3_Alis: 0,
                            co4_Alis: 0,
                            ekY_Alis: 0,
    
                            yet_KisiSayisi: kisisira.length,
                            co1_KisiSayisi: 0,
                            co2_KisiSayisi: 0,
                            co3_KisiSayisi: 0,
                            co4_KisiSayisi: 0,
                            ekY_KisiSayisi: 0,
    
                            satici: {
                                id: -1,
                                kod: hrrez.SaticiBilgileri.Kod,
                                isim: hrrez.SaticiBilgileri.Isim,
                                tip: 1,
                                YurtIci_YurtDisi: hrrez.SaticiBilgileri.IcDis,
                            },
                            alisPara: {
                                paraBirimi: this.hrgetkur(hrrez.HotelRuner.Kur),
                                kur: hrrez.OtelBilgi.KurDeger,
                                kurTarihi: null,
                            },
                            satisPara: {
                                paraBirimi: this.hrgetkur(hrrez.HotelRuner.Kur),
                                kur: hrrez.OtelBilgi.KurDeger,
                                kurTarihi: null,
                            },
                            komisyonPara: {
                                paraBirimi: this.hrgetkur(hrrez.HotelRuner.Kur),
                                kur: hrrez.OtelBilgi.KurDeger,
                                kurTarihi: null,
                            },
                            komisyonYuzdeTip: 0,
                            komisyonYuzde: 0,
                            komisyonTutar: 0,
                            P_RP: 'R',
                            masrafMerkezi: {
                                id: null,
                                kod: null,
                                isim: null,
                                tip: null
                            },
                            kalemOtel: {
                                odaTipi: {
                                    id: null,
                                    kod: null,
                                    isim: null,
                                    tip: null
                                },
                                pansiyon: 0,
                                girisSaati: helpers.getTime(hrrez.OtelBilgi.GirisSaat),
                                konum: null,
                                RP: 'T',
                                odaSayi: 1,
                                kontenjan: false,
                                freeKisi: 0,
                                fiyatKodu: {
                                    id: null,
                                    kod: null,
                                    isim: null,
                                    tip: null
                                }
                            },
                            kalemArac: null,
                            kalemDiger: null,
                            kalemRentACar: null,
                            kalemVize: null,
                            kalemSigorta: null,
                            kalemGemi: null,
                            kalemRehber: null,
                            kalemAcente: null,
                            kalemCharter: null
                        }
    
                        var kalemindex = this.kalemData.Rez.kalemler.map(function (e) {
                            return e.entId;
                        }).indexOf(hrrez.kalemIndex);
    
                        if (kalemindex != -1) {
                            this.kalemData.Rez.kalemler.splice(kalemindex, 1, yenikalem)
                        } else {
                            this.kalemData.Rez.kalemler.push(yenikalem)
                        }
    
                        this.rezervasyonKaydet(this.step.rezKalemleri, this.kalemData.Rez);
    
                    } else {
                        this.text1 =
                            'Geçersiz işlemden dolayı rezervasyon sayfasına yönlendiriliyorsunuz.'
                        this.snackbar = true
    
                        setTimeout(function () {
    
                                var link = '#/coper/rezervasyon/rezervasyonlistesi'
                                window.open(link, '_self');
                            }
    
                            .bind(this), 5000)
                    }
    
                } else if (this.$route.query.islem == "pdyeni") {
    
                    var pdtransfer = JSON.parse(window.localStorage.getItem('pdtransfer'));
    
                    if (pdtransfer != null) {
                        var kisisira = []
    
                        pdtransfer.AdresBilgileri.forEach(element => {
    
                            var yenikayit = {
                                id: null,
                                kisiTip: element.tip,
                                kisiSira: this.kalemData.Rez.adresler.length - 1,
                                yas: 0,
                                profilId: null,
                                sicilId: null,
                                
                                tcKimlikNo: element.TcKimlikNo,
                                uyeNo: null,
                                adSoyad: element.Ad + ' ' + element.Soyad,
                                adres: pdtransfer.TransferData.Adress,
                                dogumTarihi: null,
                                cinsiyet: null,
                                telefon1: pdtransfer.TransferData.Phone,
                                gsm: pdtransfer.TransferData.Phone,
                                eMail: pdtransfer.TransferData.Email,
                                kisiTableRef: null,
                                kod: null,
                                firstName: element.Ad,
                                lastName: element.Soyad
                            }
    
                            this.kalemData.Rez.adresler.push(yenikayit)
    
                            kisisira.push(this.kalemData.Rez.adresler.length - 1)
    
                        });
    
                        this.kalemData.Rez.cariKod.kod = pdtransfer.CariKodu
    
                        var yenikalem = {
                            saticiEntegrasyon: {
                                SaticiTipi: 2,
                                Kod: pdtransfer.SaticiBilgileri.Kod,
                                Isim: pdtransfer.SaticiBilgileri.Isim,
                                Adres: pdtransfer.SaticiBilgileri.Adres,
                                PK: pdtransfer.SaticiBilgileri.PK,
                                Ulke: pdtransfer.SaticiBilgileri.Ulke,
                                Sehir: pdtransfer.SaticiBilgileri.Sehir,
                                Yer: pdtransfer.SaticiBilgileri.Yer,
                                SaticiKonumu: pdtransfer.SaticiBilgileri.SaticiKonumu,
                                Yetkili: pdtransfer.SaticiBilgileri.Yetkili,
                                Web: pdtransfer.SaticiBilgileri.Web,
                                HavaAlani: pdtransfer.SaticiBilgileri.HavaAlani,
                                VDaire: pdtransfer.SaticiBilgileri.VDaire,
                                VNo: pdtransfer.SaticiBilgileri.VNo,
                                Tel1: pdtransfer.SaticiBilgileri.Tel1,
                                Tel2: pdtransfer.SaticiBilgileri.Tel2,
                                Fax: pdtransfer.SaticiBilgileri.Fax,
                                Teleks: pdtransfer.SaticiBilgileri.Teleks,
                                Email: pdtransfer.SaticiBilgileri.Email,
                                GSM: pdtransfer.SaticiBilgileri.GSM,
                                Ic_Dis: pdtransfer.SaticiBilgileri.Ic_Dis,
                                Aciklamalar: pdtransfer.SaticiBilgileri.Aciklamalar,
                            },
                            entTip: 2,
                            entId: pdtransfer.Pnr + '-' + pdtransfer.CardId,
                            islemRef: 0,
                            donem1: pdtransfer.PaxDrive.TransferInfo.DateAndTime,
                            donem2: pdtransfer.PaxDrive.TransferInfo.DateAndTime,
                            satis: {
                                KDVOran: 0
                            },
                            alis: {
                                KDVOran: 0
                            },
                            komisyon: {
                                KDVOran: 0,
                                tutar: 0
                            },
                            acenteKomisyon: {
                                paraBirimi: null,
                                kur: 0,
                                tutar: 0,
                                KDVOran: 0
                            },
                            iskonto: {
                                oran: 0,
                                tutar: 0,
                                iskontoSebebi: null,
                            },
                            odeyenTaraf: 1,
                            aciklama: 'Pax Drive Rezervasyon Satışı',
                            tedarikciAciklama: 'Pax Drive Rezervasyon Satışı',
                            turOperatoru: {
                                id: null,
                                kod: null,
                                isim: null,
                                isimAra: null,
                            },
                            departman: {
                                id: null,
                                kod: null,
                                isim: null,
                                isimAra: null,
                            },
                            kdvID: {
                                id: null,
                                kod: null,
                                isim: null,
                                isimAra: null
                            },
                            kdvMuafiyetID: {
                                id: null,
                                kod: null,
                                isim: null,
                                isimAra: null
                            },
                            entegrasyonKodu: null,
                            maliyetCariKod: {
                                id: null,
                                kod: null,
                                isim: null,
                                tip: null
                            },
                            saticiTip: 2,
                            kisiSira: kisisira,
    
                            yet_Satis: parseFloat(pdtransfer.PaxDrive.PriceDetails.DisplayPrice),
                            co1_Satis: 0,
                            co2_Satis: 0,
                            co3_Satis: 0,
                            co4_Satis: 0,
                            ekY_Satis: 0,
    
                            yet_Alis: parseFloat(pdtransfer.PaxDrive.PriceDetails.SystemPrice),
                            co1_Alis: 0,
                            co2_Alis: 0,
                            co3_Alis: 0,
                            co4_Alis: 0,
                            ekY_Alis: 0,
    
                            yet_KisiSayisi: kisisira.length,
                            co1_KisiSayisi: 0,
                            co2_KisiSayisi: 0,
                            co3_KisiSayisi: 0,
                            co4_KisiSayisi: 0,
                            ekY_KisiSayisi: 0,
    
                            satici: {
                                id: -1,
                                kod: pdtransfer.SaticiBilgileri.Kod,
                                isim: pdtransfer.SaticiBilgileri.Isim,
                                tip: 2,
                                YurtIci_YurtDisi: pdtransfer.SaticiBilgileri.IcDis,
                            },
                            alisPara: {
                                paraBirimi: this.hrgetkur(pdtransfer.PaxDrive.Rate),
                                kur: pdtransfer.PaxDrive.Currency,
                                kurTarihi: null,
                            },
                            satisPara: {
                                paraBirimi: this.hrgetkur(pdtransfer.PaxDrive.Rate),
                                kur: pdtransfer.PaxDrive.Currency,
                                kurTarihi: null,
                            },
                            komisyonPara: {
                                paraBirimi: this.hrgetkur(pdtransfer.PaxDrive.Rate),
                                kur: pdtransfer.PaxDrive.Currency,
                                kurTarihi: null,
                            },
                            komisyonYuzdeTip: 0,
                            komisyonYuzde: 0,
                            komisyonTutar: 0,
                            P_RP: 'R',
                            masrafMerkezi: {
                                id: null,
                                kod: null,
                                isim: null,
                                tip: null
                            },
                            kalemOtel: null,
                            kalemArac: {
                                tip: null,
                                ucusNo: pdtransfer.TransferData.FlightNumber,
                                ucusSaat: pdtransfer.PaxDrive.TransferInfo.DateAndTime,
                                tasimaTipi: null,
                                bolge: null,
                                nerden: pdtransfer.PaxDrive.PickupPointName,
                                nereye: pdtransfer.PaxDrive.DropPointName,
                                arac: null,
                                aracAdet: pdtransfer.PaxDrive.VehicleCount,
                                rehberDili: null,
                                rehberAdet: null,
                                seferNo: null,
                                seferId: null,
                                seferSaat: pdtransfer.PaxDrive.TransferInfo.DateAndTime,
                                ADT: null,
                                tasimaTipRef: null,
                                rehber: {
                                    id: null,
                                    kod: null,
                                    isim: null,
                                    tip: null,
                                    YurtIci_YurtDisi: null
                                },
                                pinCode: null,
                                otelKod: null,
                                SoforTahsilat: null,
                                seferVarisId: null,
                                odaNo: null,
                                transferDurumu: null,
                            },
                            kalemDiger: null,
                            kalemRentACar: null,
                            kalemVize: null,
                            kalemSigorta: null,
                            kalemGemi: null,
                            kalemRehber: null,
                            kalemAcente: null,
                            kalemCharter: null
                        }
                        this.kalemData.Rez.kalemler.push(yenikalem)
                        window.localStorage.removeItem('pdtransfer')
    
                        this.rezervasyonKaydet(this.step.rezKalemleri, this.kalemData.Rez);
    
                    } else {
                        this.text1 = 'Hatalı işlem, rezervasyon listesine yönlendiriliyorsunuz.'
                        this.snackbar = true
                        setTimeout(function () {
                            var url1 = '#/coper/rezervasyon/rezervasyonlistesi'
                            window.open(url1, '_self')
                        }.bind(this), 3000)
                    }
    
                } else if (this.$route.query.islem == "pdget") {
    
                    var pdtransfer = JSON.parse(window.localStorage.getItem('pdtransfer'));
    
                    if (pdtransfer != null) {
                        this.kalemData.Rez = pdtransfer.Rezervasyon
    
                        var kisisira = []
    
                        pdtransfer.AdresBilgileri.forEach(element => {
    
                            if (element.sira == null) {
                                var yenikayit = {
                                    id: element.CoperKisiID,
                                    kisiTip: element.tip,
                                    kisiSira: this.kalemData.Rez.adresler.length,
                                    yas: 0,
                                    profilId: null,
                                    sicilId: null,
                                    
                                    tcKimlikNo: element.TcKimlikNo,
                                    uyeNo: null,
                                    adSoyad: element.Ad + ' ' + element.Soyad,
                                    adres: pdtransfer.TransferData.Adress,
                                    dogumTarihi: null,
                                    cinsiyet: null,
                                    telefon1: pdtransfer.TransferData.Phone,
                                    gsm: pdtransfer.TransferData.Phone,
                                    eMail: pdtransfer.TransferData.Email,
                                    kisiTableRef: null,
                                    kod: null,
                                    firstName: element.Ad,
                                    lastName: element.Soyad
                                }
                                kisisira.push(yenikayit.kisiSira)
    
                                this.kalemData.Rez.adresler.push(yenikayit)
                            } else {
                                kisisira.push(element.sira)
                            }
                        });
    
                        this.kalemData.Rez.cariKod.kod = pdtransfer.Rezervasyon.cariKod.kod
    
                        var yenikalem = {
                            saticiEntegrasyon: {
                                SaticiTipi: 2,
                                Kod: pdtransfer.SaticiBilgileri.Kod,
                                Isim: pdtransfer.SaticiBilgileri.Isim,
                                Adres: pdtransfer.SaticiBilgileri.Adres,
                                PK: pdtransfer.SaticiBilgileri.PK,
                                Ulke: pdtransfer.SaticiBilgileri.Ulke,
                                Sehir: pdtransfer.SaticiBilgileri.Sehir,
                                Yer: pdtransfer.SaticiBilgileri.Yer,
                                SaticiKonumu: pdtransfer.SaticiBilgileri.SaticiKonumu,
                                Yetkili: pdtransfer.SaticiBilgileri.Yetkili,
                                Web: pdtransfer.SaticiBilgileri.Web,
                                HavaAlani: pdtransfer.SaticiBilgileri.HavaAlani,
                                VDaire: pdtransfer.SaticiBilgileri.VDaire,
                                VNo: pdtransfer.SaticiBilgileri.VNo,
                                Tel1: pdtransfer.SaticiBilgileri.Tel1,
                                Tel2: pdtransfer.SaticiBilgileri.Tel2,
                                Fax: pdtransfer.SaticiBilgileri.Fax,
                                Teleks: pdtransfer.SaticiBilgileri.Teleks,
                                Email: pdtransfer.SaticiBilgileri.Email,
                                GSM: pdtransfer.SaticiBilgileri.GSM,
                                Ic_Dis: pdtransfer.SaticiBilgileri.Ic_Dis,
                                Aciklamalar: pdtransfer.SaticiBilgileri.Aciklamalar,
                            },
                            entTip: 2,
                            entId: pdtransfer.Pnr + '-' + pdtransfer.CardId,
                            islemRef: 0,
                            donem1: pdtransfer.PaxDrive.TransferInfo.DateAndTime,
                            donem2: pdtransfer.PaxDrive.TransferInfo.DateAndTime,
                            satis: {
                                KDVOran: 0
                            },
                            alis: {
                                KDVOran: 0
                            },
                            komisyon: {
                                KDVOran: 0,
                                tutar: 0
                            },
                            acenteKomisyon: {
                                paraBirimi: null,
                                kur: 0,
                                tutar: 0,
                                KDVOran: 0
                            },
                            iskonto: {
                                oran: 0,
                                tutar: 0,
                                iskontoSebebi: null,
                            },
                            odeyenTaraf: 1,
                            aciklama: 'Pax Drive Rezervasyon Satışı',
                            tedarikciAciklama: 'Pax Drive Rezervasyon Satışı',
                            turOperatoru: {
                                id: null,
                                kod: null,
                                isim: null,
                                isimAra: null,
                            },
                            departman: {
                                id: null,
                                kod: null,
                                isim: null,
                                isimAra: null,
                            },
                            kdvID: {
                                id: null,
                                kod: null,
                                isim: null,
                                isimAra: null
                            },
                            kdvMuafiyetID: {
                                id: null,
                                kod: null,
                                isim: null,
                                isimAra: null
                            },
                            entegrasyonKodu: null,
                            maliyetCariKod: {
                                id: null,
                                kod: null,
                                isim: null,
                                tip: null
                            },
                            saticiTip: 2,
                            kisiSira: kisisira,
    
                            yet_Satis: parseFloat(pdtransfer.PaxDrive.PriceDetails.DisplayPrice),
                            co1_Satis: 0,
                            co2_Satis: 0,
                            co3_Satis: 0,
                            co4_Satis: 0,
                            ekY_Satis: 0,
    
                            yet_Alis: parseFloat(pdtransfer.PaxDrive.PriceDetails.SystemPrice),
                            co1_Alis: 0,
                            co2_Alis: 0,
                            co3_Alis: 0,
                            co4_Alis: 0,
                            ekY_Alis: 0,
    
                            yet_KisiSayisi: kisisira.length,
                            co1_KisiSayisi: 0,
                            co2_KisiSayisi: 0,
                            co3_KisiSayisi: 0,
                            co4_KisiSayisi: 0,
                            ekY_KisiSayisi: 0,
    
                            satici: {
                                id: -1,
                                kod: pdtransfer.SaticiBilgileri.Kod,
                                isim: pdtransfer.SaticiBilgileri.Isim,
                                tip: 2,
                                YurtIci_YurtDisi: pdtransfer.SaticiBilgileri.IcDis,
                            },
                            alisPara: {
                                paraBirimi: this.hrgetkur(pdtransfer.PaxDrive.Rate),
                                kur: pdtransfer.PaxDrive.Currency,
                                kurTarihi: null,
                            },
                            satisPara: {
                                paraBirimi: this.hrgetkur(pdtransfer.PaxDrive.Rate),
                                kur: pdtransfer.PaxDrive.Currency,
                                kurTarihi: null,
                            },
                            komisyonPara: {
                                paraBirimi: this.hrgetkur(pdtransfer.PaxDrive.Rate),
                                kur: pdtransfer.PaxDrive.Currency,
                                kurTarihi: null,
                            },
                            komisyonYuzdeTip: 0,
                            komisyonYuzde: 0,
                            komisyonTutar: 0,
                            P_RP: 'R',
                            masrafMerkezi: {
                                id: null,
                                kod: null,
                                isim: null,
                                tip: null
                            },
                            kalemOtel: null,
                            kalemArac: {
                                tip: null,
                                ucusNo: pdtransfer.TransferData.FlightNumber,
                                ucusSaat: pdtransfer.PaxDrive.TransferInfo.DateAndTime,
                                tasimaTipi: null,
                                bolge: null,
                                nerden: pdtransfer.PaxDrive.PickupPointName,
                                nereye: pdtransfer.PaxDrive.DropPointName,
                                arac: null,
                                aracAdet: pdtransfer.PaxDrive.VehicleCount,
                                rehberDili: null,
                                rehberAdet: null,
                                seferNo: null,
                                seferId: null,
                                seferSaat: pdtransfer.PaxDrive.TransferInfo.DateAndTime,
                                ADT: null,
                                tasimaTipRef: null,
                                rehber: {
                                    id: null,
                                    kod: null,
                                    isim: null,
                                    tip: null,
                                    YurtIci_YurtDisi: null
                                },
                                pinCode: null,
                                otelKod: null,
                                SoforTahsilat: null,
                                seferVarisId: null,
                                odaNo: null,
                                transferDurumu: null,
                            },
                            kalemDiger: null,
                            kalemRentACar: null,
                            kalemVize: null,
                            kalemSigorta: null,
                            kalemGemi: null,
                            kalemRehber: null,
                            kalemAcente: null,
                            kalemCharter: null
                        }
    
                        this.kalemData.Rez.kalemler.push(yenikalem)
                        window.localStorage.removeItem('pdtransfer')
                        this.rezervasyonKaydet(this.step.rezKalemleri, this.kalemData.Rez);
    
                    } else {
                        this.text1 = 'Hatalı işlem, rezervasyon listesine yönlendiriliyorsunuz.'
                        this.snackbar = true
                        setTimeout(function () {
                            var url1 = '#/coper/rezervasyon/rezervasyonlistesi'
                            window.open(url1, '_self')
                        }.bind(this), 3000)
                    }
    
                } else {
                    this.text1 = 'hatalı url'
                    this.snackbar = true
                }
          },
          getCurrentInfo(currentInfo){
            //this.kalemData.Rez.masrafMerkezi.kod = currentInfo.ExpenseCenter; 
          },
            kalemKopyala(value){
                value.islemRef = 0;
                var newValue = [];
                newValue.push(value);
                //this.kalemData.Rez.kalemler.push(newValue.slice(0));
                //this.kalemData.Rez.kalemler.unshift(value);
                //this.kalemData.Rez.kalemler = Object.assign({},this.kalemData.Rez.kalemler,newValue);
                  this.kalemData.Rez.kalemler = this.kalemData.Rez.kalemler.concat(newValue);
            },
            pnrKopyala(){
            this.loadingvmodel = true
            let params = {
                PNR_No: this.searchPnrNo
            }
            tool.http_post(this, "MiceLoad", params).then(
                response => {
                    if (response.body.Status == true) {
                        this.loadingvmodel = false
                        for (let index = 0; index < response.body.data.kalemler.length; index++) {
                            const element = response.body.data.kalemler[index];
                            const kalem = rez.Kalem();
                            kalem.baseKalem = element.baseKalem;
                            kalem.kalemOtel = element.kalemOtel;
                            kalem.kalemAcente = element.kalemAcente;
                            kalem.kalemArac = element.kalemArac;
                            kalem.kalemCharter = element.kalemCharter;
                            kalem.kalemDiger = element.kalemDiger;
                            kalem.kalemFeribot = element.kalemFeribot;
                            kalem.kalemGemi = element.kalemGemi;
                            kalem.kalemGolf = element.kalemGolf;
                            kalem.kalemMuze = element.kalemMuze;
                            kalem.kalemRehber = element.kalemRehber;
                            kalem.kalemRentACar = element.kalemRentACar;
                            kalem.kalemRestaurant = element.kalemRestaurant;
                            kalem.kalemSigorta = element.kalemSigorta;
                            kalem.kalemVize = element.kalemVize;
                            kalem.Alis_RPTF = element.Alis_RPTF;
                            kalem.MaliyetFixFiyat = element.MaliyetFixFiyat;
                            kalem.P_RP = element.P_RP;
                            kalem.acenteKomisyon = element.acenteKomisyon;
                            kalem.aciklama = element.aciklama;
                            kalem.alis = element.alis;
                            kalem.alisPara = element.alisPara;
                            kalem.alisTutar = element.alisTutar;
                            kalem.yet_KisiSayisi = element.yet_KisiSayisi;
                            kalem.co1_Alis = element.co1_Alis;
                            kalem.co1_KisiSayisi = element.co1_KisiSayisi;
                            kalem.co1_Satis = element.co1_Satis;
                            kalem.co2_Alis = element.co2_Alis;
                            kalem.co2_KisiSayisi = element.co2_KisiSayisi;
                            kalem.co2_Satis = element.co2_Satis;
                            kalem.co3_Alis = element.co3_Alis;
                            kalem.co3_KisiSayisi = element.co3_KisiSayisi;
                            kalem.co3_Satis = element.co3_Satis;
                            kalem.co4_Alis = element.co4_Alis;
                            kalem.co4_KisiSayisi = element.co4_KisiSayisi;
                            kalem.co4_Satis = element.co4_Satis;
                            kalem.departman = element.departman;
                            kalem.disID = element.disID;
                            kalem.donem1 = element.donem1;
                            kalem.donem2 = element.donem2;
                            kalem.ekY_Alis = element.ekY_Alis; 
                            kalem.ekY_KisiSayisi = element.ekY_KisiSayisi;
                            kalem.ekY_Satis = element.ekY_Satis;
                            kalem.entId = element.entId;
                            kalem.entTip = element.entTip;
                            kalem.entegrasyonKodu = element.entegrasyonKodu; 
                            kalem.iskonto = element.iskonto;
                            kalem.karKDV = element.karKDV;
                            kalem.kdvID = element.kdvID;
                            kalem.kdvMuafiyetID = element.kdvMuafiyetID;
                            kalem.saticiTip = element.saticiTip;
                            kalem.komisyon = element.komisyon;
                            kalem.komisyonPara = element.komisyonPara;
                            kalem.komisyonTutar = element.komisyonTutar;
                            kalem.komisyonYuzde = element.komisyonYuzde;
                            kalem.komisyonYuzdeTip = element.komisyonYuzdeTip;
                            kalem.maliyetCariKod = element.maliyetCariKod;
                            kalem.masrafMerkezi = element.masrafmerkezi;
                            kalem.odeyenTaraf = element.odeyenTaraf;
                            kalem.satici = element.satici;
                            kalem.saticiEntegrasyon = element.saticiEntegrasyon;
                            kalem.satis = element.satis;
                            kalem.satisPara = element.satisPara;
                            kalem.satisTutar = element.satisTutar;
                            kalem.tedarikciAciklama = element.tedarikciAciklama;
                            kalem.turOperatoru = element.turOperatoru;
                            kalem.yet_Alis = element.yet_Alis; 
                            kalem.yet_Satis = element.yet_Satis;
    
                            var kisiSira = [];
                            this.kalemData.Rez.adresler.forEach(element => {
                                if (element.sira == null) {
                                kisiSira.push(element.kisiSira);
                                }else{
                                kisiSira.push(element.sira);
                                }
                            });
    
    
                            kalem.kisiSira = kisiSira;
                            this.kalemData.Rez.kalemler.push(kalem);
    
                        }
                        this.kalemData.Kisiler.push(this.kalemData.Rez.adresler);
    
                    } else {
                        this.loadingvmodel = false
                        this.text1 = response.body.ErrorList[0]
                        this.snackbar = true
                    }
                },
                response => {
                    this.HataYonetimi(response, params, 'Rezervasyon Getirilemedi');
                }
            );
            },
            paxdriveRezDegistir(val) {
    
                this.$refs.paxdriveeditdialog.open('', val).then(
                    sonuc => {
                        if (sonuc.status == true) {
    
                            this.text1 = sonuc.message
                            this.snackbar = true
                            var kalem = val
    
                            //transfer değişmiş ise yeni bilgileri kaleme ekleyip kaydedelim
                            kalem.donem1 = sonuc.data.tarih
                            kalem.donem2 = sonuc.data.tarih
                            kalem.kalemArac.seferSaat = '0001-01-01T' + sonuc.data.saat + ':00'
                            kalem.kalemArac.ucusSaat = '0001-01-01T' + sonuc.data.saat + ':00'
                            this.kalemData.Rez.kalemler.splice(this.kalemData.Rez.kalemler.indexOf(val),
                                1, kalem)
                            this.rezervasyonKaydet(this.step.rezKalemleri, this.kalemData.Rez);
    
                        } 
    
                    });
            },
            paxdriveRezervasyonIptal(val) {
    
                this.$refs.onaydialog.open('Bu transferi iptal etmek istediğinize emin misiniz?', 1).then(
                    sonuc => {
    
                        if (sonuc == true) {
    
                            if (val.entId != null) {
    
                                var rezid = val.entId.split("-");
    
                                this.loadingvmodel = true
    
                                var credentials = JSON.parse(window.localStorage.getItem(
                                    'credentials'));
    
                                var params = {
                                    LogInput: {
                                        UserID: credentials.UserID,
                                        CustomerID: credentials.MusteriID
                                    },
                                    CardId: rezid[1]
                                }
    
                                this.$http.post(auth.PAXDRIVE_API_URL + 'api/Transfer/CancelBooking',
                                    params, {
                                        headers: {
                                            'Authorization': 'Basic ' + window.btoa(auth
                                                .HOTELRUNNERUSERNAME +
                                                ':' + auth
                                                .HOTELRUNNERUSERPASS)
                                        }
                                    }).then((response) => {
    
                                    if (response.body.Status == true) {
    
                                        this.kalemData.Rez.kalemler.splice(this.kalemData.Rez
                                            .kalemler
                                            .indexOf(val), 1)
    
                                        if (this.kalemData.Rez.kalemler.length == 0) {
                                            this.iptalDialog = true
                                            this.IptalNedeni = 'Pax Drive Transfer İptali'
                                            this.iptalTuru = 'pdIptal'
    
                                        } else {
                                            this.rezervasyonKaydet(this.step.rezKalemleri, this
                                                .kalemData
                                                .Rez);
                                        }
    
                                    } else {
                                        this.text1 = response.body.Message
                                        this.snackbar = true
                                        this.loadingvmodel = false
    
                                    }
    
                                }, (response) => {
                                    this.text1 = this.$t('error-occurred-please-try-again')
                                    this.snackbar = true
                                    this.loadingvmodel = false
                                })
    
                            } else {
                                this.text1 =
                                    "PaxDrive kayıt bilgilerine ulaşılamadı. Sorunu teknik desteğe bildiriniz."
                                this.snackbar = true
                            }
    
                        }
                    });
    
            },
    
            hotelRunnerRezDegistir(val) {
    
                window.localStorage.removeItem('hrrezervasyon')
                var kalemkisiList = []
                val.kisiSira.forEach(element => {
                    kalemkisiList.push(this.kalemData.Rez.adresler[element])
    
                });
    
                var rezervasyon = {
                    Rezervasyon: this.kalemData.Rez,
                    HotelRuner: null,
                    hrislem: false,
                    kalemIndex: val.entId,
                    kalemKisiList: kalemkisiList
                }
    
                window.localStorage.setItem('hrrezervasyon', JSON.stringify(rezervasyon))
    
                var link = '#/hotelrunner/rezervasyon/id?islemTip=hredit&hrid=' + val.entId
                window.open(link, '_self');
            },
    
            hotelRunnerRezIptal(val) {
                var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    
                this.loadingvmodel = true
                var params = {
                    LogInput: {
                        UserID: credentials.UserID,
                        CustomerID: credentials.MusteriID
                    },
                    ReservationCode: val.entId,
                }
                this.$http.post(auth.HOTELRUNNER_API_URL + 'api/v1/CancelReservation', params, {
                    headers: {
                        'Authorization': 'Basic ' + window.btoa(auth.HOTELRUNNERUSERNAME + ':' +
                            auth
                            .HOTELRUNNERUSERPASS)
                    }
                }).then((response) => {
                    this.loadingvmodel = false
                    this.text1 = response.body.ResponseMessage
                    this.snackbar = true
    
                    if (response.body.Status == true) {
    
                        this.kalemData.Rez.kalemler.splice(this.kalemData.Rez.kalemler.indexOf(val),
                            1)
    
                        if (this.kalemData.Rez.kalemler.length == 0) {
                            this.iptalDialog = true
                            this.IptalNedeni = 'Hotel Runner Rezervasyon İptali'
                            this.iptalTuru = 'hrIptal'
    
                            // this.$refs.onaydialog.open('Rezervasyona ait coper kaydınızı silmek istiyor musunuz?', 1).then(
                            //   sonuc => {
    
                            //     if (sonuc == true) {
    
                            //     } else {
    
                            //     }
    
                            //   });
                        } else {
                            // this.hrkisiSil(val)
                            this.rezervasyonKaydet(this.step.rezKalemleri, this.kalemData.Rez);
                        }
                    }
                }, (response) => {
    
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-Rezervasyon/Iptal'
                        this.snackbar = true
                        this.loadingvmodel = false
    
                        this.progress = false
                    } else {
                        this.text1 = 'Service Unavailable-Rezervasyon/Iptal'
                        this.snackbar = true
                        this.progress = false
                        this.loadingvmodel = false
    
                    }
                })
    
            },
            hrkisiSil(kalem) {
    
                kalem.kisiSira.forEach(element => {
    
                    this.kalemData.Rez.adresler.splice(element, 1)
                    this.kalemData.Kisiler = this.kalemData.Rez.adresler
                    var sira = element;
    
                    var i = 0;
                    var j = 0;
                    var k = 0;
    
                    for (i = 0; i < this.kalemData.Rez.adresler.length; i++) {
                        if (sira < this.kalemData.Rez.adresler[i].kisiSira) {
                            this.kalemData.Rez.adresler[i].kisiSira--;
                        }
                    }
    
                    for (i = 0; i < this.kalemData.Rez.kalemler.length; i++) {
                        for (j = 0; j < this.kalemData.Rez.kalemler[i].kisiSira.length; j++) {
                            if (sira == this.kalemData.Rez.kalemler[i].kisiSira[j]) {
                                this.kalemData.Rez.kalemler[i].kisiSira.splice(j, 1);
                                break;
                            }
                        }
                        for (k = 0; k < this.kalemData.Rez.kalemler[i].kisiSira.length; k++) {
                            if (sira < this.kalemData.Rez.kalemler[i].kisiSira[k]) {
                                this.kalemData.Rez.kalemler[i].kisiSira[k]--;
                            }
                        }
                    }
                    this.Adres.kisiSira = -1;
                });
    
            },
            getOtelUlke(val) {
                if (val == 'TR') {
                    return 0
                } else {
                    return '1'
                }
            },
            hrgetkur(val) {
                if (val == 'TRY') {
                    return 'TL'
                } else {
                    return val
                }
            },
            pnrIptalDialog(val) {
                this.iptalDialog = true
                this.IptalNedeni = null
            },
    
            pnrIptal() {
                this.IptalTipi = null
    
                if (this.$refs.formiptal.validate()) {
    
                    let params = {
                        IptalTipi: 2, //PNR iptalinde 1, Takip No iptalinde 2 olacak, Henüz Takip No iptal yapılmadı.
                        IptalNo: this.kalemData.Rez.takipNo, //PNR No veya Takip No
                        IptalNedeni: this.IptalNedeni
                    }
    
                    tool.http_post(this, 'RezervasyonIptal', params).then(
    
                        response => {
    
                            if (response.body.Status == true) {
                                this.text1 =
                                    "PNR iptal edildi. Rezervasyon listesine yönlendiriliyorsunuz."
                                this.snackbar = true
                                this.iptalDialog = false
                                setTimeout(function () {
                                    var url1 = '#/coper/rezervasyon/rezervasyonlistesi'
                                    window.open(url1, '_self')
                                }.bind(this), 3000)
    
                            } else {
                                this.text1 = response.body.ErrorList[0]
                                this.snackbar = true
                            }
    
                        },
    
                        response => {
    
                            this.text1 = 'Hata Oluştu, tekrar deneyiniz'
    
                            this.snackbar = true
    
                        }
    
                    );
                }
    
            },
    
            HataYonetimi(response, request, baslik) {
    
                if (response.status === 500) //Internal Server Error
                {
                    this.loadingvmodel = false;
                    this.$refs.hatadialog.open(response, request, baslik);
    
                } else {
                    this.loadingvmodel = false;
                    this.text1 = 'Service Unavailable -' + baslik;
                    this.snackbar = true;
                }
            },
            tckisiGetir(tcno) {
    
                if (this.Adres.tcKimlikNo != null) {
                    if (String(this.Adres.tcKimlikNo.length) == 11) {
                        let prm = {
                            TCKimlikNo: this.Adres.tcKimlikNo
                        }
    
                        tool.http_post(this, "AdresBul_TCKN", prm).then(
                            response => {
                                if (response.body.Status == true && response.body.data != null) {
                                    this.Adres = response.body.data
    
                                    if (response.body.data.firstName == "" || response.body.data.firstName == null) {
                                        this.Adres.firstName = this.Adres.adSoyad
                                    }
                                }
    
                            },
                            response => {
                                this.HataYonetimi(response, prm, "Kişi adres bilgisi getirilemedi");
                            }
                        );
                    }
                }
    
            },
            kisiAra() {
                this.adresDialogData.dialogShow = true
            },
            OdemeDuzenle(val) {
                this.$refs.tahsilatdialog.open("update", this.kalemData.Rez.toplamTL.netSatis, val).then(
                    sonuc => {
                        if (sonuc == true) {
                            this.GetOdeme();
                        }
                    });
            },
            OdemeSil(val) {
                this.$refs.onaydialog.open('Bu kayıtı silmek istediğinize emin misiniz?', 1).then(sonuc => {
    
                    if (sonuc == true) {
                        this.loadingvmodel = true
                        let prm = {
                            P_SirketAdi: val.sirketAdi,
                            P_HesapKodu: val.hesapKodu,
                            P_Tarih: val.tarih,
                            P_SiraNo: val.siraNo
                        }
    
                        tool.http_post(this, "GenelOdemeSil", prm).then(
                            response => {
                                this.loadingvmodel = false
                                this.GetOdeme(val);
                            },
                            response => {
                                this.HataYonetimi(response, prm, "Ödeme Silinemedi");
                                this.loadingvmodel = false
                            }
                        );
    
                    }
                });
            },
            GetOdeme(item) {
    
                let prm = {
                    pNR_No: this.kalemData.Rez.pNR_No,
                    hedefParaBirimi: 'TL',
                    kurTarihi: item.tarih
                }
    
                tool.http_post(this, "GetOdeme", prm).then(
                    response => {
                        this.kalemData.Rez.odemeler = response.body.data;
                    },
                    response => {
                        this.HataYonetimi(response, prm, 'Ödeme Getirilemedi');
                    }
                );
            },
            OdemeEkle() {
                this.$refs.tahsilatdialog.open("tahsilat", this.kalemData.Rez.toplamTL.netSatis, null).then(
                    sonuc => {
                        if (sonuc == true) {
                            // this.GetOdeme();
                        }
                    });
            },
            kalemTemizle() {
    
                this.kalemData.kalem = rez.Kalem()
    
            },
    
            rezTemizle() {
                this.kalemData.Rez.pNR_No = null
                this.kalemData.Rez.kayitTarihi = tool.Now_yyyy_MM_dd()
                this.kalemData.Rez.cariKod.kod = null
                this.kalemData.Rez.rezVeren = ""
                this.kalemData.Rez.masrafMerkezi.kod = null
                this.kalemData.Rez.anaTip = 0
                this.kalemData.Rez.ulke = null
                this.kalemData.Rez.karsiRezKod = ""
                this.kalemData.Rez.turKod = ""
                this.kalemData.Rez.acenteDepartman.kod = null
                this.kalemData.Rez.hizmetNo = null
                this.kalemData.Rez.referansKod = null
                this.kalemData.Rez.adresler = []
                this.kalemData.Rez.kalemler = []
                this.kalemData.Rez.toplamTL.satis = 0
                this.kalemData.Rez.toplamTL.alis = 0
                this.kalemData.Rez.toplamTL.komisyon = 0
                this.kalemData.Rez.toplamTL.iskonto = 0
                this.kalemData.Rez.opsiyonluMusteri = false
                this.kalemData.Rez.opsiyonTarihi = null
                this.kalemData.Rez.opsiyonSaati = null
            },
    
            rezkayitgetir(val,recordNumber) {
    
                this.kalemData.kalem = val
    
                this.kalemData.islem = 'edit'
    
                if (val.saticiTip == 1) {
                    this.kalemData.kalem.kalemOtel.girisSaati = helpers.getTime(val.kalemOtel.girisSaati)
                    this.iconrezervasyon = 'tab-1'
    
                } else if (val.saticiTip == 2) {
                    this.iconrezervasyon = 'tab-2'
                    this.kalemData.kalem.kalemArac.ucusSaat = helpers.getTime(val.kalemArac.ucusSaat)
                    this.kalemData.kalem.kalemArac.seferSaat = helpers.getTime(val.kalemArac.seferSaat)
    
                } else if (val.saticiTip == 6) {
                    this.iconrezervasyon = 'tab-6'
                    this.kalemData.kalem.kalemRehber.Saat = helpers.getTime(val.kalemRehber.Saat)
    
                } else if (val.saticiTip == 3) {
                    this.iconrezervasyon = 'tab-3'
    
                } else if (val.saticiTip == 4) {
                    this.iconrezervasyon = 'tab-4'
                    this.kalemData.kalem.kalemAcente.Saat = helpers.getTime(val.kalemAcente.Saat)
    
                } else if (val.saticiTip == 9) {
                    this.iconrezervasyon = 'tab-9'
    
                    this.kalemData.kalem.kalemGemi.GirisSaat = helpers.getTime(val.kalemGemi.GirisSaat)
    
                } else if (val.saticiTip == 8) {
                    this.iconrezervasyon = 'tab-8'
    
                    this.kalemData.kalem.kalemCharter.Saat = helpers.getTime(val.kalemCharter.Saat)
    
                } else if (val.saticiTip == 10) {
                    this.iconrezervasyon = 'tab-10'
                    this.kalemData.kalem.kalemDiger.Saat = helpers.getTime(val.kalemDiger.Saat)
    
                } else if (val.saticiTip == 14) {
                    this.iconrezervasyon = 'tab-14'
    
                } else if (val.saticiTip == 5) {
                    this.iconrezervasyon = 'tab-5'
                    this.kalemData.kalem.kalemRentACar.teslimSaat = helpers.getTime(val.kalemRentACar
                        .teslimSaat)
                    this.kalemData.kalem.kalemRentACar.alisSaat = helpers.getTime(val.kalemRentACar
                        .alisSaat)
                    this.kalemData.kalem.kalemRentACar.musteriTeslimSaati = helpers.getTime(val
                        .kalemRentACar
                        .musteriTeslimSaati)
    
                } else if (val.saticiTip == 11) {
                    this.iconrezervasyon = 'tab-12'
                }
    
                //this.kalemData.recordno = this.kalemData.Rez.kalemler.indexOf(val)
                this.kalemData.recordno = recordNumber;
                this.allrezlist = false;
                this.minrezlist = true;
                
                this.kalemData.Kisiler = this.kalemData.Rez.adresler;
    
            },
            rezkayitsil(val) {
                console.log(val);
                var kalem=this.kalemData.Rez.kalemler[this.kalemData.Rez.kalemler.indexOf(val)];
                console.log(kalem);
                if(confirm("Seçilen Rezervasyon Kalemini İptal Etmek İstiyor musunuz?"))
                {
                    if (kalem.PNR_No!=null && kalem.PNR_No>0)
                {
                    
                    let params = {
                    IptalTipi: 1, //PNR iptalinde 1, Takip No iptalinde 2 olacak, Henüz Takip No iptal yapılmadı.
                    IptalNo: kalem.PNR_No, //PNR No veya Takip No
                    IptalNedeni: 'mice pnr iptal'
                }
                tool.http_post(this, 'RezervasyonIptal', params).then(
                    response => {
                        if (response.body.Status == true) {
                            this.text1 = "PNR iptal edildi."
                            this.snackbar = true
                           
                            location.reload();
                        } else {
                            this.text1 = response.body.ErrorList[0]
                            this.snackbar = true
                           
                        }
                    },
                    response => {
                        this.text1 = 'Hata Oluştu, tekrar deneyiniz'
                        this.snackbar = true
                    }
                );
                    
                }
                else
                {
                    this.kalemData.Rez.kalemler.splice(this.kalemData.Rez.kalemler.indexOf(val), 1)
                }
                }
               
                
            },
            kisiSil(a) {
    
                this.$refs.onaydialog.open('Bu kişiyi silmek istediğinize emin misiniz?', 1).then(sonuc => {
    
                    if (sonuc == true) {
    
                        this.kalemData.Rez.adresler.splice(this.kalemData.Rez.adresler.indexOf(a),
                            1)
                        this.kalemData.Kisiler = this.kalemData.Rez.adresler
                        var sira = a.kisiSira;
    
                        var i = 0;
                        var j = 0;
                        var k = 0;
    
                        for (i = 0; i < this.kalemData.Rez.adresler.length; i++) {
                            if (sira < this.kalemData.Rez.adresler[i].kisiSira) {
                                this.kalemData.Rez.adresler[i].kisiSira--;
                            }
                        }
    
                        for (i = 0; i < this.kalemData.Rez.kalemler.length; i++) {
                            for (j = 0; j < this.kalemData.Rez.kalemler[i].kisiSira.length; j++) {
                                if (sira == this.kalemData.Rez.kalemler[i].kisiSira[j]) {
                                    this.kalemData.Rez.kalemler[i].kisiSira.splice(j, 1);
                                    break;
                                }
                            }
                            for (k = 0; k < this.kalemData.Rez.kalemler[i].kisiSira.length; k++) {
                                if (sira < this.kalemData.Rez.kalemler[i].kisiSira[k]) {
                                    this.kalemData.Rez.kalemler[i].kisiSira[k]--;
                                }
                            }
                        }
                        this.Adres.kisiSira = -1;
                    }
                });
            },
            kisiDuzenle(a) {
                this.Adres = a
            },
            KisiTipToStr(tip) {
                return rez.KisiTipToStr(tip);
            },
            KisiEkle() {
                if (this.$refs.formkisiEkle.validate()) {
    
                    if (this.Adres.dogumTarihi != null) {
                        var dogumyili = new Date(this.Adres.dogumTarihi)
                        this.Adres.yas = helpers.getYear() - dogumyili.getFullYear()
                    } else {
                        this.Adres.yas = 0
                    }
    
                    var yenikayit = {
                        id: this.Adres.id,
                        kisiTip: this.Adres.kisiTip,
                        kisiSira: this.kalemData.Rez.adresler.length,
                        yas: this.Adres.yas,
                        profilId: this.Adres.profilId,
                        sicilId: this.Adres.sicilId,
                        
                        tcKimlikNo: this.Adres.tcKimlikNo,
                        uyeNo: this.Adres.uyeNo,
                        lastName: this.Adres.lastName,
                        firstName: this.Adres.firstName,
                        adSoyad: this.Adres.firstName + ' ' + this.Adres.lastName,
                        adres: this.Adres.adres,
                        dogumTarihi: this.Adres.dogumTarihi,
                        cinsiyet: this.Adres.cinsiyet,
                        telefon1: this.Adres.telefon1,
                        gsm: this.Adres.gsm,
                        eMail: this.Adres.eMail,
                    }
    
                    // this.kisileritems.push(yenikayit)
                    this.kalemData.Rez.adresler.push(yenikayit)
                    this.Adres.id = null
                    this.Adres.kisiTip = 0
    
                    this.Adres.lastName = null
                    this.Adres.firstName = null
                    this.Adres.yas = null
                    this.Adres.profilId = null
                    this.Adres.sicilId = null
                    
                    this.Adres.tcKimlikNo = null
                    this.Adres.uyeNo = null
                    this.Adres.adSoyad = null
                    this.Adres.adres = null
                    this.Adres.dogumTarihi = ''
                    this.Adres.cinsiyet = 'E'
                    this.Adres.telefon1 = null
                    this.Adres.gsm = null
                    this.Adres.eMail = null
    
                }
    
                // var a = this.kalemData.Rez.adresler.find(this.IsimSiraBul);
                // var b = this.kalemData.Rez.adresler.find(this.IsimBul);
                // var c = this.kalemData.Rez.adresler.find(this.IsimIdBul);
    
                // if (this.Adres.adSoyad !== "") {
                //   if (c !== undefined) {
                //     var sira = c.kisiSira;
                //     this.Adres.kisiSira = sira;
                //     Object.assign(this.kalemData.Rez.adresler[sira], this.Adres);
                //     this.Adres = kalemData.Rez.Adres();
                //   } else if (
                //     this.kalemData.Rez.adresler.length == 0 ||
                //     (this.Adres.kisiSira == -1 && b == undefined)
                //   ) {
                //     this.Adres.kisiSira = this.kalemData.Rez.adresler.length;
                //     this.kalemData.Rez.adresler.push(Object.assign({}, this.Adres));
                //     this.Adres = kalemData.Rez.Adres();
                //   } else if (a !== undefined && b == undefined) {
                //     var sira = this.Adres.kisiSira;
                //     Object.assign(this.kalemData.Rez.adresler[sira], this.Adres);
                //     this.Adres = kalemData.Rez.Adres();
                //   } else {
                //     this.mesajGoster(this.$t('Similar-names-cannot-entered'));
                //   }
                // } else {
                //   this.mesajGoster(this.$t('You-need-to-enter-name'));
                // }
            },
    
            SonrakiSayfa(v) {
                if (v == this.step.onKayit) {
                    if (this.$refs.formOnKayit.validate()) {
                        this.steppervmodel = this.step.kisiBilgileri;
                    } else {
                        this.text1 = this.$t('Please-fill-required-fields')
                        this.snackbar = true
                    }
                }
                if (v == this.step.kisiBilgileri) {
                    if (this.kalemData.Rez.adresler.length > 0) {
                        this.steppervmodel = this.step.rezKalemleri;
                    } else {
                        this.text1 = this.$t('Please-add-person-the-list');
                        this.snackbar = true
                    }
                }
                if (v == this.step.rezKalemleri) {
                    if (this.kalemData.Rez.kalemler.length == 0) {
                        this.text1 = "Lütfen listeye rezervasyon kalemi ekleyiniz."
                        this.snackbar = true
                    } else {
                        
                        // this.steppervmodel = this.step.tahsilat;
                        this.rezervasyonKaydet(this.step.tahsilat, this.kalemData.Rez);
    
                    }
    
                }
                if (v == this.step.tahsilat) {
                    this.steppervmodel = this.step.dokumanlar;
                }
                if (v == this.step.dokumanlar) {
                    this.steppervmodel = this.step.onKayit;
                }
            },
    
            OncekiSayfa(v) {
    
                if (v == this.step.onKayit) {
                    this.steppervmodel = this.steppervmodel;
                } else if (v == this.step.kisiBilgileri) {
                    this.steppervmodel = this.step.onKayit;
                } else if (v == this.step.rezKalemleri) {
                    this.steppervmodel = this.step.kisiBilgileri;
                } else if (v == this.step.tahsilat) {
                    this.mountedShortcut();
                    this.steppervmodel = this.step.rezKalemleri;
                } else if (v == this.step.dokumanlar) {
                    this.steppervmodel = this.step.tahsilat;
                }
            },
    
            stepperShow() {
                if (this.steppervmodel == this.step.tahsilat) {
    
                }
            },
            faturanotarihdegistir(tur) {
                //tur 0 ise faturatarih 1 ise tarih
    
                this.dialogdegistir = true;
                if (tur == 0) {
                    this.islemturu = 0;
                    this.ChangeFaturaNo = this.SerbestFatura.FaturaNo
                    this.ChangeTarih = null
                } else if (tur == 1) {
                    this.ChangeTarih = this.SerbestFatura.Tarih
                    this.ChangeFaturaNo = null
                    this.islemturu = 1;
                }
    
            },
            dizayngetir() {
                var credentials = JSON.parse(window.localStorage.getItem('credentials'));
                var params = {
                    SirketKodu: credentials.SirketKodu,
                    FaturaTip: 'S',
                    DovizliFatura: false,
                    HatTipi: false,
                    TumFiltre: true
                }
    
                this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceMainTableList', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.dizaynsec = response.body
                }, (response) => {
                    if (response.status === 0) {
                        this.progress = false
                        this.text1 = 'Service Unavailable-InvoiceXsltTableList'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable-InvoiceXsltTableList'
                        this.snackbar = true
                    }
                })
    
            },
            Yazdir() {
                this.dizaynbilgigetir(this.SerbestFatura.EFaturaShowID.DizaynID);
    
                if (this.SerbestFatura.EFaturaShowID.PdfID != 0) {
                    var prm = {
                        id: this.SerbestFatura.EFaturaShowID.EFaturaID,
                        guid: this.SerbestFatura.EFaturaShowID.EFaturaGuid
                    };
                    this.$refs.reportbrosablon.Print(prm, this.SerbestFatura.EFaturaShowID.PdfID).then(
                        confirm => {
    
                        },
                        confirm => {
    
                        }
                    );
                } else {
                    this.text1 = this.$t('design-you-selected-does-include-invoice-present-design-Invoice-screen')
                    this.snackbar = true
                }
            },
            xsltgetir() {
                var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    
                var paramsxslt = {
                    CompanyCode: credentials.SirketKodu,
    
                }
                this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceXsltTableList', paramsxslt, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.xsltitems = response.body
    
                    this.SerbestFatura.EFaturaShowID.XsltID = this.xsltIdget;
    
                }, (response) => {
                    if (response.status === 0) {
                        this.progress = false
                        this.text1 = 'Service Unavailable-InvoiceXsltTableList'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable-InvoiceXsltTableList'
                        this.snackbar = true
                    }
                })
    
            },
            dizaynbilgigetir(Faturaid) {
                this.dizaynsec.forEach(element => {
                    if (element.FaturaId == Faturaid) {
                        this.SerbestFatura.EFaturaShowID.XsltID = element.FaturaXsltId
                        this.SerbestFatura.EFaturaShowID.PdfID = element.FaturaPdfID
                    }
                });
            },
    
            cariislemler() {
    
                var credentials = JSON.parse(window.localStorage.getItem('credentials'))
                var params = {
                    Code: this.SerbestFatura.Cari.Kod,
                    CompanyCode: credentials.SirketKodu
                }
    
                this.$http.post(auth.API_URL + 'api/Current/Get', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.unvan = response.body.Title
    
                    if (response.body.CreditLimit == null || response.body.CreditLimit == '') {
    
                        this.kredilimiti = parseFloat(0).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
                                '$1,') +
                            ' ₺'
                    } else {
                        this.kredilimiti = parseFloat(response.body.CreditLimit).toFixed(2).replace(
                                /(\d)(?=(\d{3})+\.)/g,
                                '$1,') +
                            ' ₺'
                    }
    
                    this.SerbestFatura.EFaturaBilgi.Unvani = response.body.Title
                    this.SerbestFatura.EFaturaBilgi.Adres1 = response.body.Invoice.Address
                    this.SerbestFatura.EFaturaBilgi.IlceSehir = response.body.Invoice.Province
                    this.SerbestFatura.EFaturaBilgi.Email = response.body.Email
                    this.SerbestFatura.EFaturaBilgi.VergiDairesi = response.body.Invoice.TaxOffice
                    this.SerbestFatura.EFaturaBilgi.VergiNo = response.body.Invoice.TaxNumber
                    this.SerbestFatura.EFaturaBilgi.TcKimlikNo = response.body.Invoice
                        .IdentityNumber
                    this.SerbestFatura.EFaturaBilgi.Adi = response.body.Invoice.PerFirstName
                    this.SerbestFatura.EFaturaBilgi.Soyadi = response.body.Invoice.PerFamilyName
                    this.SerbestFatura.EFaturaBilgi.TUnvani = response.body.Invoice.PerTitle
                    this.SerbestFatura.EFaturaBilgi.DigerAdi = response.body.Invoice.PerMiddleName
                    this.SerbestFatura.EFaturaBilgi.OnAdiEki = response.body.Invoice.PerNameSuffix
    
                    this.efaturatipigecici = String(response.body.EInvoiceType);
    
                    //ana sirket e faturacı değilse kağıt fatura
                    if (credentials.EFatura != '1') {
    
                        this.SerbestFatura.Efaturakayit = false
                        this.SerbestFatura.Earchiveakayit = false
                        this.SerbestFatura.KagitFatura = true
                    }
    
                    if (credentials.EFatura == '1' && response.body.EInvoiceCustomer == '1') {
                        // ana sirket efatura cari efatura o zaman efaturacı
                        this.SerbestFatura.Efaturakayit = true
                        this.SerbestFatura.Earchiveakayit = false
                        this.SerbestFatura.KagitFatura = false
    
                    }
    
                    if (credentials.EFatura == '1' && response.body.EInvoiceCustomer == '0') {
                        if (credentials.EArsiv == '1') {
                            //anasirket efatura cari earsiv  o zaman earşivci
                            this.SerbestFatura.Earchiveakayit = true
                            this.SerbestFatura.Efaturakayit = false
                            this.SerbestFatura.KagitFatura = false
                        } else {
                            this.SerbestFatura.Earchiveakayit = false
                            this.SerbestFatura.Efaturakayit = false
                            this.SerbestFatura.KagitFatura = true
                        }
                    }
    
                    var params1 = {
                        CompanyCode: credentials.SirketKodu,
                    }
    
                    if (this.SerbestFatura.Efaturakayit == true) {
    
                        if (this.$route.query.islem != "yenigelenevrak" && this.$route.query
                            .islem !=
                            "gelenevrak") {
                            this.gibserigoster = true;
                        }
    
                    } else if (this.SerbestFatura.Earchiveakayit == true) {
    
                        if (this.$route.query.islem != "yenigelenevrak" && this.$route.query
                            .islem !=
                            "gelenevrak") {
                            this.gibserigoster = true;
                        }
    
                    } else if (this.SerbestFatura.KagitFatura == true) {
                        this.gibserigoster = false;
                    }
    
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = response.body.ResponseMessage
                        this.snackbar = true
                    } else {
                        this.text1 = response.statusText
                        this.snackbar = true
                    }
                })
    
            },
            guncelle: guncelle,
            ekle: ekle,
            toDateformat: toDateformat,
    
            //coper
            pnrchange,
            rezervasyonKaydet,
            rezervasyonKaydetTekrar,
            profil: profil,
            musteripersonel: musteripersonel,
        },
        beforeMount: beforeMount,
        components: {
            'parainput': parainput,
            'dovizinput': dovizinput,
            'yuzdeinput': yuzdeinput,
            'tarihcomp': tarihcomp,
            referansmerkezicomp,
            masrafmerkezicomp,
            reportbrosablon,
            geneltiplist,
            yetkidialog,
            kisitip,
            anatip,
            geneltipara,
            pnraracomp,
            cariara,
            genelarama,
            odeme,
            pnrara,
            caricomp,
            kalemotel,
            kalemarac,
            kalemdiger,
            kalemrentacar,
            kalemvize,
            kalemsigorta,
            kalemrestaurant,
            kalemgemi,
            kalemrehber,
            kalemgunluktur,
            kalemcharter,
            loadingcomp,
            tahsilatdialog,
            onaydialog,
            onaydialogchk,
            kalemdokumanlar,
            kisiadresara,
            hatadialog,
            paxdriveeditdialog,
            pnrbul,
            profildialog,
            musteripersoneldialog,
            snackbarcomp,
           
        },
        watch: {
    
            'adresDialogData.adres': function (val) {
    
                this.Adres = this.adresDialogData.adres
            },
            'kalemData.Rez.opsiyonluMusteri': function (val) {
                if (val == false) {
                    this.kalemData.Rez.opsiyonTarihi = null
                    this.kalemData.Rez.opsiyonSaati = null
                }
            },
            'kalemData.aktif': function (val) {
                if (val == false) {
                    this.kalemData.islem = "new"
    
                    this.kalemTemizle();
                    this.iconrezervasyon = 2
                    this.allrezlist = true
                    this.minrezlist = false
                }
            },
            'iconrezervasyon': function (val) {
    
                // Otel = 1,
                // Arac = 2,
                // Restaurant = 3,
                // Acente = 4,
                // RentACar = 5,
                // Rehber = 6,
                // Muze = 7,
                // Charter = 8,
                // Gemi = 9,
                // Diger = 10,
                // Vize = 11,
                // TurOperatoru = 12,
                // //Konsolosluk = 13,
                // Sigorta = 14,
                // Feribot = 15,
    
                this.fab = false
    
                if (val == undefined) {
                    this.allrezlist = true
                    this.minrezlist = false
                } else {
    
                    this.kalemData.aktif = true
    
                    this.kalemData.Kisiler = this.kalemData.Rez.adresler
    
                    if (val == 'tab-1') {
                        this.allrezlist = false
                        this.minrezlist = true
                        this.rezbaslik = 'Otel Bilgileri'
                        this.rezicon = 'hotel'
    
                        if (this.kalemData.islem != 'edit') {
                            this.kalemData.kalem.donem2 = helpers.adddays(1);
                        }
    
                        this.kalemData.kalem.saticiTip = 1
    
                    } else if (val == 'tab-2') {
                        this.rezbaslik = 'Transfer Bilgileri'
                        this.kalemData.kalem.saticiTip = 2
                        this.allrezlist = false
                        this.minrezlist = true
                        this.rezicon = 'rv_hookup'
    
                    } else if (val == 'tab-3') {
                        this.rezbaslik = 'Restaurant Bilgileri'
                        this.kalemData.kalem.saticiTip = 3
                        this.allrezlist = false
                        this.minrezlist = true
                        this.rezicon = 'restaurant'
                    } else if (val == 'tab-4') {
                        this.rezbaslik = 'Günlük Tur Bilgileri'
                        this.kalemData.kalem.saticiTip = 4
                        this.allrezlist = false
                        this.minrezlist = true
                        this.rezicon = 'local_see'
                    } else if (val == 'tab-5') {
    
                        if (this.kalemData.islem != 'edit') {
                            this.kalemData.kalem.kalemRentACar.teslimTarihi = helpers.adddays(1);
                            this.kalemData.kalem.kalemRentACar.teslimSaat = helpers.getTimeNow()
                            this.kalemData.kalem.kalemRentACar.alisSaat = helpers.getTimeNow()
                        }
    
                        this.rezbaslik = 'Rent A Car Bilgileri'
                        this.kalemData.kalem.saticiTip = 5
                        this.allrezlist = false
                        this.minrezlist = true
                        this.rezicon = 'departure_board'
                    } else if (val == 'tab-6') {
    
                        if (this.kalemData.islem != 'edit') {
                            //  this.kalemData.kalem.kalemRentACar.teslimTarihi = helpers.adddays(1);
                            //  this.kalemData.kalem.kalemRentACar.teslimSaat = helpers.getTimeNow()
                            // this.kalemData.kalem.kalemRentACar.alisSaat = helpers.getTimeNow()
                        }
    
                        this.rezbaslik = 'Rehber Bilgileri'
                        this.kalemData.kalem.saticiTip = 6
                        this.allrezlist = false
                        this.minrezlist = true
                        this.rezicon = 'emoji_people'
                    } else if (val == 'tab-8') {
                        this.rezbaslik = 'Havayolu Bilgileri'
                        this.kalemData.kalem.saticiTip = 8
                        this.allrezlist = false
                        this.minrezlist = true
                        this.rezicon = 'flight_takeoff'
                    } else if (val == 'tab-9') {
                        this.rezbaslik = 'Gemi Bilgileri'
                        this.kalemData.kalem.saticiTip = 9
                        this.allrezlist = false
                        this.minrezlist = true
                        this.rezicon = 'directions_boat'
    
                    } else if (val == 'tab-10') {
                        this.rezbaslik = this.$t('Other-Details')
                        this.kalemData.kalem.saticiTip = 10
                        this.allrezlist = false
                        this.minrezlist = true
                        this.rezicon = 'category'
    
                    } else if (val == 'tab-14') {
                        this.rezbaslik = 'Sigorta Bilgileri'
                        this.kalemData.kalem.saticiTip = 14
                        this.allrezlist = false
                        this.minrezlist = true
                        this.rezicon = 'verified_user'
                    } else if (val == 'tab-12') {
                        this.rezbaslik = 'Vize Bilgileri'
                        this.kalemData.kalem.saticiTip = 11
                        this.allrezlist = false
                        this.minrezlist = true
                        this.rezicon = 'style'
                    } else {
                        this.allrezlist = true
                        this.minrezlist = false
                    }
                }
    
            }
    
        }
    }
    
    function profil(kalem) {
        this.$refs.profildialog
            .open(kalem.profilId, {
                color: "red"
            })
            .then(profildialog => {
                if (profildialog.ok) {
                    kalem.profilId = profildialog.id;
                }
            });
    }
    
    function musteripersonel(kalem) {
        this.$refs.musteripersoneldialog
            .open(kalem.sicilId, {
                color: "red"
            })
            .then(musteripersoneldialog => {
                if (musteripersoneldialog.ok) {
                    kalem.sicilId = musteripersoneldialog.id;
                }
            });
    }
    
    function rezervasyonKaydetTekrar(sayfa, reze) {
    
    this.rezControl += 1;
    if(this.rezControl == 1){
    
    
    this.loadingvmodel = true
    
    let arrayCopy = JSON.parse(JSON.stringify(this.kalemData.Rez)); // create TRUE copy
    console.log(this.kalemData.Rez);
    //ACente komisyon doviz tutari 0 ise class null gonderiliyor
    arrayCopy.kalemler.forEach(element => {
            if(element.acenteKomisyon != null){
                if(element.acenteKomisyon.DovizTutar == 0){
                    element.acenteKomisyon = null;
                }
            }
    });
    
    
    let params = {
        Rezervasyon: arrayCopy
    }
    tool.http_post(this, "MiceSave", params).then(response => {
    
            if (response.body.Status == true) {
                this.kalemData.Rez = response.body.data;
                this.steppervmodel = sayfa;
                this.loadingvmodel = false
                this.text1 = 'işlem tamamlandı';
                this.snackbar = true;
                window.localStorage.removeItem('hrrezervasyon')
                this.rezControl = 0;
    
            } else {
                this.text1 = response.body.ErrorList[0];
                this.snackbar = true;
                this.loadingvmodel = false
                this.rezControl = 0;
    
               
                if (this.kalemData.Rez.pNR_No != null && this.kalemData.Rez.pNR_No != '' && this
                    .kalemData.Rez
                    .pNR_No >0)
                     {
    
                    setTimeout(function () {
                        this.steppervmodel = sayfa;
    
                    }.bind(this), 5000)
    
                }
    
            }
        },
        response => {
            this.rezControl = 0;
            this.HataYonetimi(response, params, 'Rezervasyon Kaydedilemedi');
        }
    );
    }
    }
    
    function rezervasyonKaydet(sayfa, reze) {
    
    this.rezControl += 1;
    if(this.rezControl == 1){
    
    
    this.loadingvmodel = true
    
    let arrayCopy = JSON.parse(JSON.stringify(this.kalemData.Rez)); // create TRUE copy
    
    //ACente komisyon doviz tutari 0 ise class null gonderiliyor
    arrayCopy.kalemler.forEach(element => {
            if(element.acenteKomisyon != null){
                if(element.acenteKomisyon.DovizTutar == 0){
                    element.acenteKomisyon = null;
                }
            }
    });
    
    
    let params = {
        Rezervasyon: arrayCopy
    }
    tool.http_post(this, "MiceSave", params).then(response => {
    
            if (response.body.Status == true) {
                this.kalemData.Rez = response.body.data;
                this.steppervmodel = sayfa;
                this.loadingvmodel = false
                this.text1 = 'işlem tamamlandı';
                this.snackbar = true;
                window.localStorage.removeItem('hrrezervasyon')
                this.rezControl = 0;
    
            } else { 
                    if (response.body.ErrorList[0].includes('zaten yapılmış'))
                    {
                        this.$refs.onaydialogchk.open(response.body.ErrorList[0].replace('Hata','Uyarı'), 1,'Aynı kişi ve tarih için daha önce kayıtlı rezervasyon kaydı bulundu;','Aynı kişi ile işleme devam edilsin','İşlem İptal Edilsin ').then(
                    sonuc => {
    
                        if (sonuc == true) {
                            
                            this.kalemData.Rez.MisafirIsmiKontrolEdilmesin=true;
                            this.rezControl = 0;
                            this.rezervasyonKaydetTekrar(sayfa, reze);
                            return;
    
                        }
                        else
                        {
                            this.rezControl = 0;
                            this.loadingvmodel = false
                            return;
                        }
                    });
                    }
                    else
                    {
                        this.text1 = response.body.ErrorList[0];
                this.snackbar = true;
                this.loadingvmodel = false
                this.rezControl = 0;
    
               
                if (this.kalemData.Rez.TakipNo != null && this.kalemData.Rez.TakipNo != '' && this
                    .kalemData.Rez
                    .TakipNo >0)
                     {
    
                    setTimeout(function () {
                        this.steppervmodel = sayfa;
    
                    }.bind(this), 5000)
    
                }
                    }
               
    
            }
        },
        response => {
            if (this.rezControl==1)
            {
                this.rezControl = 0;
                this.HataYonetimi(response, params, 'Rezervasyon Kaydedilemedi');
            }
           
        }
               
    );
    }
    }
    
    // function rezervasyonKaydet(sayfa, reze) {
    
    //     this.rezControl += 1;
    //     if(this.rezControl == 1){
    
        
    //     this.loadingvmodel = true
    
    //     let arrayCopy = JSON.parse(JSON.stringify(this.kalemData.Rez)); // create TRUE copy
    
    //     //ACente komisyon doviz tutari 0 ise class null gonderiliyor
    //     arrayCopy.kalemler.forEach(element => {
    //             if(element.acenteKomisyon != null){
    //                 if(element.acenteKomisyon.DovizTutar == 0){
    //                     element.acenteKomisyon = null;
    //                 }
    //             }
    //     });
        
    
    //     let params = {
    //         Rezervasyon: arrayCopy
    //     }
    //     tool.http_post(this, "RezervasyonKaydet", params).then(response => {
    
    //             if (response.body.Status == true) {
    //                 this.kalemData.Rez = response.body.data;
    //                 this.steppervmodel = sayfa;
    //                 this.loadingvmodel = false
    //                 this.text1 = 'işlem tamamlandı';
    //                 this.snackbar = true;
    //                 window.localStorage.removeItem('hrrezervasyon')
    //                 this.rezControl = 0;
    
    //             } else {
    
    //                 if (response.body.ErrorList[0].includes('zaten yapılmış'))
    //                 {
    //                     this.$refs.onaydialog.open(response.body.ErrorList[0] + ' ' + 'PNR No Daha Önce Kayıt Edilmiş? Aynı Numarayı Tekrar Kullanmak İstiyor musunuz.?', 1).then(
    //                 sonuc => {
    
    //                     if (sonuc == true) {
    //                         console.log('gidiyom');
    //                         this.kalemData.Rez.MisafirIsmiKontrolEdilmesin=true;
    //                         this.rezervasyonKaydetTekrar(sayfa, reze);
    //                         return;
    
    //                     }
    //                     else
    //                     {
    //                         return;
    //                     }
    //                 });
    //                 }
    //                 else
    //                 {
    //                      this.text1 = response.body.ErrorList[0];
    //                      this.snackbar = true;
    //                      this.loadingvmodel = false
    //                      this.rezControl = 0;
    //                      if (this.kalemData.Rez.pNR_No != null && this.kalemData.Rez.pNR_No != '' && this
    //     .kalemData.Rez
    //     .pNR_No >0)
    //      {
           
    //     setTimeout(function () {
    //         this.steppervmodel = sayfa;
    
    //     }.bind(this), 5000)
    
    // }
    //                 }
    
                    
    
    
    
    
    
    // }
    // },
    // response => {
    // this.rezControl = 0;
    // this.HataYonetimi(response, params, 'Rezervasyon Kaydedilemedi');
    // }
    // );      
    // }
    // }
    
    function beforeMount() {}
    
    function pnrchange(v) {
        if (v != 0) {
    
            this.status.loading = true;
    
            tool.http_post(this, "GetRezervasyon", {
                    Id: this.kalemData.Rez.pNR_No
                })
                .then(
                    response => {
                        if (response.body.pNR_No == 0) {
                            this.Rez = this.kalemData.Rez.Rezervasyon();
                            this.status.text = "PNR bulunamadı";
                            this.status.show = true;
                        } else {
                            this.Rez = response.body;
                            this.toplam = response.body.toplamTL;
                            //this.status.text = "PNR bilgisi getirildi";
                        }
                        this.status.loading = false;
                    },
                    response => {
                        this.status = tool.responseToStatus(response);
                        this.Rez = this.kalemData.Rez.Rezervasyon();
                    }
                );
        }
    }
    
    function toDateformat(dateStr) {
        var parts = dateStr.split("-");
        return (parts[2] + '.' + parts[1] + '.' + parts[0]);
    }
    
    function ekle() {
    
        this.Current.Contract.ContractDate = this.SerbestFatura.Tarih
    
        var current = this.Current
        this.$http.post(auth.API_URL + 'api/Current/New', current, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
            if (response.body.Status === true) {
                this.text1 = 'Kayıt Eklendi'
                this.snackbar = true
            } else if (response.body.Status === false) {
                this.text1 = 'Hata Oluştu'
                this.snackbar = true
            }
        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
            } else {
                
               let data ={
               response: response,
               request: current,
               api:'Current/New',
               type:2,
               message: response.body.ExceptionMessage
               };
               this.$refs.showMessage.open(data);
    
            }
        })
    }
    
    function guncelle() {
    
        this.$validator.validateAll().then((result) => {
            if (result) {
    
                this.Current.Contract.ContractDate = this.SerbestFatura.Tarih
                var current = this.Current
                this.$http.post(auth.API_URL + 'api/Current/Update', current, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    if (response.body.Status === true) {
                        this.text1 = 'Bilgiler Güncellendi'
                        this.snackbar = true
                    } else if (response.body.Status === false) {
                        this.text1 = 'Hata Oluştu'
                        this.snackbar = true
                    }
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = response.body.ResponseMessage
                        this.snackbar = true
                    } else {
                        this.text1 = response.body.ResponseMessage
                        this.snackbar = true
                    }
                })
            }
        })
    }
    </script>
    
    <style>
    #create .v-speed-dial {
        position: absolute;
    }
    
    #create .v-btn--floating {
        position: relative;
    }
    
    .outer {
    
        position: relative;
        display: inline-block;
        margin: 0 10px;
        padding-top: inherit+100px;
    
    }
    
    .inner {
        position: absolute;
        top: 104%;
        left: 50%;
        padding-block-start: 30px;
        padding-block-end: 10px;
    }
    
    .icorta {
        margin: 0px auto;
        height: 226px;
        color: #fff;
        position: absolute;
        left: 92%;
        top: 95%;
        margin-left: -110px;
        margin-top: -15px;
    }
    
    .rotate {
        -moz-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
        -webkit-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
        transform: translateX(-50%) translateY(-50%) rotate(-90deg);
    
    }
    </style>
    